!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("web3-eth")) : "function" == typeof define && define.amd ? define(["web3-eth"], e) : "object" == typeof exports ? exports.subspace = e(require("web3-eth")) : t.subspace = e(t["web3-eth"]);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 33);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _r = function r(t, e) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && (t[n] = e[n]);
        }
      })(t, e);
    };

    function i(t, e) {
      function n() {
        this.constructor = t;
      }

      _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    }
  }, function (t, e, n) {
    t.exports = n(28);
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return l;
    });

    var r = n(0),
        i = n(10),
        o = n(14),
        s = n(6),
        a = n(11),
        u = n(7),
        c = n(12),
        l = function (t) {
      function e(n, r, i) {
        var s = t.call(this) || this;

        switch (s.syncErrorValue = null, s.syncErrorThrown = !1, s.syncErrorThrowable = !1, s.isStopped = !1, arguments.length) {
          case 0:
            s.destination = o.a;
            break;

          case 1:
            if (!n) {
              s.destination = o.a;
              break;
            }

            if ("object" == typeof n) {
              n instanceof e ? (s.syncErrorThrowable = n.syncErrorThrowable, s.destination = n, n.add(s)) : (s.syncErrorThrowable = !0, s.destination = new h(s, n));
              break;
            }

          default:
            s.syncErrorThrowable = !0, s.destination = new h(s, n, r, i);
        }

        return s;
      }

      return r.a(e, t), e.prototype[a.a] = function () {
        return this;
      }, e.create = function (t, n, r) {
        var i = new e(t, n, r);
        return i.syncErrorThrowable = !1, i;
      }, e.prototype.next = function (t) {
        this.isStopped || this._next(t);
      }, e.prototype.error = function (t) {
        this.isStopped || (this.isStopped = !0, this._error(t));
      }, e.prototype.complete = function () {
        this.isStopped || (this.isStopped = !0, this._complete());
      }, e.prototype.unsubscribe = function () {
        this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this));
      }, e.prototype._next = function (t) {
        this.destination.next(t);
      }, e.prototype._error = function (t) {
        this.destination.error(t), this.unsubscribe();
      }, e.prototype._complete = function () {
        this.destination.complete(), this.unsubscribe();
      }, e.prototype._unsubscribeAndRecycle = function () {
        var t = this._parentOrParents;
        return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = t, this;
      }, e;
    }(s.a),
        h = function (t) {
      function e(e, n, r, s) {
        var a,
            u = t.call(this) || this;
        u._parentSubscriber = e;
        var c = u;
        return Object(i.a)(n) ? a = n : n && (a = n.next, r = n.error, s = n.complete, n !== o.a && (c = Object.create(n), Object(i.a)(c.unsubscribe) && u.add(c.unsubscribe.bind(c)), c.unsubscribe = u.unsubscribe.bind(u))), u._context = c, u._next = a, u._error = r, u._complete = s, u;
      }

      return r.a(e, t), e.prototype.next = function (t) {
        if (!this.isStopped && this._next) {
          var e = this._parentSubscriber;
          u.a.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable ? this.__tryOrSetError(e, this._next, t) && this.unsubscribe() : this.__tryOrUnsub(this._next, t);
        }
      }, e.prototype.error = function (t) {
        if (!this.isStopped) {
          var e = this._parentSubscriber,
              n = u.a.useDeprecatedSynchronousErrorHandling;
          if (this._error) n && e.syncErrorThrowable ? (this.__tryOrSetError(e, this._error, t), this.unsubscribe()) : (this.__tryOrUnsub(this._error, t), this.unsubscribe());else if (e.syncErrorThrowable) n ? (e.syncErrorValue = t, e.syncErrorThrown = !0) : Object(c.a)(t), this.unsubscribe();else {
            if (this.unsubscribe(), n) throw t;
            Object(c.a)(t);
          }
        }
      }, e.prototype.complete = function () {
        var t = this;

        if (!this.isStopped) {
          var e = this._parentSubscriber;

          if (this._complete) {
            var n = function n() {
              return t._complete.call(t._context);
            };

            u.a.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable ? (this.__tryOrSetError(e, n), this.unsubscribe()) : (this.__tryOrUnsub(n), this.unsubscribe());
          } else this.unsubscribe();
        }
      }, e.prototype.__tryOrUnsub = function (t, e) {
        try {
          t.call(this._context, e);
        } catch (t) {
          if (this.unsubscribe(), u.a.useDeprecatedSynchronousErrorHandling) throw t;
          Object(c.a)(t);
        }
      }, e.prototype.__tryOrSetError = function (t, e, n) {
        if (!u.a.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");

        try {
          e.call(this._context, n);
        } catch (e) {
          return u.a.useDeprecatedSynchronousErrorHandling ? (t.syncErrorValue = e, t.syncErrorThrown = !0, !0) : (Object(c.a)(e), !0);
        }

        return !1;
      }, e.prototype._unsubscribe = function () {
        var t = this._parentSubscriber;
        this._context = null, this._parentSubscriber = null, t.unsubscribe();
      }, e;
    }(l);
  }, function (t, e, n) {
    "use strict";

    var r = n(2);
    var i = n(11),
        o = n(14);

    var s = function () {
      return "function" == typeof Symbol && Symbol.observable || "@@observable";
    }(),
        a = n(26),
        u = n(7);

    n.d(e, "a", function () {
      return c;
    });

    var c = function () {
      function t(t) {
        this._isScalar = !1, t && (this._subscribe = t);
      }

      return t.prototype.lift = function (e) {
        var n = new t();
        return n.source = this, n.operator = e, n;
      }, t.prototype.subscribe = function (t, e, n) {
        var s = this.operator,
            a = function (t, e, n) {
          if (t) {
            if (t instanceof r.a) return t;
            if (t[i.a]) return t[i.a]();
          }

          return t || e || n ? new r.a(t, e, n) : new r.a(o.a);
        }(t, e, n);

        if (s ? a.add(s.call(a, this.source)) : a.add(this.source || u.a.useDeprecatedSynchronousErrorHandling && !a.syncErrorThrowable ? this._subscribe(a) : this._trySubscribe(a)), u.a.useDeprecatedSynchronousErrorHandling && a.syncErrorThrowable && (a.syncErrorThrowable = !1, a.syncErrorThrown)) throw a.syncErrorValue;
        return a;
      }, t.prototype._trySubscribe = function (t) {
        try {
          return this._subscribe(t);
        } catch (e) {
          u.a.useDeprecatedSynchronousErrorHandling && (t.syncErrorThrown = !0, t.syncErrorValue = e), !function (t) {
            for (; t;) {
              var e = t,
                  n = e.closed,
                  i = e.destination,
                  o = e.isStopped;
              if (n || o) return !1;
              t = i && i instanceof r.a ? i : null;
            }

            return !0;
          }(t) ? console.warn(e) : t.error(e);
        }
      }, t.prototype.forEach = function (t, e) {
        var n = this;
        return new (e = l(e))(function (e, r) {
          var i;
          i = n.subscribe(function (e) {
            try {
              t(e);
            } catch (t) {
              r(t), i && i.unsubscribe();
            }
          }, r, e);
        });
      }, t.prototype._subscribe = function (t) {
        var e = this.source;
        return e && e.subscribe(t);
      }, t.prototype[s] = function () {
        return this;
      }, t.prototype.pipe = function () {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t[e] = arguments[e];
        }

        return 0 === t.length ? this : Object(a.b)(t)(this);
      }, t.prototype.toPromise = function (t) {
        var e = this;
        return new (t = l(t))(function (t, n) {
          var r;
          e.subscribe(function (t) {
            return r = t;
          }, function (t) {
            return n(t);
          }, function () {
            return t(r);
          });
        });
      }, t.create = function (e) {
        return new t(e);
      }, t;
    }();

    function l(t) {
      if (t || (t = u.a.Promise || Promise), !t) throw new Error("no Promise impl found");
      return t;
    }
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    t.exports = function (t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(16);

    var i = n(10),
        o = function () {
      function t(t) {
        return Error.call(this), this.message = t ? t.length + " errors occurred during unsubscription:\n" + t.map(function (t, e) {
          return e + 1 + ") " + t.toString();
        }).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = t, this;
      }

      return t.prototype = Object.create(Error.prototype), t;
    }();

    n.d(e, "a", function () {
      return s;
    });

    var s = function () {
      function t(t) {
        this.closed = !1, this._parentOrParents = null, this._subscriptions = null, t && (this._unsubscribe = t);
      }

      var e;
      return t.prototype.unsubscribe = function () {
        var e;

        if (!this.closed) {
          var n,
              s = this._parentOrParents,
              u = this._unsubscribe,
              c = this._subscriptions;
          if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, s instanceof t) s.remove(this);else if (null !== s) for (var l = 0; l < s.length; ++l) {
            s[l].remove(this);
          }
          if (Object(i.a)(u)) try {
            u.call(this);
          } catch (t) {
            e = t instanceof o ? a(t.errors) : [t];
          }

          if (Object(r.a)(c)) {
            l = -1;

            for (var h = c.length; ++l < h;) {
              var f = c[l];
              if (null !== (n = f) && "object" == typeof n) try {
                f.unsubscribe();
              } catch (t) {
                e = e || [], t instanceof o ? e = e.concat(a(t.errors)) : e.push(t);
              }
            }
          }

          if (e) throw new o(e);
        }
      }, t.prototype.add = function (e) {
        var n = e;
        if (!e) return t.EMPTY;

        switch (typeof e) {
          case "function":
            n = new t(e);

          case "object":
            if (n === this || n.closed || "function" != typeof n.unsubscribe) return n;
            if (this.closed) return n.unsubscribe(), n;

            if (!(n instanceof t)) {
              var r = n;
              (n = new t())._subscriptions = [r];
            }

            break;

          default:
            throw new Error("unrecognized teardown " + e + " added to Subscription.");
        }

        var i = n._parentOrParents;
        if (null === i) n._parentOrParents = this;else if (i instanceof t) {
          if (i === this) return n;
          n._parentOrParents = [i, this];
        } else {
          if (-1 !== i.indexOf(this)) return n;
          i.push(this);
        }
        var o = this._subscriptions;
        return null === o ? this._subscriptions = [n] : o.push(n), n;
      }, t.prototype.remove = function (t) {
        var e = this._subscriptions;

        if (e) {
          var n = e.indexOf(t);
          -1 !== n && e.splice(n, 1);
        }
      }, t.EMPTY = ((e = new t()).closed = !0, e), t;
    }();

    function a(t) {
      return t.reduce(function (t, e) {
        return t.concat(e instanceof o ? e.errors : e);
      }, []);
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = !1,
        i = {
      Promise: void 0,

      set useDeprecatedSynchronousErrorHandling(t) {
        t && new Error().stack;
        r = t;
      },

      get useDeprecatedSynchronousErrorHandling() {
        return r;
      }

    };
  }, function (t, e) {
    function n(t, e, n, r, i, o, s) {
      try {
        var a = t[o](s),
            u = a.value;
      } catch (t) {
        return void n(t);
      }

      a.done ? e(u) : Promise.resolve(u).then(r, i);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (i, o) {
          var s = t.apply(e, r);

          function a(t) {
            n(s, i, o, a, u, "next", t);
          }

          function u(t) {
            n(s, i, o, a, u, "throw", t);
          }

          a(void 0);
        });
      };
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return "function" == typeof t;
    }

    n.d(e, "a", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });

    var r = function () {
      return "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
    }();
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      setTimeout(function () {
        throw t;
      }, 0);
    }

    n.d(e, "a", function () {
      return r;
    });
  }, function (t, e, n) {
    var r;

    t.exports = function t(e, n, i) {
      function o(a, u) {
        if (!n[a]) {
          if (!e[a]) {
            if (!u && "function" == typeof r && r) return r(a, !0);
            if (s) return s(a, !0);
            throw new Error("Cannot find module '" + a + "'");
          }

          var c = n[a] = {
            exports: {}
          };
          e[a][0].call(c.exports, function (t) {
            var n = e[a][1][t];
            return o(n || t);
          }, c, c.exports, t, e, n, i);
        }

        return n[a].exports;
      }

      for (var s = "function" == typeof r && r, a = 0; a < i.length; a++) {
        o(i[a]);
      }

      return o;
    }({
      1: [function (t, e, n) {
        (function (r, i, o, s, a, u, c, l, h) {
          "use strict";

          function f(t, e) {
            return function (t, e) {
              var n;
              if (void 0 === (n = "passthrough" !== e.algorithm ? b.createHash(e.algorithm) : new v()).write && (n.write = n.update, n.end = n.update), y(e, n).dispatch(t), n.update || n.end(""), n.digest) return n.digest("buffer" === e.encoding ? void 0 : e.encoding);
              var r = n.read();
              return "buffer" === e.encoding ? r : r.toString(e.encoding);
            }(t, e = p(t, e));
          }

          function p(t, e) {
            if ((e = e || {}).algorithm = e.algorithm || "sha1", e.encoding = e.encoding || "hex", e.excludeValues = !!e.excludeValues, e.algorithm = e.algorithm.toLowerCase(), e.encoding = e.encoding.toLowerCase(), e.ignoreUnknown = !0 === e.ignoreUnknown, e.respectType = !1 !== e.respectType, e.respectFunctionNames = !1 !== e.respectFunctionNames, e.respectFunctionProperties = !1 !== e.respectFunctionProperties, e.unorderedArrays = !0 === e.unorderedArrays, e.unorderedSets = !1 !== e.unorderedSets, e.unorderedObjects = !1 !== e.unorderedObjects, e.replacer = e.replacer || void 0, e.excludeKeys = e.excludeKeys || void 0, void 0 === t) throw new Error("Object argument required.");

            for (var n = 0; n < g.length; ++n) {
              g[n].toLowerCase() === e.algorithm.toLowerCase() && (e.algorithm = g[n]);
            }

            if (-1 === g.indexOf(e.algorithm)) throw new Error('Algorithm "' + e.algorithm + '"  not supported. supported values: ' + g.join(", "));
            if (-1 === m.indexOf(e.encoding) && "passthrough" !== e.algorithm) throw new Error('Encoding "' + e.encoding + '"  not supported. supported values: ' + m.join(", "));
            return e;
          }

          function d(t) {
            return "function" == typeof t && null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(t));
          }

          function y(t, e, n) {
            n = n || [];

            var r = function r(t) {
              return e.update ? e.update(t, "utf8") : e.write(t, "utf8");
            };

            return {
              dispatch: function dispatch(e) {
                t.replacer && (e = t.replacer(e));
                var n = typeof e;
                return null === e && (n = "null"), this["_" + n](e);
              },
              _object: function _object(e) {
                var i,
                    s = Object.prototype.toString.call(e),
                    a = /\[object (.*)\]/i.exec(s);
                if (a = (a = a ? a[1] : "unknown:[" + s + "]").toLowerCase(), (i = n.indexOf(e)) >= 0) return this.dispatch("[CIRCULAR:" + i + "]");
                if (n.push(e), void 0 !== o && o.isBuffer && o.isBuffer(e)) return r("buffer:"), r(e);

                if ("object" === a || "function" === a) {
                  var u = Object.keys(e);
                  t.unorderedObjects && (u = u.sort()), !1 === t.respectType || d(e) || u.splice(0, 0, "prototype", "__proto__", "constructor"), t.excludeKeys && (u = u.filter(function (e) {
                    return !t.excludeKeys(e);
                  })), r("object:" + u.length + ":");
                  var c = this;
                  return u.forEach(function (n) {
                    c.dispatch(n), r(":"), t.excludeValues || c.dispatch(e[n]), r(",");
                  });
                }

                if (!this["_" + a]) {
                  if (t.ignoreUnknown) return r("[" + a + "]");
                  throw new Error('Unknown object type "' + a + '"');
                }

                this["_" + a](e);
              },
              _array: function _array(e, i) {
                i = void 0 !== i ? i : !1 !== t.unorderedArrays;
                var o = this;
                if (r("array:" + e.length + ":"), !i || e.length <= 1) return e.forEach(function (t) {
                  return o.dispatch(t);
                });
                var s = [],
                    a = e.map(function (e) {
                  var r = new v(),
                      i = n.slice();
                  return y(t, r, i).dispatch(e), s = s.concat(i.slice(n.length)), r.read().toString();
                });
                return n = n.concat(s), a.sort(), this._array(a, !1);
              },
              _date: function _date(t) {
                return r("date:" + t.toJSON());
              },
              _symbol: function _symbol(t) {
                return r("symbol:" + t.toString());
              },
              _error: function _error(t) {
                return r("error:" + t.toString());
              },
              _boolean: function _boolean(t) {
                return r("bool:" + t.toString());
              },
              _string: function _string(t) {
                r("string:" + t.length + ":"), r(t.toString());
              },
              _function: function _function(e) {
                r("fn:"), d(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== t.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), t.respectFunctionProperties && this._object(e);
              },
              _number: function _number(t) {
                return r("number:" + t.toString());
              },
              _xml: function _xml(t) {
                return r("xml:" + t.toString());
              },
              _null: function _null() {
                return r("Null");
              },
              _undefined: function _undefined() {
                return r("Undefined");
              },
              _regexp: function _regexp(t) {
                return r("regex:" + t.toString());
              },
              _uint8array: function _uint8array(t) {
                return r("uint8array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _uint8clampedarray: function _uint8clampedarray(t) {
                return r("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _int8array: function _int8array(t) {
                return r("uint8array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _uint16array: function _uint16array(t) {
                return r("uint16array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _int16array: function _int16array(t) {
                return r("uint16array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _uint32array: function _uint32array(t) {
                return r("uint32array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _int32array: function _int32array(t) {
                return r("uint32array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _float32array: function _float32array(t) {
                return r("float32array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _float64array: function _float64array(t) {
                return r("float64array:"), this.dispatch(Array.prototype.slice.call(t));
              },
              _arraybuffer: function _arraybuffer(t) {
                return r("arraybuffer:"), this.dispatch(new Uint8Array(t));
              },
              _url: function _url(t) {
                return r("url:" + t.toString());
              },
              _map: function _map(e) {
                r("map:");
                var n = Array.from(e);
                return this._array(n, !1 !== t.unorderedSets);
              },
              _set: function _set(e) {
                r("set:");
                var n = Array.from(e);
                return this._array(n, !1 !== t.unorderedSets);
              },
              _blob: function _blob() {
                if (t.ignoreUnknown) return r("[blob]");
                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
              },
              _domwindow: function _domwindow() {
                return r("domwindow");
              },
              _process: function _process() {
                return r("process");
              },
              _timer: function _timer() {
                return r("timer");
              },
              _pipe: function _pipe() {
                return r("pipe");
              },
              _tcp: function _tcp() {
                return r("tcp");
              },
              _udp: function _udp() {
                return r("udp");
              },
              _tty: function _tty() {
                return r("tty");
              },
              _statwatcher: function _statwatcher() {
                return r("statwatcher");
              },
              _securecontext: function _securecontext() {
                return r("securecontext");
              },
              _connection: function _connection() {
                return r("connection");
              },
              _zlib: function _zlib() {
                return r("zlib");
              },
              _context: function _context() {
                return r("context");
              },
              _nodescript: function _nodescript() {
                return r("nodescript");
              },
              _httpparser: function _httpparser() {
                return r("httpparser");
              },
              _dataview: function _dataview() {
                return r("dataview");
              },
              _signal: function _signal() {
                return r("signal");
              },
              _fsevent: function _fsevent() {
                return r("fsevent");
              },
              _tlswrap: function _tlswrap() {
                return r("tlswrap");
              }
            };
          }

          function v() {
            return {
              buf: "",
              write: function write(t) {
                this.buf += t;
              },
              end: function end(t) {
                this.buf += t;
              },
              read: function read() {
                return this.buf;
              }
            };
          }

          var b = t("crypto");
          (n = e.exports = f).sha1 = function (t) {
            return f(t);
          }, n.keys = function (t) {
            return f(t, {
              excludeValues: !0,
              algorithm: "sha1",
              encoding: "hex"
            });
          }, n.MD5 = function (t) {
            return f(t, {
              algorithm: "md5",
              encoding: "hex"
            });
          }, n.keysMD5 = function (t) {
            return f(t, {
              algorithm: "md5",
              encoding: "hex",
              excludeValues: !0
            });
          };
          var g = b.getHashes ? b.getHashes().slice() : ["sha1", "md5"];
          g.push("passthrough");
          var m = ["buffer", "hex", "binary", "base64"];

          n.writeToStream = function (t, e, n) {
            return void 0 === n && (n = e, e = {}), y(e = p(t, e), n).dispatch(t);
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_e8180ef5.js", "/");
      }, {
        buffer: 3,
        crypto: 5,
        lYpoI2: 10
      }],
      2: [function (t, e, n) {
        (function (t, e, r, i, o, s, a, u, c) {
          var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          !function (t) {
            "use strict";

            function e(t) {
              var e = t.charCodeAt(0);
              return e === r || e === u ? 62 : e === i || e === c ? 63 : e < o ? -1 : e < o + 10 ? e - o + 26 + 26 : e < a + 26 ? e - a : e < s + 26 ? e - s + 26 : void 0;
            }

            var n = "undefined" != typeof Uint8Array ? Uint8Array : Array,
                r = "+".charCodeAt(0),
                i = "/".charCodeAt(0),
                o = "0".charCodeAt(0),
                s = "a".charCodeAt(0),
                a = "A".charCodeAt(0),
                u = "-".charCodeAt(0),
                c = "_".charCodeAt(0);
            t.toByteArray = function (t) {
              function r(t) {
                c[h++] = t;
              }

              var i, o, s, a, u, c;
              if (t.length % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
              var l = t.length;
              u = "=" === t.charAt(l - 2) ? 2 : "=" === t.charAt(l - 1) ? 1 : 0, c = new n(3 * t.length / 4 - u), s = u > 0 ? t.length - 4 : t.length;
              var h = 0;

              for (i = 0, o = 0; i < s; i += 4, o += 3) {
                r((16711680 & (a = e(t.charAt(i)) << 18 | e(t.charAt(i + 1)) << 12 | e(t.charAt(i + 2)) << 6 | e(t.charAt(i + 3)))) >> 16), r((65280 & a) >> 8), r(255 & a);
              }

              return 2 === u ? r(255 & (a = e(t.charAt(i)) << 2 | e(t.charAt(i + 1)) >> 4)) : 1 === u && (r((a = e(t.charAt(i)) << 10 | e(t.charAt(i + 1)) << 4 | e(t.charAt(i + 2)) >> 2) >> 8 & 255), r(255 & a)), c;
            }, t.fromByteArray = function (t) {
              function e(t) {
                return l.charAt(t);
              }

              function n(t) {
                return e(t >> 18 & 63) + e(t >> 12 & 63) + e(t >> 6 & 63) + e(63 & t);
              }

              var r,
                  i,
                  o,
                  s = t.length % 3,
                  a = "";

              for (r = 0, o = t.length - s; r < o; r += 3) {
                a += n(i = (t[r] << 16) + (t[r + 1] << 8) + t[r + 2]);
              }

              switch (s) {
                case 1:
                  a += e((i = t[t.length - 1]) >> 2), a += e(i << 4 & 63), a += "==";
                  break;

                case 2:
                  a += e((i = (t[t.length - 2] << 8) + t[t.length - 1]) >> 10), a += e(i >> 4 & 63), a += e(i << 2 & 63), a += "=";
              }

              return a;
            };
          }(void 0 === n ? this.base64js = {} : n);
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, {
        buffer: 3,
        lYpoI2: 10
      }],
      3: [function (t, e, n) {
        (function (e, r, i, o, s, a, u, c, l) {
          function i(t, e, n) {
            if (!(this instanceof i)) return new i(t, e, n);
            var r,
                o,
                s,
                a = typeof t;
            if ("base64" === e && "string" === a) for (t = function (t) {
              return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
            }(t); t.length % 4 != 0;) {
              t += "=";
            }
            if ("number" === a) r = D(t);else if ("string" === a) r = i.byteLength(t, e);else {
              if ("object" !== a) throw new Error("First argument needs to be a number, array or string.");
              r = D(t.length);
            }
            if (i._useTypedArrays ? o = i._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), i._useTypedArrays && "number" == typeof t.byteLength) o._set(t);else if (function (t) {
              return P(t) || i.isBuffer(t) || t && "object" == typeof t && "number" == typeof t.length;
            }(t)) for (s = 0; s < r; s++) {
              i.isBuffer(t) ? o[s] = t.readUInt8(s) : o[s] = t[s];
            } else if ("string" === a) o.write(t, 0, e);else if ("number" === a && !i._useTypedArrays && !n) for (s = 0; s < r; s++) {
              o[s] = 0;
            }
            return o;
          }

          function h(t, e, n, r) {
            n = Number(n) || 0;
            var o = t.length - n;
            r ? (r = Number(r)) > o && (r = o) : r = o;
            var s = e.length;
            q(s % 2 == 0, "Invalid hex string"), r > s / 2 && (r = s / 2);

            for (var a = 0; a < r; a++) {
              var u = parseInt(e.substr(2 * a, 2), 16);
              q(!isNaN(u), "Invalid hex string"), t[n + a] = u;
            }

            return i._charsWritten = 2 * a, a;
          }

          function f(t, e, n, r) {
            return i._charsWritten = N(C(e), t, n, r);
          }

          function p(t, e, n, r) {
            return i._charsWritten = N(function (t) {
              for (var e = [], n = 0; n < t.length; n++) {
                e.push(255 & t.charCodeAt(n));
              }

              return e;
            }(e), t, n, r);
          }

          function d(t, e, n, r) {
            return i._charsWritten = N(L(e), t, n, r);
          }

          function y(t, e, n, r) {
            return i._charsWritten = N(function (t) {
              for (var e, n, r, i = [], o = 0; o < t.length; o++) {
                e = t.charCodeAt(o), n = e >> 8, r = e % 256, i.push(r), i.push(n);
              }

              return i;
            }(e), t, n, r);
          }

          function v(t, e, n) {
            var r = "";
            n = Math.min(t.length, n);

            for (var i = e; i < n; i++) {
              r += String.fromCharCode(t[i]);
            }

            return r;
          }

          function b(t, e, n, r) {
            r || (q("boolean" == typeof n, "missing or invalid endian"), q(null != e, "missing offset"), q(e + 1 < t.length, "Trying to read beyond buffer length"));
            var i,
                o = t.length;
            if (!(e >= o)) return n ? (i = t[e], e + 1 < o && (i |= t[e + 1] << 8)) : (i = t[e] << 8, e + 1 < o && (i |= t[e + 1])), i;
          }

          function g(t, e, n, r) {
            r || (q("boolean" == typeof n, "missing or invalid endian"), q(null != e, "missing offset"), q(e + 3 < t.length, "Trying to read beyond buffer length"));
            var i,
                o = t.length;
            if (!(e >= o)) return n ? (e + 2 < o && (i = t[e + 2] << 16), e + 1 < o && (i |= t[e + 1] << 8), i |= t[e], e + 3 < o && (i += t[e + 3] << 24 >>> 0)) : (e + 1 < o && (i = t[e + 1] << 16), e + 2 < o && (i |= t[e + 2] << 8), e + 3 < o && (i |= t[e + 3]), i += t[e] << 24 >>> 0), i;
          }

          function m(t, e, n, r) {
            if (r || (q("boolean" == typeof n, "missing or invalid endian"), q(null != e, "missing offset"), q(e + 1 < t.length, "Trying to read beyond buffer length")), !(e >= t.length)) {
              var i = b(t, e, n, !0);
              return 32768 & i ? -1 * (65535 - i + 1) : i;
            }
          }

          function w(t, e, n, r) {
            if (r || (q("boolean" == typeof n, "missing or invalid endian"), q(null != e, "missing offset"), q(e + 3 < t.length, "Trying to read beyond buffer length")), !(e >= t.length)) {
              var i = g(t, e, n, !0);
              return 2147483648 & i ? -1 * (4294967295 - i + 1) : i;
            }
          }

          function I(t, e, n, r) {
            return r || (q("boolean" == typeof n, "missing or invalid endian"), q(e + 3 < t.length, "Trying to read beyond buffer length")), R.read(t, e, n, 23, 4);
          }

          function x(t, e, n, r) {
            return r || (q("boolean" == typeof n, "missing or invalid endian"), q(e + 7 < t.length, "Trying to read beyond buffer length")), R.read(t, e, n, 52, 8);
          }

          function k(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 1 < t.length, "trying to write beyond buffer length"), M(e, 65535));
            var o = t.length;
            if (!(n >= o)) for (var s = 0, a = Math.min(o - n, 2); s < a; s++) {
              t[n + s] = (e & 255 << 8 * (r ? s : 1 - s)) >>> 8 * (r ? s : 1 - s);
            }
          }

          function E(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 3 < t.length, "trying to write beyond buffer length"), M(e, 4294967295));
            var o = t.length;
            if (!(n >= o)) for (var s = 0, a = Math.min(o - n, 4); s < a; s++) {
              t[n + s] = e >>> 8 * (r ? s : 3 - s) & 255;
            }
          }

          function O(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 1 < t.length, "Trying to write beyond buffer length"), F(e, 32767, -32768)), n >= t.length || k(t, e >= 0 ? e : 65535 + e + 1, n, r, i);
          }

          function S(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 3 < t.length, "Trying to write beyond buffer length"), F(e, 2147483647, -2147483648)), n >= t.length || E(t, e >= 0 ? e : 4294967295 + e + 1, n, r, i);
          }

          function _(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 3 < t.length, "Trying to write beyond buffer length"), $(e, 34028234663852886e22, -34028234663852886e22)), n >= t.length || R.write(t, e, n, r, 23, 4);
          }

          function A(t, e, n, r, i) {
            i || (q(null != e, "missing value"), q("boolean" == typeof r, "missing or invalid endian"), q(null != n, "missing offset"), q(n + 7 < t.length, "Trying to write beyond buffer length"), $(e, 17976931348623157e292, -17976931348623157e292)), n >= t.length || R.write(t, e, n, r, 52, 8);
          }

          function j(t, e, n) {
            return "number" != typeof t ? n : (t = ~~t) >= e ? e : t >= 0 ? t : (t += e) >= 0 ? t : 0;
          }

          function D(t) {
            return (t = ~~Math.ceil(+t)) < 0 ? 0 : t;
          }

          function P(t) {
            return (Array.isArray || function (t) {
              return "[object Array]" === Object.prototype.toString.call(t);
            })(t);
          }

          function B(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function C(t) {
            for (var e = [], n = 0; n < t.length; n++) {
              var r = t.charCodeAt(n);
              if (r <= 127) e.push(t.charCodeAt(n));else {
                var i = n;
                r >= 55296 && r <= 57343 && n++;

                for (var o = encodeURIComponent(t.slice(i, n + 1)).substr(1).split("%"), s = 0; s < o.length; s++) {
                  e.push(parseInt(o[s], 16));
                }
              }
            }

            return e;
          }

          function L(t) {
            return z.toByteArray(t);
          }

          function N(t, e, n, r) {
            for (var i = 0; i < r && !(i + n >= e.length || i >= t.length); i++) {
              e[i + n] = t[i];
            }

            return i;
          }

          function T(t) {
            try {
              return decodeURIComponent(t);
            } catch (t) {
              return String.fromCharCode(65533);
            }
          }

          function M(t, e) {
            q("number" == typeof t, "cannot write a non-number as a number"), q(t >= 0, "specified a negative value for writing an unsigned value"), q(t <= e, "value is larger than maximum value for type"), q(Math.floor(t) === t, "value has a fractional component");
          }

          function F(t, e, n) {
            q("number" == typeof t, "cannot write a non-number as a number"), q(t <= e, "value larger than maximum allowed value"), q(t >= n, "value smaller than minimum allowed value"), q(Math.floor(t) === t, "value has a fractional component");
          }

          function $(t, e, n) {
            q("number" == typeof t, "cannot write a non-number as a number"), q(t <= e, "value larger than maximum allowed value"), q(t >= n, "value smaller than minimum allowed value");
          }

          function q(t, e) {
            if (!t) throw new Error(e || "Failed assertion");
          }

          var z = t("base64-js"),
              R = t("ieee754");
          n.Buffer = i, n.SlowBuffer = i, n.INSPECT_MAX_BYTES = 50, i.poolSize = 8192, i._useTypedArrays = function () {
            try {
              var t = new ArrayBuffer(0),
                  e = new Uint8Array(t);
              return e.foo = function () {
                return 42;
              }, 42 === e.foo() && "function" == typeof e.subarray;
            } catch (t) {
              return !1;
            }
          }(), i.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, i.isBuffer = function (t) {
            return !(null == t || !t._isBuffer);
          }, i.byteLength = function (t, e) {
            var n;

            switch (t += "", e || "utf8") {
              case "hex":
                n = t.length / 2;
                break;

              case "utf8":
              case "utf-8":
                n = C(t).length;
                break;

              case "ascii":
              case "binary":
              case "raw":
                n = t.length;
                break;

              case "base64":
                n = L(t).length;
                break;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                n = 2 * t.length;
                break;

              default:
                throw new Error("Unknown encoding");
            }

            return n;
          }, i.concat = function (t, e) {
            if (q(P(t), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === t.length) return new i(0);
            if (1 === t.length) return t[0];
            var n;
            if ("number" != typeof e) for (e = 0, n = 0; n < t.length; n++) {
              e += t[n].length;
            }
            var r = new i(e),
                o = 0;

            for (n = 0; n < t.length; n++) {
              var s = t[n];
              s.copy(r, o), o += s.length;
            }

            return r;
          }, i.prototype.write = function (t, e, n, r) {
            if (isFinite(e)) isFinite(n) || (r = n, n = void 0);else {
              var i = r;
              r = e, e = n, n = i;
            }
            e = Number(e) || 0;
            var o,
                s = this.length - e;

            switch (n ? (n = Number(n)) > s && (n = s) : n = s, r = String(r || "utf8").toLowerCase()) {
              case "hex":
                o = h(this, t, e, n);
                break;

              case "utf8":
              case "utf-8":
                o = f(this, t, e, n);
                break;

              case "ascii":
                o = p(this, t, e, n);
                break;

              case "binary":
                o = function (t, e, n, r) {
                  return p(t, e, n, r);
                }(this, t, e, n);

                break;

              case "base64":
                o = d(this, t, e, n);
                break;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                o = y(this, t, e, n);
                break;

              default:
                throw new Error("Unknown encoding");
            }

            return o;
          }, i.prototype.toString = function (t, e, n) {
            var r,
                i = this;
            if (t = String(t || "utf8").toLowerCase(), e = Number(e) || 0, (n = void 0 !== n ? Number(n) : n = i.length) === e) return "";

            switch (t) {
              case "hex":
                r = function (t, e, n) {
                  var r = t.length;
                  (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);

                  for (var i = "", o = e; o < n; o++) {
                    i += B(t[o]);
                  }

                  return i;
                }(i, e, n);

                break;

              case "utf8":
              case "utf-8":
                r = function (t, e, n) {
                  var r = "",
                      i = "";
                  n = Math.min(t.length, n);

                  for (var o = e; o < n; o++) {
                    t[o] <= 127 ? (r += T(i) + String.fromCharCode(t[o]), i = "") : i += "%" + t[o].toString(16);
                  }

                  return r + T(i);
                }(i, e, n);

                break;

              case "ascii":
                r = v(i, e, n);
                break;

              case "binary":
                r = function (t, e, n) {
                  return v(t, e, n);
                }(i, e, n);

                break;

              case "base64":
                r = function (t, e, n) {
                  return 0 === e && n === t.length ? z.fromByteArray(t) : z.fromByteArray(t.slice(e, n));
                }(i, e, n);

                break;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                r = function (t, e, n) {
                  for (var r = t.slice(e, n), i = "", o = 0; o < r.length; o += 2) {
                    i += String.fromCharCode(r[o] + 256 * r[o + 1]);
                  }

                  return i;
                }(i, e, n);

                break;

              default:
                throw new Error("Unknown encoding");
            }

            return r;
          }, i.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          }, i.prototype.copy = function (t, e, n, r) {
            var o = this;

            if (n || (n = 0), r || 0 === r || (r = this.length), e || (e = 0), r !== n && 0 !== t.length && 0 !== o.length) {
              q(r >= n, "sourceEnd < sourceStart"), q(e >= 0 && e < t.length, "targetStart out of bounds"), q(n >= 0 && n < o.length, "sourceStart out of bounds"), q(r >= 0 && r <= o.length, "sourceEnd out of bounds"), r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
              var s = r - n;
              if (s < 100 || !i._useTypedArrays) for (var a = 0; a < s; a++) {
                t[a + e] = this[a + n];
              } else t._set(this.subarray(n, n + s), e);
            }
          }, i.prototype.slice = function (t, e) {
            var n = this.length;
            if (t = j(t, n, 0), e = j(e, n, n), i._useTypedArrays) return i._augment(this.subarray(t, e));

            for (var r = e - t, o = new i(r, void 0, !0), s = 0; s < r; s++) {
              o[s] = this[s + t];
            }

            return o;
          }, i.prototype.get = function (t) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(t);
          }, i.prototype.set = function (t, e) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(t, e);
          }, i.prototype.readUInt8 = function (t, e) {
            if (e || (q(null != t, "missing offset"), q(t < this.length, "Trying to read beyond buffer length")), !(t >= this.length)) return this[t];
          }, i.prototype.readUInt16LE = function (t, e) {
            return b(this, t, !0, e);
          }, i.prototype.readUInt16BE = function (t, e) {
            return b(this, t, !1, e);
          }, i.prototype.readUInt32LE = function (t, e) {
            return g(this, t, !0, e);
          }, i.prototype.readUInt32BE = function (t, e) {
            return g(this, t, !1, e);
          }, i.prototype.readInt8 = function (t, e) {
            if (e || (q(null != t, "missing offset"), q(t < this.length, "Trying to read beyond buffer length")), !(t >= this.length)) return 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, i.prototype.readInt16LE = function (t, e) {
            return m(this, t, !0, e);
          }, i.prototype.readInt16BE = function (t, e) {
            return m(this, t, !1, e);
          }, i.prototype.readInt32LE = function (t, e) {
            return w(this, t, !0, e);
          }, i.prototype.readInt32BE = function (t, e) {
            return w(this, t, !1, e);
          }, i.prototype.readFloatLE = function (t, e) {
            return I(this, t, !0, e);
          }, i.prototype.readFloatBE = function (t, e) {
            return I(this, t, !1, e);
          }, i.prototype.readDoubleLE = function (t, e) {
            return x(this, t, !0, e);
          }, i.prototype.readDoubleBE = function (t, e) {
            return x(this, t, !1, e);
          }, i.prototype.writeUInt8 = function (t, e, n) {
            n || (q(null != t, "missing value"), q(null != e, "missing offset"), q(e < this.length, "trying to write beyond buffer length"), M(t, 255)), e >= this.length || (this[e] = t);
          }, i.prototype.writeUInt16LE = function (t, e, n) {
            k(this, t, e, !0, n);
          }, i.prototype.writeUInt16BE = function (t, e, n) {
            k(this, t, e, !1, n);
          }, i.prototype.writeUInt32LE = function (t, e, n) {
            E(this, t, e, !0, n);
          }, i.prototype.writeUInt32BE = function (t, e, n) {
            E(this, t, e, !1, n);
          }, i.prototype.writeInt8 = function (t, e, n) {
            n || (q(null != t, "missing value"), q(null != e, "missing offset"), q(e < this.length, "Trying to write beyond buffer length"), F(t, 127, -128)), e >= this.length || (t >= 0 ? this.writeUInt8(t, e, n) : this.writeUInt8(255 + t + 1, e, n));
          }, i.prototype.writeInt16LE = function (t, e, n) {
            O(this, t, e, !0, n);
          }, i.prototype.writeInt16BE = function (t, e, n) {
            O(this, t, e, !1, n);
          }, i.prototype.writeInt32LE = function (t, e, n) {
            S(this, t, e, !0, n);
          }, i.prototype.writeInt32BE = function (t, e, n) {
            S(this, t, e, !1, n);
          }, i.prototype.writeFloatLE = function (t, e, n) {
            _(this, t, e, !0, n);
          }, i.prototype.writeFloatBE = function (t, e, n) {
            _(this, t, e, !1, n);
          }, i.prototype.writeDoubleLE = function (t, e, n) {
            A(this, t, e, !0, n);
          }, i.prototype.writeDoubleBE = function (t, e, n) {
            A(this, t, e, !1, n);
          }, i.prototype.fill = function (t, e, n) {
            if (t || (t = 0), e || (e = 0), n || (n = this.length), "string" == typeof t && (t = t.charCodeAt(0)), q("number" == typeof t && !isNaN(t), "value is not a number"), q(n >= e, "end < start"), n !== e && 0 !== this.length) {
              q(e >= 0 && e < this.length, "start out of bounds"), q(n >= 0 && n <= this.length, "end out of bounds");

              for (var r = e; r < n; r++) {
                this[r] = t;
              }
            }
          }, i.prototype.inspect = function () {
            for (var t = [], e = this.length, r = 0; r < e; r++) {
              if (t[r] = B(this[r]), r === n.INSPECT_MAX_BYTES) {
                t[r + 1] = "...";
                break;
              }
            }

            return "<Buffer " + t.join(" ") + ">";
          }, i.prototype.toArrayBuffer = function () {
            if ("undefined" != typeof Uint8Array) {
              if (i._useTypedArrays) return new i(this).buffer;

              for (var t = new Uint8Array(this.length), e = 0, n = t.length; e < n; e += 1) {
                t[e] = this[e];
              }

              return t.buffer;
            }

            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          };
          var U = i.prototype;

          i._augment = function (t) {
            return t._isBuffer = !0, t._get = t.get, t._set = t.set, t.get = U.get, t.set = U.set, t.write = U.write, t.toString = U.toString, t.toLocaleString = U.toString, t.toJSON = U.toJSON, t.copy = U.copy, t.slice = U.slice, t.readUInt8 = U.readUInt8, t.readUInt16LE = U.readUInt16LE, t.readUInt16BE = U.readUInt16BE, t.readUInt32LE = U.readUInt32LE, t.readUInt32BE = U.readUInt32BE, t.readInt8 = U.readInt8, t.readInt16LE = U.readInt16LE, t.readInt16BE = U.readInt16BE, t.readInt32LE = U.readInt32LE, t.readInt32BE = U.readInt32BE, t.readFloatLE = U.readFloatLE, t.readFloatBE = U.readFloatBE, t.readDoubleLE = U.readDoubleLE, t.readDoubleBE = U.readDoubleBE, t.writeUInt8 = U.writeUInt8, t.writeUInt16LE = U.writeUInt16LE, t.writeUInt16BE = U.writeUInt16BE, t.writeUInt32LE = U.writeUInt32LE, t.writeUInt32BE = U.writeUInt32BE, t.writeInt8 = U.writeInt8, t.writeInt16LE = U.writeInt16LE, t.writeInt16BE = U.writeInt16BE, t.writeInt32LE = U.writeInt32LE, t.writeInt32BE = U.writeInt32BE, t.writeFloatLE = U.writeFloatLE, t.writeFloatBE = U.writeFloatBE, t.writeDoubleLE = U.writeDoubleLE, t.writeDoubleBE = U.writeDoubleBE, t.fill = U.fill, t.inspect = U.inspect, t.toArrayBuffer = U.toArrayBuffer, t;
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, {
        "base64-js": 2,
        buffer: 3,
        ieee754: 11,
        lYpoI2: 10
      }],
      4: [function (t, e, n) {
        (function (n, r, i, o, s, a, u, c, l) {
          i = t("buffer").Buffer;
          var h = 4,
              f = new i(h);
          f.fill(0);
          var p = 8;
          e.exports = {
            hash: function hash(t, e, n, r) {
              return i.isBuffer(t) || (t = new i(t)), function (t, e, n) {
                for (var r = new i(e), o = n ? r.writeInt32BE : r.writeInt32LE, s = 0; s < t.length; s++) {
                  o.call(r, t[s], 4 * s, !0);
                }

                return r;
              }(e(function (t, e) {
                if (t.length % h != 0) {
                  var n = t.length + (h - t.length % h);
                  t = i.concat([t, f], n);
                }

                for (var r = [], o = e ? t.readInt32BE : t.readInt32LE, s = 0; s < t.length; s += h) {
                  r.push(o.call(t, s));
                }

                return r;
              }(t, r), t.length * p), n, r);
            }
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        buffer: 3,
        lYpoI2: 10
      }],
      5: [function (t, e, n) {
        (function (e, r, i, o, s, a, u, c, l) {
          function h(t, e) {
            var n = v[t = t || "sha1"],
                r = [];
            return n || f("algorithm:", t, "is not yet supported"), {
              update: function update(t) {
                return i.isBuffer(t) || (t = new i(t)), r.push(t), t.length, this;
              },
              digest: function digest(t) {
                var o = i.concat(r),
                    s = e ? function (t, e, n) {
                  i.isBuffer(e) || (e = new i(e)), i.isBuffer(n) || (n = new i(n)), e.length > b ? e = t(e) : e.length < b && (e = i.concat([e, g], b));

                  for (var r = new i(b), o = new i(b), s = 0; s < b; s++) {
                    r[s] = 54 ^ e[s], o[s] = 92 ^ e[s];
                  }

                  var a = t(i.concat([r, n]));
                  return t(i.concat([o, a]));
                }(n, e, o) : n(o);
                return r = null, t ? s.toString(t) : s;
              }
            };
          }

          function f() {
            var t = [].slice.call(arguments).join(" ");
            throw new Error([t, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join("\n"));
          }

          i = t("buffer").Buffer;
          var p = t("./sha"),
              d = t("./sha256"),
              y = t("./rng"),
              v = {
            sha1: p,
            sha256: d,
            md5: t("./md5")
          },
              b = 64,
              g = new i(b);
          g.fill(0), n.createHash = function (t) {
            return h(t);
          }, n.createHmac = function (t, e) {
            return h(t, e);
          }, n.randomBytes = function (t, e) {
            if (!e || !e.call) return new i(y(t));

            try {
              e.call(this, void 0, new i(y(t)));
            } catch (t) {
              e(t);
            }
          }, function (t, e) {
            for (var n in t) {
              e(t[n], n);
            }
          }(["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], function (t) {
            n[t] = function () {
              f("sorry,", t, "is not implemented yet");
            };
          });
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        "./md5": 6,
        "./rng": 7,
        "./sha": 8,
        "./sha256": 9,
        buffer: 3,
        lYpoI2: 10
      }],
      6: [function (t, e, n) {
        (function (n, r, i, o, s, a, u, c, l) {
          function h(t, e) {
            t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e;

            for (var n = 1732584193, r = -271733879, i = -1732584194, o = 271733878, s = 0; s < t.length; s += 16) {
              var a = n,
                  u = r,
                  c = i,
                  l = o;
              n = p(n, r, i, o, t[s + 0], 7, -680876936), o = p(o, n, r, i, t[s + 1], 12, -389564586), i = p(i, o, n, r, t[s + 2], 17, 606105819), r = p(r, i, o, n, t[s + 3], 22, -1044525330), n = p(n, r, i, o, t[s + 4], 7, -176418897), o = p(o, n, r, i, t[s + 5], 12, 1200080426), i = p(i, o, n, r, t[s + 6], 17, -1473231341), r = p(r, i, o, n, t[s + 7], 22, -45705983), n = p(n, r, i, o, t[s + 8], 7, 1770035416), o = p(o, n, r, i, t[s + 9], 12, -1958414417), i = p(i, o, n, r, t[s + 10], 17, -42063), r = p(r, i, o, n, t[s + 11], 22, -1990404162), n = p(n, r, i, o, t[s + 12], 7, 1804603682), o = p(o, n, r, i, t[s + 13], 12, -40341101), i = p(i, o, n, r, t[s + 14], 17, -1502002290), n = d(n, r = p(r, i, o, n, t[s + 15], 22, 1236535329), i, o, t[s + 1], 5, -165796510), o = d(o, n, r, i, t[s + 6], 9, -1069501632), i = d(i, o, n, r, t[s + 11], 14, 643717713), r = d(r, i, o, n, t[s + 0], 20, -373897302), n = d(n, r, i, o, t[s + 5], 5, -701558691), o = d(o, n, r, i, t[s + 10], 9, 38016083), i = d(i, o, n, r, t[s + 15], 14, -660478335), r = d(r, i, o, n, t[s + 4], 20, -405537848), n = d(n, r, i, o, t[s + 9], 5, 568446438), o = d(o, n, r, i, t[s + 14], 9, -1019803690), i = d(i, o, n, r, t[s + 3], 14, -187363961), r = d(r, i, o, n, t[s + 8], 20, 1163531501), n = d(n, r, i, o, t[s + 13], 5, -1444681467), o = d(o, n, r, i, t[s + 2], 9, -51403784), i = d(i, o, n, r, t[s + 7], 14, 1735328473), n = y(n, r = d(r, i, o, n, t[s + 12], 20, -1926607734), i, o, t[s + 5], 4, -378558), o = y(o, n, r, i, t[s + 8], 11, -2022574463), i = y(i, o, n, r, t[s + 11], 16, 1839030562), r = y(r, i, o, n, t[s + 14], 23, -35309556), n = y(n, r, i, o, t[s + 1], 4, -1530992060), o = y(o, n, r, i, t[s + 4], 11, 1272893353), i = y(i, o, n, r, t[s + 7], 16, -155497632), r = y(r, i, o, n, t[s + 10], 23, -1094730640), n = y(n, r, i, o, t[s + 13], 4, 681279174), o = y(o, n, r, i, t[s + 0], 11, -358537222), i = y(i, o, n, r, t[s + 3], 16, -722521979), r = y(r, i, o, n, t[s + 6], 23, 76029189), n = y(n, r, i, o, t[s + 9], 4, -640364487), o = y(o, n, r, i, t[s + 12], 11, -421815835), i = y(i, o, n, r, t[s + 15], 16, 530742520), n = v(n, r = y(r, i, o, n, t[s + 2], 23, -995338651), i, o, t[s + 0], 6, -198630844), o = v(o, n, r, i, t[s + 7], 10, 1126891415), i = v(i, o, n, r, t[s + 14], 15, -1416354905), r = v(r, i, o, n, t[s + 5], 21, -57434055), n = v(n, r, i, o, t[s + 12], 6, 1700485571), o = v(o, n, r, i, t[s + 3], 10, -1894986606), i = v(i, o, n, r, t[s + 10], 15, -1051523), r = v(r, i, o, n, t[s + 1], 21, -2054922799), n = v(n, r, i, o, t[s + 8], 6, 1873313359), o = v(o, n, r, i, t[s + 15], 10, -30611744), i = v(i, o, n, r, t[s + 6], 15, -1560198380), r = v(r, i, o, n, t[s + 13], 21, 1309151649), n = v(n, r, i, o, t[s + 4], 6, -145523070), o = v(o, n, r, i, t[s + 11], 10, -1120210379), i = v(i, o, n, r, t[s + 2], 15, 718787259), r = v(r, i, o, n, t[s + 9], 21, -343485551), n = b(n, a), r = b(r, u), i = b(i, c), o = b(o, l);
            }

            return Array(n, r, i, o);
          }

          function f(t, e, n, r, i, o) {
            return b(function (t, e) {
              return t << e | t >>> 32 - e;
            }(b(b(e, t), b(r, o)), i), n);
          }

          function p(t, e, n, r, i, o, s) {
            return f(e & n | ~e & r, t, e, i, o, s);
          }

          function d(t, e, n, r, i, o, s) {
            return f(e & r | n & ~r, t, e, i, o, s);
          }

          function y(t, e, n, r, i, o, s) {
            return f(e ^ n ^ r, t, e, i, o, s);
          }

          function v(t, e, n, r, i, o, s) {
            return f(n ^ (e | ~r), t, e, i, o, s);
          }

          function b(t, e) {
            var n = (65535 & t) + (65535 & e);
            return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
          }

          var g = t("./helpers");

          e.exports = function (t) {
            return g.hash(t, h, 16);
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        "./helpers": 4,
        buffer: 3,
        lYpoI2: 10
      }],
      7: [function (t, e, n) {
        (function (t, n, r, i, o, s, a, u, c) {
          !function () {
            var t, n;
            t = function t(_t) {
              for (var e, n = new Array(_t), r = 0; r < _t; r++) {
                0 == (3 & r) && (e = 4294967296 * Math.random()), n[r] = e >>> ((3 & r) << 3) & 255;
              }

              return n;
            }, this.crypto && crypto.getRandomValues && (n = function n(t) {
              var e = new Uint8Array(t);
              return crypto.getRandomValues(e), e;
            }), e.exports = n || t;
          }();
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        buffer: 3,
        lYpoI2: 10
      }],
      8: [function (t, e, n) {
        (function (n, r, i, o, s, a, u, c, l) {
          function h(t, e) {
            t[e >> 5] |= 128 << 24 - e % 32, t[15 + (e + 64 >> 9 << 4)] = e;

            for (var n = Array(80), r = 1732584193, i = -271733879, o = -1732584194, s = 271733878, a = -1009589776, u = 0; u < t.length; u += 16) {
              for (var c = r, l = i, h = o, v = s, b = a, g = 0; g < 80; g++) {
                n[g] = g < 16 ? t[u + g] : y(n[g - 3] ^ n[g - 8] ^ n[g - 14] ^ n[g - 16], 1);
                var m = d(d(y(r, 5), f(g, i, o, s)), d(d(a, n[g]), p(g)));
                a = s, s = o, o = y(i, 30), i = r, r = m;
              }

              r = d(r, c), i = d(i, l), o = d(o, h), s = d(s, v), a = d(a, b);
            }

            return Array(r, i, o, s, a);
          }

          function f(t, e, n, r) {
            return t < 20 ? e & n | ~e & r : t < 40 ? e ^ n ^ r : t < 60 ? e & n | e & r | n & r : e ^ n ^ r;
          }

          function p(t) {
            return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
          }

          function d(t, e) {
            var n = (65535 & t) + (65535 & e);
            return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
          }

          function y(t, e) {
            return t << e | t >>> 32 - e;
          }

          var v = t("./helpers");

          e.exports = function (t) {
            return v.hash(t, h, 20, !0);
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        "./helpers": 4,
        buffer: 3,
        lYpoI2: 10
      }],
      9: [function (t, e, n) {
        (function (n, r, i, o, s, a, u, c, l) {
          var h = t("./helpers"),
              f = function f(t, e) {
            var n = (65535 & t) + (65535 & e);
            return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
          },
              p = function p(t, e) {
            return t >>> e | t << 32 - e;
          },
              d = function d(t, e) {
            return t >>> e;
          },
              y = function y(t, e, n) {
            return t & e ^ ~t & n;
          },
              v = function v(t, e, n) {
            return t & e ^ t & n ^ e & n;
          },
              b = function b(t) {
            return p(t, 2) ^ p(t, 13) ^ p(t, 22);
          },
              g = function g(t) {
            return p(t, 6) ^ p(t, 11) ^ p(t, 25);
          },
              m = function m(t) {
            return p(t, 7) ^ p(t, 18) ^ d(t, 3);
          },
              w = function w(t) {
            return p(t, 17) ^ p(t, 19) ^ d(t, 10);
          },
              I = function I(t, e) {
            var n,
                r,
                i,
                o,
                s,
                a,
                u,
                c,
                l,
                h,
                p = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298),
                d = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225),
                I = new Array(64);
            t[e >> 5] |= 128 << 24 - e % 32, t[15 + (e + 64 >> 9 << 4)] = e;

            for (var x = 0; x < t.length; x += 16) {
              n = d[0], r = d[1], i = d[2], o = d[3], s = d[4], a = d[5], u = d[6], c = d[7];

              for (var k = 0; k < 64; k++) {
                I[k] = k < 16 ? t[k + x] : f(f(f(w(I[k - 2]), I[k - 7]), m(I[k - 15])), I[k - 16]), l = f(f(f(f(c, g(s)), y(s, a, u)), p[k]), I[k]), h = f(b(n), v(n, r, i)), c = u, u = a, a = s, s = f(o, l), o = i, i = r, r = n, n = f(l, h);
              }

              d[0] = f(n, d[0]), d[1] = f(r, d[1]), d[2] = f(i, d[2]), d[3] = f(o, d[3]), d[4] = f(s, d[4]), d[5] = f(a, d[5]), d[6] = f(u, d[6]), d[7] = f(c, d[7]);
            }

            return d;
          };

          e.exports = function (t) {
            return h.hash(t, I, 32, !0);
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, {
        "./helpers": 4,
        buffer: 3,
        lYpoI2: 10
      }],
      10: [function (t, e, n) {
        (function (t, n, r, i, o, s, a, u, c) {
          function l() {}

          (t = e.exports = {}).nextTick = function () {
            var t = "undefined" != typeof window && window.setImmediate,
                e = "undefined" != typeof window && window.postMessage && window.addEventListener;
            if (t) return function (t) {
              return window.setImmediate(t);
            };

            if (e) {
              var n = [];
              return window.addEventListener("message", function (t) {
                var e = t.source;
                (e === window || null === e) && "process-tick" === t.data && (t.stopPropagation(), n.length > 0) && n.shift()();
              }, !0), function (t) {
                n.push(t), window.postMessage("process-tick", "*");
              };
            }

            return function (t) {
              setTimeout(t, 0);
            };
          }(), t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.on = l, t.addListener = l, t.once = l, t.off = l, t.removeListener = l, t.removeAllListeners = l, t.emit = l, t.binding = function (t) {
            throw new Error("process.binding is not supported");
          }, t.cwd = function () {
            return "/";
          }, t.chdir = function (t) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, {
        buffer: 3,
        lYpoI2: 10
      }],
      11: [function (t, e, n) {
        (function (t, e, r, i, o, s, a, u, c) {
          n.read = function (t, e, n, r, i) {
            var o,
                s,
                a = 8 * i - r - 1,
                u = (1 << a) - 1,
                c = u >> 1,
                l = -7,
                h = n ? i - 1 : 0,
                f = n ? -1 : 1,
                p = t[e + h];

            for (h += f, o = p & (1 << -l) - 1, p >>= -l, l += a; l > 0; o = 256 * o + t[e + h], h += f, l -= 8) {
              ;
            }

            for (s = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; s = 256 * s + t[e + h], h += f, l -= 8) {
              ;
            }

            if (0 === o) o = 1 - c;else {
              if (o === u) return s ? NaN : 1 / 0 * (p ? -1 : 1);
              s += Math.pow(2, r), o -= c;
            }
            return (p ? -1 : 1) * s * Math.pow(2, o - r);
          }, n.write = function (t, e, n, r, i, o) {
            var s,
                a,
                u,
                c = 8 * o - i - 1,
                l = (1 << c) - 1,
                h = l >> 1,
                f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                p = r ? 0 : o - 1,
                d = r ? 1 : -1,
                y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = l) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + h >= 1 ? f / u : f * Math.pow(2, 1 - h)) * u >= 2 && (s++, u /= 2), s + h >= l ? (a = 0, s = l) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[n + p] = 255 & a, p += d, a /= 256, i -= 8) {
              ;
            }

            for (s = s << i | a, c += i; c > 0; t[n + p] = 255 & s, p += d, s /= 256, c -= 8) {
              ;
            }

            t[n + p - d] |= 128 * y;
          };
        }).call(this, t("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/ieee754/index.js", "/node_modules/ieee754");
      }, {
        buffer: 3,
        lYpoI2: 10
      }]
    }, {}, [1])(1);
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(7),
        i = n(12),
        o = {
      closed: !0,
      next: function next(t) {},
      error: function error(t) {
        if (r.a.useDeprecatedSynchronousErrorHandling) throw t;
        Object(i.a)(t);
      },
      complete: function complete() {}
    };
  },, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });

    var r = function () {
      return Array.isArray || function (t) {
        return t && "number" == typeof t.length;
      };
    }();
  }, function (t, e, n) {
    "use strict";

    var r = Array.isArray,
        i = Object.keys,
        o = Object.prototype.hasOwnProperty;

    t.exports = function t(e, n) {
      if (e === n) return !0;

      if (e && n && "object" == typeof e && "object" == typeof n) {
        var s,
            a,
            u,
            c = r(e),
            l = r(n);

        if (c && l) {
          if ((a = e.length) != n.length) return !1;

          for (s = a; 0 != s--;) {
            if (!t(e[s], n[s])) return !1;
          }

          return !0;
        }

        if (c != l) return !1;
        var h = e instanceof Date,
            f = n instanceof Date;
        if (h != f) return !1;
        if (h && f) return e.getTime() == n.getTime();
        var p = e instanceof RegExp,
            d = n instanceof RegExp;
        if (p != d) return !1;
        if (p && d) return e.toString() == n.toString();
        var y = i(e);
        if ((a = y.length) !== i(n).length) return !1;

        for (s = a; 0 != s--;) {
          if (!o.call(n, y[s])) return !1;
        }

        for (s = a; 0 != s--;) {
          if (!t(e[u = y[s]], n[u])) return !1;
        }

        return !0;
      }

      return e != e && n != n;
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(4),
          i = n.n(r),
          o = n(5),
          s = n.n(o),
          a = n(34),
          u = n(20),
          c = n.n(u),
          l = function l() {
        return void 0 !== t && (t.android || t.NSObject) ? "NATIVESCRIPT" : "undefined" == typeof window ? "NODEJS" : "undefined" != typeof document ? -1 === document.URL.indexOf("http://") && -1 === document.URL.indexOf("https://") ? "CORDOVA" : "BROWSER" : "CORDOVA";
      },
          h = function () {
        function t(e, n, r) {
          var o = this;
          i()(this, t), this.db = new c.a(e, {
            autoload: !0,
            autoloadCallback: function autoloadCallback() {
              o.databaseInitialize();
            },
            autosave: !0,
            env: l(),
            autosaveInterval: 2e3
          }), this.events = n;
        }

        return s()(t, [{
          key: "databaseInitialize",
          value: function value(t) {
            var e = this;
            Object(a.a)(this.events, "updateDB").subscribe(function () {
              e.db.saveDatabase();
            });
          }
        }, {
          key: "getLastKnownEvent",
          value: function value(t) {
            var e = this.db.getCollection(t);
            return e && e.count() ? e.max("blockNumber") : (this.db.addCollection(t), 0);
          }
        }, {
          key: "getFirstKnownEvent",
          value: function value(t) {
            var e = this.db.getCollection(t);
            return e && e.count() ? e.min("blockNumber") : (this.db.addCollection(t), 0);
          }
        }, {
          key: "getEventsFor",
          value: function value(t) {
            return this.db.getCollection(t).find();
          }
        }, {
          key: "eventExists",
          value: function value(t, e) {
            var n = this.db.getCollection(t);
            return n ? n.find({
              id: e
            }).length > 0 : (this.db.addCollection(t), !1);
          }
        }, {
          key: "recordEvent",
          value: function value(t, e) {
            this.db.getCollection(t).insert(e);
          }
        }, {
          key: "deleteEvent",
          value: function value(t, e) {
            var n = this.db.getCollection(t);
            n && n.chain().find({
              id: e
            }).remove();
          }
        }, {
          key: "deleteNewestBlocks",
          value: function value(t, e) {
            if (!(e <= 0)) {
              var n = this.db.getCollection(t);
              n && n.chain().find({
                blockNumber: {
                  $gte: e
                }
              }).remove();
            }
          }
        }]), t;
      }();

      e.a = h;
    }).call(this, n(18));
  }, function (t, e, n) {
    (function (r, i) {
      var o, s, a;
      s = [], void 0 === (a = "function" == typeof (o = function o() {
        return function () {
          "use strict";

          var t = Object.prototype.hasOwnProperty,
              e = {
            copyProperties: function copyProperties(t, e) {
              var n;

              for (n in t) {
                e[n] = t[n];
              }
            },
            resolveTransformObject: function resolveTransformObject(t, n, r) {
              var i, o;
              if ("number" != typeof r && (r = 0), ++r >= 10) return t;

              for (i in t) {
                "string" == typeof t[i] && 0 === t[i].indexOf("[%lktxp]") ? (o = t[i].substring(8), n.hasOwnProperty(o) && (t[i] = n[o])) : "object" == typeof t[i] && (t[i] = e.resolveTransformObject(t[i], n, r));
              }

              return t;
            },
            resolveTransformParams: function resolveTransformParams(t, n) {
              var r,
                  i,
                  o = [];
              if (void 0 === n) return t;

              for (r = 0; r < t.length; r++) {
                i = y(t[r], "shallow-recurse-objects"), o.push(e.resolveTransformObject(i, n));
              }

              return o;
            },
            getIn: function getIn(t, e, n) {
              if (null != t) {
                if (!n) return t[e];
                if ("string" == typeof e && (e = e.split(".")), !Array.isArray(e)) throw new Error("path must be a string or array. Found " + typeof e);

                for (var r = 0, i = e.length; null != t && r < i;) {
                  t = t[e[r++]];
                }

                return r && r == i ? t : void 0;
              }
            }
          },
              o = {
            aeq: s,
            lt: a,
            gt: u
          };

          function s(t, e) {
            var n, r, i, o;
            if (t === e) return !0;

            if (!t || !e || !0 === t || !0 === e || t != t || e != e) {
              switch (t) {
                case void 0:
                case null:
                  i = 1;
                  break;

                case !1:
                  i = 3;
                  break;

                case !0:
                  i = 4;
                  break;

                case "":
                  i = 5;
                  break;

                default:
                  i = t == t ? 9 : 0;
              }

              switch (e) {
                case void 0:
                case null:
                  o = 1;
                  break;

                case !1:
                  o = 3;
                  break;

                case !0:
                  o = 4;
                  break;

                case "":
                  o = 5;
                  break;

                default:
                  o = e == e ? 9 : 0;
              }

              if (9 !== i || 9 !== o) return i === o;
            }

            return n = Number(t), r = Number(e), n == n || r == r ? n === r : (n = t.toString()) == (r = e.toString());
          }

          function a(t, e, n) {
            var r, i, o, s;

            if (!t || !e || !0 === t || !0 === e || t != t || e != e) {
              switch (t) {
                case void 0:
                case null:
                  o = 1;
                  break;

                case !1:
                  o = 3;
                  break;

                case !0:
                  o = 4;
                  break;

                case "":
                  o = 5;
                  break;

                default:
                  o = t == t ? 9 : 0;
              }

              switch (e) {
                case void 0:
                case null:
                  s = 1;
                  break;

                case !1:
                  s = 3;
                  break;

                case !0:
                  s = 4;
                  break;

                case "":
                  s = 5;
                  break;

                default:
                  s = e == e ? 9 : 0;
              }

              if (9 !== o || 9 !== s) return o === s ? n : o < s;
            }

            return r = Number(t), i = Number(e), r == r && i == i ? r < i || !(r > i) && n : r == r && i != i || (i != i || r == r) && (t < e || !(t > e) && (t == e ? n : (r = t.toString()) < (i = e.toString()) || r == i && n));
          }

          function u(t, e, n) {
            var r, i, o, s;

            if (!t || !e || !0 === t || !0 === e || t != t || e != e) {
              switch (t) {
                case void 0:
                case null:
                  o = 1;
                  break;

                case !1:
                  o = 3;
                  break;

                case !0:
                  o = 4;
                  break;

                case "":
                  o = 5;
                  break;

                default:
                  o = t == t ? 9 : 0;
              }

              switch (e) {
                case void 0:
                case null:
                  s = 1;
                  break;

                case !1:
                  s = 3;
                  break;

                case !0:
                  s = 4;
                  break;

                case "":
                  s = 5;
                  break;

                default:
                  s = e == e ? 9 : 0;
              }

              if (9 !== o || 9 !== s) return o === s ? n : o > s;
            }

            return r = Number(t), i = Number(e), r == r && i == i ? r > i || !(r < i) && n : (r != r || i == i) && (i == i && r != r || t > e || !(t < e) && (t == e ? n : (r = t.toString()) > (i = e.toString()) || r == i && n));
          }

          function c(t, e, n) {
            return o.aeq(t, e) ? 0 : o.lt(t, e, !1) ? n ? 1 : -1 : o.gt(t, e, !1) ? n ? -1 : 1 : 0;
          }

          function l(t, e, n, r, i) {
            var o,
                s = i || 0,
                a = e[s],
                u = !1;
            if ("object" == typeof t && a in t && (o = t[a]), s + 1 >= e.length) u = n(o, r);else if (Array.isArray(o)) for (var c = 0, h = o.length; c < h && !0 !== (u = l(o[c], e, n, r, s + 1)); c += 1) {
              ;
            } else u = l(o, e, n, r, s + 1);
            return u;
          }

          function h(e) {
            return "string" == typeof e || Array.isArray(e) ? function (t) {
              return -1 !== e.indexOf(t);
            } : "object" == typeof e && null !== e ? function (n) {
              return t.call(e, n);
            } : null;
          }

          function f(e, n) {
            for (var r in n) {
              if (t.call(n, r)) return p[r](e, n[r]);
            }

            return !1;
          }

          var p = {
            $eq: function $eq(t, e) {
              return t === e;
            },
            $aeq: function $aeq(t, e) {
              return t == e;
            },
            $ne: function $ne(t, e) {
              return e != e ? t == t : t !== e;
            },
            $dteq: function $dteq(t, e) {
              return o.aeq(t, e);
            },
            $gt: function $gt(t, e) {
              return o.gt(t, e, !1);
            },
            $gte: function $gte(t, e) {
              return o.gt(t, e, !0);
            },
            $lt: function $lt(t, e) {
              return o.lt(t, e, !1);
            },
            $lte: function $lte(t, e) {
              return o.lt(t, e, !0);
            },
            $jgt: function $jgt(t, e) {
              return t > e;
            },
            $jgte: function $jgte(t, e) {
              return t >= e;
            },
            $jlt: function $jlt(t, e) {
              return t < e;
            },
            $jlte: function $jlte(t, e) {
              return t <= e;
            },
            $between: function $between(t, e) {
              return null != t && o.gt(t, e[0], !0) && o.lt(t, e[1], !0);
            },
            $jbetween: function $jbetween(t, e) {
              return null != t && t >= e[0] && t <= e[1];
            },
            $in: function $in(t, e) {
              return -1 !== e.indexOf(t);
            },
            $nin: function $nin(t, e) {
              return -1 === e.indexOf(t);
            },
            $keyin: function $keyin(t, e) {
              return t in e;
            },
            $nkeyin: function $nkeyin(t, e) {
              return !(t in e);
            },
            $definedin: function $definedin(t, e) {
              return void 0 !== e[t];
            },
            $undefinedin: function $undefinedin(t, e) {
              return void 0 === e[t];
            },
            $regex: function $regex(t, e) {
              return e.test(t);
            },
            $containsString: function $containsString(t, e) {
              return "string" == typeof t && -1 !== t.indexOf(e);
            },
            $containsNone: function $containsNone(t, e) {
              return !p.$containsAny(t, e);
            },
            $containsAny: function $containsAny(t, e) {
              var n = h(t);
              return null !== n && (Array.isArray(e) ? e.some(n) : n(e));
            },
            $contains: function $contains(t, e) {
              var n = h(t);
              return null !== n && (Array.isArray(e) ? e.every(n) : n(e));
            },
            $elemMatch: function $elemMatch(t, e) {
              return !!Array.isArray(t) && t.some(function (t) {
                return Object.keys(e).every(function (n) {
                  var r = e[n];
                  return "object" == typeof r && r || (r = {
                    $eq: r
                  }), -1 !== n.indexOf(".") ? l(t, n.split("."), f, e[n]) : f(t[n], r);
                });
              });
            },
            $type: function $type(t, e) {
              var n = typeof t;
              return "object" === n && (Array.isArray(t) ? n = "array" : t instanceof Date && (n = "date")), "object" != typeof e ? n === e : f(n, e);
            },
            $finite: function $finite(t, e) {
              return e === isFinite(t);
            },
            $size: function $size(t, e) {
              return !!Array.isArray(t) && ("object" != typeof e ? t.length === e : f(t.length, e));
            },
            $len: function $len(t, e) {
              return "string" == typeof t && ("object" != typeof e ? t.length === e : f(t.length, e));
            },
            $where: function $where(t, e) {
              return !0 === e(t);
            },
            $not: function $not(t, e) {
              return !f(t, e);
            },
            $and: function $and(t, e) {
              for (var n = 0, r = e.length; n < r; n += 1) {
                if (!f(t, e[n])) return !1;
              }

              return !0;
            },
            $or: function $or(t, e) {
              for (var n = 0, r = e.length; n < r; n += 1) {
                if (f(t, e[n])) return !0;
              }

              return !1;
            },
            $exists: function $exists(t, e) {
              return e ? void 0 !== t : void 0 === t;
            }
          },
              d = {
            $eq: p.$eq,
            $aeq: !0,
            $dteq: !0,
            $gt: !0,
            $gte: !0,
            $lt: !0,
            $lte: !0,
            $in: !0,
            $between: !0
          };

          function y(t, e) {
            if (null == t) return null;
            var n;

            switch (e || "parse-stringify") {
              case "parse-stringify":
                n = JSON.parse(JSON.stringify(t));
                break;

              case "jquery-extend-deep":
                n = jQuery.extend(!0, {}, t);
                break;

              case "shallow":
                n = Object.create(t.constructor.prototype), Object.keys(t).map(function (e) {
                  n[e] = t[e];
                });
                break;

              case "shallow-assign":
                n = Object.create(t.constructor.prototype), Object.assign(n, t);
                break;

              case "shallow-recurse-objects":
                n = y(t, "shallow"), Object.keys(t).forEach(function (e) {
                  "object" == typeof t[e] && "Object" === t[e].constructor.name ? n[e] = y(t[e], "shallow-recurse-objects") : Array.isArray(t[e]) && (n[e] = function (t, e) {
                    if ("parse-stringify" == e) return y(t, e);

                    for (var n = [], r = 0, i = t.length; r < i; r++) {
                      n[r] = y(t[r], e);
                    }

                    return n;
                  }(t[e], "shallow-recurse-objects"));
                });
            }

            return n;
          }

          function v() {
            try {
              return window && void 0 !== window.localStorage && null !== window.localStorage;
            } catch (t) {
              return !1;
            }
          }

          function b() {}

          function g(t, e) {
            this.filename = t || "loki.db", this.collections = [], this.databaseVersion = 1.5, this.engineVersion = 1.5, this.autosave = !1, this.autosaveInterval = 5e3, this.autosaveHandle = null, this.throttledSaves = !0, this.options = {}, this.persistenceMethod = null, this.persistenceAdapter = null, this.throttledSavePending = !1, this.throttledCallbacks = [], this.verbose = !(!e || !e.hasOwnProperty("verbose")) && e.verbose, this.events = {
              init: [],
              loaded: [],
              flushChanges: [],
              close: [],
              changes: [],
              warning: []
            }, e && e.hasOwnProperty("env") ? this.ENV = e.env : this.ENV = void 0 !== r && (r.android || r.NSObject) ? "NATIVESCRIPT" : "undefined" == typeof window ? "NODEJS" : void 0 !== r && r.window && void 0 !== i ? "NODEJS" : "undefined" != typeof document ? -1 === document.URL.indexOf("http://") && -1 === document.URL.indexOf("https://") ? "CORDOVA" : "BROWSER" : "CORDOVA", "undefined" === this.ENV && (this.ENV = "NODEJS"), this.configureOptions(e, !0), this.on("init", this.clearChanges);
          }

          function m(t) {
            this.hashStore = {}, this.options = t || {}, this.options.hasOwnProperty("asyncResponses") || (this.options.asyncResponses = !1), this.options.hasOwnProperty("asyncTimeout") || (this.options.asyncTimeout = 50);
          }

          function w(t, e) {
            if (this.mode = "reference", this.adapter = null, this.options = e || {}, this.dbref = null, this.dbname = "", this.pageIterator = {}, !t) throw new Error("LokiPartitioningAdapter requires a (non-reference mode) adapter on construction");
            if ("reference" === t.mode) throw new Error("LokiPartitioningAdapter cannot be instantiated with a reference mode adapter");
            this.adapter = t, this.options.hasOwnProperty("paging") || (this.options.paging = !1), this.options.hasOwnProperty("pageSize") || (this.options.pageSize = 26214400), this.options.hasOwnProperty("delimiter") || (this.options.delimiter = "$<\n");
          }

          function I() {
            try {
              this.fs = n(31);
            } catch (t) {
              this.fs = null;
            }
          }

          function x() {}

          function k(t, e) {
            return e = e || {}, this.collection = t, this.filteredrows = [], this.filterInitialized = !1, this;
          }

          function E(t, e, n) {
            this.collection = t, this.name = e, this.rebuildPending = !1, this.options = n || {}, this.options.hasOwnProperty("persistent") || (this.options.persistent = !1), this.options.hasOwnProperty("sortPriority") || (this.options.sortPriority = "passive"), this.options.hasOwnProperty("minRebuildInterval") || (this.options.minRebuildInterval = 1), this.resultset = new k(t), this.resultdata = [], this.resultsdirty = !1, this.cachedresultset = null, this.filterPipeline = [], this.sortFunction = null, this.sortCriteria = null, this.sortCriteriaSimple = null, this.sortDirty = !1, this.events = {
              rebuild: []
            };
          }

          function O(e, n) {
            this.name = e, this.data = [], this.idIndex = [], this.binaryIndices = {}, this.constraints = {
              unique: {},
              exact: {}
            }, this.uniqueNames = [], this.transforms = {}, this.objType = e, this.dirty = !0, this.cachedIndex = null, this.cachedBinaryIndex = null, this.cachedData = null;
            var r = this;
            (n = n || {}).hasOwnProperty("unique") && (Array.isArray(n.unique) || (n.unique = [n.unique]), n.unique.forEach(function (t) {
              r.uniqueNames.push(t), r.constraints.unique[t] = new N(t);
            })), n.hasOwnProperty("exact") && n.exact.forEach(function (t) {
              r.constraints.exact[t] = new T(t);
            }), this.adaptiveBinaryIndices = !n.hasOwnProperty("adaptiveBinaryIndices") || n.adaptiveBinaryIndices, this.transactional = !!n.hasOwnProperty("transactional") && n.transactional, this.cloneObjects = !!n.hasOwnProperty("clone") && n.clone, this.cloneMethod = n.hasOwnProperty("cloneMethod") ? n.cloneMethod : "parse-stringify", this.asyncListeners = !!n.hasOwnProperty("asyncListeners") && n.asyncListeners, this.disableMeta = !!n.hasOwnProperty("disableMeta") && n.disableMeta, this.disableChangesApi = !n.hasOwnProperty("disableChangesApi") || n.disableChangesApi, this.disableDeltaChangesApi = !n.hasOwnProperty("disableDeltaChangesApi") || n.disableDeltaChangesApi, this.disableChangesApi && (this.disableDeltaChangesApi = !0), this.autoupdate = !!n.hasOwnProperty("autoupdate") && n.autoupdate, this.serializableIndices = !n.hasOwnProperty("serializableIndices") || n.serializableIndices, this.ttl = {
              age: null,
              ttlInterval: null,
              daemon: null
            }, this.setTTL(n.ttl || -1, n.ttlInterval), this.maxId = 0, this.DynamicViews = [], this.events = {
              insert: [],
              update: [],
              "pre-insert": [],
              "pre-update": [],
              close: [],
              flushbuffer: [],
              error: [],
              delete: [],
              warning: []
            }, this.changes = [], this.ensureId();
            var i = [];
            if (n && n.indices) if ("[object Array]" === Object.prototype.toString.call(n.indices)) i = n.indices;else {
              if ("string" != typeof n.indices) throw new TypeError("Indices needs to be a string or an array of strings");
              i = [n.indices];
            }

            for (var o = 0; o < i.length; o++) {
              this.ensureIndex(i[o]);
            }

            function s(t, e) {
              var n = null !== e && "object" == typeof e ? Object.keys(e) : null;

              if (n && n.length && ["string", "boolean", "number"].indexOf(typeof e) < 0) {
                for (var i = {}, o = 0; o < n.length; o++) {
                  var a = n[o];
                  if (e.hasOwnProperty(a)) if (!t.hasOwnProperty(a) || r.uniqueNames.indexOf(a) >= 0 || "$loki" == a || "meta" == a) i[a] = e[a];else {
                    var u = s(t[a], e[a]);
                    void 0 !== u && u != {} && (i[a] = u);
                  }
                }

                return 0 === Object.keys(i).length ? void 0 : i;
              }

              return t === e ? void 0 : e;
            }

            function a() {
              r.changes = [];
            }

            this.observerCallback = function (e) {
              var n = "function" == typeof Set ? new Set() : [];
              n.add || (n.add = function (t) {
                return -1 === this.indexOf(t) && this.push(t), this;
              }), e.forEach(function (t) {
                n.add(t.object);
              }), n.forEach(function (e) {
                if (!t.call(e, "$loki")) return r.removeAutoUpdateObserver(e);

                try {
                  r.update(e);
                } catch (t) {}
              });
            }, this.getChangeDelta = function (t, e) {
              return e ? s(e, t) : JSON.parse(JSON.stringify(t));
            }, this.getObjectDelta = s, this.getChanges = function () {
              return r.changes;
            }, this.flushChanges = a, this.setChangesApi = function (t) {
              r.disableChangesApi = !t, t || (r.disableDeltaChangesApi = !1);
            }, this.on("delete", function (t) {
              r.disableChangesApi || r.createChange(r.name, "R", t);
            }), this.on("warning", function (t) {
              r.lokiConsoleWrapper.warn(t);
            }), a();
          }

          function S(t) {
            return -1 !== t.indexOf(".");
          }

          function _(t) {
            return parseFloat(t, 10);
          }

          function A(t, e) {
            return t + e;
          }

          function j(t, e) {
            return t - e;
          }

          function D(t) {
            return t.reduce(A, 0) / t.length;
          }

          function P(t, e, n) {
            if (!1 === n) return t[e];

            for (var r = e.split("."), i = t; r.length > 0;) {
              i = i[r.shift()];
            }

            return i;
          }

          function B(t, e, n) {
            for (var r, i, o = 0, s = t.length; o < s;) {
              if (i = o + s >> 1, 0 === (r = n.apply(null, [e, t[i]]))) return {
                found: !0,
                index: i
              };
              r < 0 ? s = i : o = i + 1;
            }

            return {
              found: !1,
              index: s
            };
          }

          function C(t) {
            return function (e, n) {
              return B(e, n, t);
            };
          }

          function L() {}

          function N(t) {
            this.field = t, this.keyMap = {}, this.lokiMap = {};
          }

          function T(t) {
            this.index = {}, this.field = t;
          }

          return b.prototype.events = {}, b.prototype.asyncListeners = !1, b.prototype.on = function (t, e) {
            var n,
                r = this;
            return Array.isArray(t) ? (t.forEach(function (t) {
              r.on(t, e);
            }), e) : ((n = this.events[t]) || (n = this.events[t] = []), n.push(e), e);
          }, b.prototype.emit = function (t) {
            var e = this,
                n = Array.prototype.slice.call(arguments, 1);
            if (!t || !this.events[t]) throw new Error("No event " + t + " defined");
            this.events[t].forEach(function (t) {
              e.asyncListeners ? setTimeout(function () {
                t.apply(e, n);
              }, 1) : t.apply(e, n);
            });
          }, b.prototype.addListener = b.prototype.on, b.prototype.removeListener = function (t, e) {
            var n = this;
            if (Array.isArray(t)) t.forEach(function (t) {
              n.removeListener(t, e);
            });else if (this.events[t]) {
              var r = this.events[t];
              r.splice(r.indexOf(e), 1);
            }
          }, g.prototype = new b(), g.prototype.constructor = g, g.prototype.getIndexedAdapter = function () {
            return n(30);
          }, g.prototype.configureOptions = function (t, e) {
            var n = {
              fs: I,
              localStorage: x,
              memory: m
            };

            if (this.options = {}, this.persistenceMethod = null, this.persistenceAdapter = null, void 0 !== t) {
              if (this.options = t, this.options.hasOwnProperty("persistenceMethod") && "function" == typeof n[t.persistenceMethod] && (this.persistenceMethod = t.persistenceMethod, this.persistenceAdapter = new n[t.persistenceMethod]()), this.options.hasOwnProperty("adapter") && (this.persistenceMethod = "adapter", this.persistenceAdapter = t.adapter, this.options.adapter = null), t.autoload && e) {
                var r = this;
                setTimeout(function () {
                  r.loadDatabase(t, t.autoloadCallback);
                }, 1);
              }

              this.options.hasOwnProperty("autosaveInterval") && (this.autosaveDisable(), this.autosaveInterval = parseInt(this.options.autosaveInterval, 10)), this.options.hasOwnProperty("autosave") && this.options.autosave && (this.autosaveDisable(), this.autosave = !0, this.options.hasOwnProperty("autosaveCallback") ? this.autosaveEnable(t, t.autosaveCallback) : this.autosaveEnable()), this.options.hasOwnProperty("throttledSaves") && (this.throttledSaves = this.options.throttledSaves);
            }

            this.options.hasOwnProperty("serializationMethod") || (this.options.serializationMethod = "normal"), this.options.hasOwnProperty("destructureDelimiter") || (this.options.destructureDelimiter = "$<\n"), null === this.persistenceAdapter && (this.persistenceMethod = {
              NODEJS: "fs",
              BROWSER: "localStorage",
              CORDOVA: "localStorage",
              MEMORY: "memory"
            }[this.ENV], this.persistenceMethod && (this.persistenceAdapter = new n[this.persistenceMethod]()));
          }, g.prototype.copy = function (t) {
            var e,
                n,
                r = new g(this.filename, {
              env: "NA"
            });
            if (t = t || {}, r.loadJSONObject(this, {
              retainDirtyFlags: !0
            }), t.hasOwnProperty("removeNonSerializable") && !0 === t.removeNonSerializable) for (r.autosaveHandle = null, r.persistenceAdapter = null, e = r.collections.length, n = 0; n < e; n++) {
              r.collections[n].constraints = null, r.collections[n].ttl = null;
            }
            return r;
          }, g.prototype.addCollection = function (t, e) {
            var n,
                r = this.collections.length;

            if (e && !0 === e.disableMeta) {
              if (!1 === e.disableChangesApi) throw new Error("disableMeta option cannot be passed as true when disableChangesApi is passed as false");
              if (!1 === e.disableDeltaChangesApi) throw new Error("disableMeta option cannot be passed as true when disableDeltaChangesApi is passed as false");
              if ("number" == typeof e.ttl && e.ttl > 0) throw new Error("disableMeta option cannot be passed as true when ttl is enabled");
            }

            for (n = 0; n < r; n += 1) {
              if (this.collections[n].name === t) return this.collections[n];
            }

            var i = new O(t, e);
            return this.collections.push(i), this.verbose && (i.lokiConsoleWrapper = console), i;
          }, g.prototype.loadCollection = function (t) {
            if (!t.name) throw new Error("Collection must have a name property to be loaded");
            this.collections.push(t);
          }, g.prototype.getCollection = function (t) {
            var e,
                n = this.collections.length;

            for (e = 0; e < n; e += 1) {
              if (this.collections[e].name === t) return this.collections[e];
            }

            return this.emit("warning", "collection " + t + " not found"), null;
          }, g.prototype.renameCollection = function (t, e) {
            var n = this.getCollection(t);
            return n && (n.name = e), n;
          }, g.prototype.listCollections = function () {
            for (var t = this.collections.length, e = []; t--;) {
              e.push({
                name: this.collections[t].name,
                type: this.collections[t].objType,
                count: this.collections[t].data.length
              });
            }

            return e;
          }, g.prototype.removeCollection = function (t) {
            var e,
                n = this.collections.length;

            for (e = 0; e < n; e += 1) {
              if (this.collections[e].name === t) {
                var r = new O(t, {}),
                    i = this.collections[e];

                for (var o in i) {
                  i.hasOwnProperty(o) && r.hasOwnProperty(o) && (i[o] = r[o]);
                }

                return void this.collections.splice(e, 1);
              }
            }
          }, g.prototype.getName = function () {
            return this.name;
          }, g.prototype.serializeReplacer = function (t, e) {
            switch (t) {
              case "autosaveHandle":
              case "persistenceAdapter":
              case "constraints":
              case "ttl":
                return null;

              case "throttledSavePending":
              case "throttledCallbacks":
                return;

              case "lokiConsoleWrapper":
                return null;

              default:
                return e;
            }
          }, g.prototype.serialize = function (t) {
            switch ((t = t || {}).hasOwnProperty("serializationMethod") || (t.serializationMethod = this.options.serializationMethod), t.serializationMethod) {
              case "normal":
                return JSON.stringify(this, this.serializeReplacer);

              case "pretty":
                return JSON.stringify(this, this.serializeReplacer, 2);

              case "destructured":
                return this.serializeDestructured();

              default:
                return JSON.stringify(this, this.serializeReplacer);
            }
          }, g.prototype.toJson = g.prototype.serialize, g.prototype.serializeDestructured = function (t) {
            var e,
                n,
                r,
                i,
                o,
                s = [];
            if ((t = t || {}).hasOwnProperty("partitioned") || (t.partitioned = !1), t.hasOwnProperty("delimited") || (t.delimited = !0), t.hasOwnProperty("delimiter") || (t.delimiter = this.options.destructureDelimiter), !0 === t.partitioned && t.hasOwnProperty("partition") && t.partition >= 0) return this.serializeCollection({
              delimited: t.delimited,
              delimiter: t.delimiter,
              collectionIndex: t.partition
            });

            for ((o = new g(this.filename)).loadJSONObject(this), e = 0; e < o.collections.length; e++) {
              o.collections[e].data = [];
            }

            if (!0 === t.partitioned && -1 === t.partition) return o.serialize({
              serializationMethod: "normal"
            });

            for (s.push(o.serialize({
              serializationMethod: "normal"
            })), o = null, e = 0; e < this.collections.length; e++) {
              if (r = this.serializeCollection({
                delimited: t.delimited,
                delimiter: t.delimiter,
                collectionIndex: e
              }), !1 === t.partitioned && !1 === t.delimited) {
                if (!Array.isArray(r)) throw new Error("a nondelimited, non partitioned collection serialization did not return an expected array");

                for (i = r.length, n = 0; n < i; n++) {
                  s.push(r[n]), r[n] = null;
                }

                s.push("");
              } else s.push(r);
            }

            return t.partitioned ? (t.delimited, s) : t.delimited ? (s.push(""), s.join(t.delimiter)) : (s.push(""), s);
          }, g.prototype.serializeCollection = function (t) {
            var e,
                n,
                r = [];
            if ((t = t || {}).hasOwnProperty("delimited") || (t.delimited = !0), !t.hasOwnProperty("collectionIndex")) throw new Error("serializeCollection called without 'collectionIndex' option");

            for (e = this.collections[t.collectionIndex].data.length, r = [], n = 0; n < e; n++) {
              r.push(JSON.stringify(this.collections[t.collectionIndex].data[n]));
            }

            return t.delimited ? (r.push(""), r.join(t.delimiter)) : r;
          }, g.prototype.deserializeDestructured = function (t, e) {
            var n,
                r,
                i,
                o = [],
                s = 0,
                a = 1,
                u = !1;

            if ((e = e || {}).hasOwnProperty("partitioned") || (e.partitioned = !1), e.hasOwnProperty("delimited") || (e.delimited = !0), e.hasOwnProperty("delimiter") || (e.delimiter = this.options.destructureDelimiter), e.partitioned) {
              if (e.hasOwnProperty("partition")) return -1 === e.partition ? n = JSON.parse(t[0]) : this.deserializeCollection(t[e.partition + 1], e);

              for (r = (n = JSON.parse(t[0])).collections.length, s = 0; s < r; s++) {
                n.collections[s].data = this.deserializeCollection(t[s + 1], e);
              }

              return n;
            }

            if (e.delimited) {
              if (o = t.split(e.delimiter), t = null, 0 === o.length) return null;
            } else o = t;

            for (r = (n = JSON.parse(o[0])).collections.length, o[0] = null; !u;) {
              o[a], "" === o[a] ? ++s > r && (u = !0) : (i = JSON.parse(o[a]), n.collections[s].data.push(i)), o[a++] = null;
            }

            return n;
          }, g.prototype.deserializeCollection = function (t, e) {
            var n,
                r,
                i = [];

            for ((e = e || {}).hasOwnProperty("partitioned") || (e.partitioned = !1), e.hasOwnProperty("delimited") || (e.delimited = !0), e.hasOwnProperty("delimiter") || (e.delimiter = this.options.destructureDelimiter), e.delimited ? (i = t.split(e.delimiter)).pop() : i = t, r = i.length, n = 0; n < r; n++) {
              i[n] = JSON.parse(i[n]);
            }

            return i;
          }, g.prototype.loadJSON = function (t, e) {
            var n;
            if (0 === t.length) n = {};else switch (this.options.serializationMethod) {
              case "normal":
              case "pretty":
                n = JSON.parse(t);
                break;

              case "destructured":
                n = this.deserializeDestructured(t);
                break;

              default:
                n = JSON.parse(t);
            }
            this.loadJSONObject(n, e);
          }, g.prototype.loadJSONObject = function (t, n) {
            var r,
                i,
                o,
                s,
                a,
                u,
                c = 0,
                l = t.collections ? t.collections.length : 0;

            function h(t) {
              var r,
                  i = n[t.name];
              return i.proto ? (r = i.inflate || e.copyProperties, function (t) {
                var e = new i.proto();
                return r(t, e), e;
              }) : i.inflate;
            }

            for (this.name = t.name, t.hasOwnProperty("throttledSaves") && n && !n.hasOwnProperty("throttledSaves") && (this.throttledSaves = t.throttledSaves), this.collections = []; c < l; c += 1) {
              if (r = t.collections[c], (i = this.addCollection(r.name, {
                disableChangesApi: r.disableChangesApi,
                disableDeltaChangesApi: r.disableDeltaChangesApi,
                disableMeta: r.disableMeta
              })).adaptiveBinaryIndices = !!r.hasOwnProperty("adaptiveBinaryIndices") && !0 === r.adaptiveBinaryIndices, i.transactional = r.transactional, i.asyncListeners = r.asyncListeners, i.cloneObjects = r.cloneObjects, i.cloneMethod = r.cloneMethod || "parse-stringify", i.autoupdate = r.autoupdate, i.changes = r.changes, n && !0 === n.retainDirtyFlags ? i.dirty = r.dirty : i.dirty = !1, o = r.data.length, s = 0, n && n.hasOwnProperty(r.name)) for (a = h(r); s < o; s++) {
                u = a(r.data[s]), i.data[s] = u, i.addAutoUpdateObserver(u);
              } else for (; s < o; s++) {
                i.data[s] = r.data[s], i.addAutoUpdateObserver(i.data[s]);
              }
              if (i.maxId = void 0 === r.maxId ? 0 : r.maxId, i.idIndex = r.idIndex, void 0 !== r.binaryIndices && (i.binaryIndices = r.binaryIndices), void 0 !== r.transforms && (i.transforms = r.transforms), i.ensureId(), i.uniqueNames = [], r.hasOwnProperty("uniqueNames")) for (i.uniqueNames = r.uniqueNames, s = 0; s < i.uniqueNames.length; s++) {
                i.ensureUniqueIndex(i.uniqueNames[s]);
              }

              if (void 0 !== r.DynamicViews) {
                for (var f = 0; f < r.DynamicViews.length; f++) {
                  var p = r.DynamicViews[f],
                      d = i.addDynamicView(p.name, p.options);
                  d.resultdata = p.resultdata, d.resultsdirty = p.resultsdirty, d.filterPipeline = p.filterPipeline, d.sortCriteria = p.sortCriteria, d.sortFunction = null, d.sortDirty = p.sortDirty, d.resultset.filteredrows = p.resultset.filteredrows, d.resultset.filterInitialized = p.resultset.filterInitialized, d.rematerialize({
                    removeWhereFilters: !0
                  });
                }

                t.databaseVersion < 1.5 && (i.ensureAllIndexes(!0), i.dirty = !0);
              }
            }
          }, g.prototype.close = function (t) {
            this.autosave && (this.autosaveDisable(), this.autosaveDirty() && (this.saveDatabase(t), t = void 0)), t && this.on("close", t), this.emit("close");
          }, g.prototype.generateChangesNotification = function (t) {
            function e(t) {
              return t.name;
            }

            var n = [],
                r = t || this.collections.map(e);
            return this.collections.forEach(function (t) {
              -1 !== r.indexOf(e(t)) && (n = n.concat(t.getChanges()));
            }), n;
          }, g.prototype.serializeChanges = function (t) {
            return JSON.stringify(this.generateChangesNotification(t));
          }, g.prototype.clearChanges = function () {
            this.collections.forEach(function (t) {
              t.flushChanges && t.flushChanges();
            });
          }, m.prototype.loadDatabase = function (t, e) {
            var n = this;
            this.options.asyncResponses ? setTimeout(function () {
              n.hashStore.hasOwnProperty(t) ? e(n.hashStore[t].value) : e(null);
            }, this.options.asyncTimeout) : this.hashStore.hasOwnProperty(t) ? e(this.hashStore[t].value) : e(null);
          }, m.prototype.saveDatabase = function (t, e, n) {
            var r,
                i = this;
            this.options.asyncResponses ? setTimeout(function () {
              r = i.hashStore.hasOwnProperty(t) ? i.hashStore[t].savecount : 0, i.hashStore[t] = {
                savecount: r + 1,
                lastsave: new Date(),
                value: e
              }, n();
            }, this.options.asyncTimeout) : (r = this.hashStore.hasOwnProperty(t) ? this.hashStore[t].savecount : 0, this.hashStore[t] = {
              savecount: r + 1,
              lastsave: new Date(),
              value: e
            }, n());
          }, m.prototype.deleteDatabase = function (t, e) {
            this.hashStore.hasOwnProperty(t) && delete this.hashStore[t], "function" == typeof e && e();
          }, w.prototype.loadDatabase = function (t, e) {
            var n = this;
            this.dbname = t, this.dbref = new g(t), this.adapter.loadDatabase(t, function (t) {
              if (t) {
                "string" != typeof t && e(new Error("LokiPartitioningAdapter received an unexpected response from inner adapter loadDatabase()"));
                var r = JSON.parse(t);
                n.dbref.loadJSONObject(r), r = null, n.dbref.collections.length, 0 !== n.dbref.collections.length ? (n.pageIterator = {
                  collection: 0,
                  pageIndex: 0
                }, n.loadNextPartition(0, function () {
                  e(n.dbref);
                })) : e(n.dbref);
              } else e(t);
            });
          }, w.prototype.loadNextPartition = function (t, e) {
            var n = this.dbname + "." + t,
                r = this;
            if (!0 === this.options.paging) return this.pageIterator.pageIndex = 0, void this.loadNextPage(e);
            this.adapter.loadDatabase(n, function (n) {
              var i = r.dbref.deserializeCollection(n, {
                delimited: !0,
                collectionIndex: t
              });
              r.dbref.collections[t].data = i, ++t < r.dbref.collections.length ? r.loadNextPartition(t, e) : e();
            });
          }, w.prototype.loadNextPage = function (t) {
            var e = this.dbname + "." + this.pageIterator.collection + "." + this.pageIterator.pageIndex,
                n = this;
            this.adapter.loadDatabase(e, function (e) {
              var r = e.split(n.options.delimiter);
              e = "";
              var i,
                  o = r.length,
                  s = "" === r[o - 1];

              for (s && (r.pop(), "" === r[(o = r.length) - 1] && 1 === o && (r.pop(), o = r.length)), i = 0; i < o; i++) {
                n.dbref.collections[n.pageIterator.collection].data.push(JSON.parse(r[i])), r[i] = null;
              }

              r = [], s ? ++n.pageIterator.collection < n.dbref.collections.length ? n.loadNextPartition(n.pageIterator.collection, t) : t() : (n.pageIterator.pageIndex++, n.loadNextPage(t));
            });
          }, w.prototype.exportDatabase = function (t, e, n) {
            var r,
                i = e.collections.length;

            for (this.dbref = e, this.dbname = t, this.dirtyPartitions = [-1], r = 0; r < i; r++) {
              e.collections[r].dirty && this.dirtyPartitions.push(r);
            }

            this.saveNextPartition(function (t) {
              n(t);
            });
          }, w.prototype.saveNextPartition = function (t) {
            var e = this,
                n = this.dirtyPartitions.shift(),
                r = this.dbname + (-1 === n ? "" : "." + n);
            if (this.options.paging && -1 !== n) return this.pageIterator = {
              collection: n,
              docIndex: 0,
              pageIndex: 0
            }, void this.saveNextPage(function (n) {
              0 === e.dirtyPartitions.length ? t(n) : e.saveNextPartition(t);
            });
            var i = this.dbref.serializeDestructured({
              partitioned: !0,
              delimited: !0,
              partition: n
            });
            this.adapter.saveDatabase(r, i, function (n) {
              n ? t(n) : 0 === e.dirtyPartitions.length ? t(null) : e.saveNextPartition(t);
            });
          }, w.prototype.saveNextPage = function (t) {
            var e = this,
                n = this.dbref.collections[this.pageIterator.collection],
                r = this.dbname + "." + this.pageIterator.collection + "." + this.pageIterator.pageIndex,
                i = 0,
                o = n.data.length,
                s = this.options.delimiter.length,
                a = "",
                u = "",
                c = !1,
                l = !1,
                h = function h(n) {
              u = "", n && t(n), c ? t(null) : (e.pageIterator.pageIndex++, e.saveNextPage(t));
            };

            for (0 === n.data.length && (c = !0);;) {
              if (c || (a = JSON.stringify(n.data[this.pageIterator.docIndex]), u += a, i += a.length, ++this.pageIterator.docIndex >= o && (c = !0)), i >= this.options.pageSize && (l = !0), l && !c || (u += this.options.delimiter, i += s), c || l) return void this.adapter.saveDatabase(r, u, h);
            }
          }, I.prototype.loadDatabase = function (t, e) {
            var n = this;
            this.fs.stat(t, function (r, i) {
              !r && i.isFile() ? n.fs.readFile(t, {
                encoding: "utf8"
              }, function (t, n) {
                e(t ? new Error(t) : n);
              }) : e(null);
            });
          }, I.prototype.saveDatabase = function (t, e, n) {
            var r = this,
                i = t + "~";
            this.fs.writeFile(i, e, function (e) {
              e ? n(new Error(e)) : r.fs.rename(i, t, n);
            });
          }, I.prototype.deleteDatabase = function (t, e) {
            this.fs.unlink(t, function (t) {
              t ? e(new Error(t)) : e();
            });
          }, x.prototype.loadDatabase = function (t, e) {
            v() ? e(localStorage.getItem(t)) : e(new Error("localStorage is not available"));
          }, x.prototype.saveDatabase = function (t, e, n) {
            v() ? (localStorage.setItem(t, e), n(null)) : n(new Error("localStorage is not available"));
          }, x.prototype.deleteDatabase = function (t, e) {
            v() ? (localStorage.removeItem(t), e(null)) : e(new Error("localStorage is not available"));
          }, g.prototype.throttledSaveDrain = function (t, e) {
            var n = this,
                r = new Date().getTime();

            if (this.throttledSaves || t(!0), (e = e || {}).hasOwnProperty("recursiveWait") || (e.recursiveWait = !0), e.hasOwnProperty("recursiveWaitLimit") || (e.recursiveWaitLimit = !1), e.hasOwnProperty("recursiveWaitLimitDuration") || (e.recursiveWaitLimitDuration = 2e3), e.hasOwnProperty("started") || (e.started = new Date().getTime()), this.throttledSaves && this.throttledSavePending) {
              if (!e.recursiveWait) return void this.throttledCallbacks.push(t);
              this.throttledCallbacks.push(function () {
                return n.throttledSavePending ? e.recursiveWaitLimit && r - e.started > e.recursiveWaitLimitDuration ? void t(!1) : void n.throttledSaveDrain(t, e) : void t(!0);
              });
            } else t(!0);
          }, g.prototype.loadDatabaseInternal = function (t, e) {
            var n = e || function (t, e) {
              if (t) throw t;
            },
                r = this;

            null !== this.persistenceAdapter ? this.persistenceAdapter.loadDatabase(this.filename, function (e) {
              if ("string" == typeof e) {
                var i = !1;

                try {
                  r.loadJSON(e, t || {}), i = !0;
                } catch (t) {
                  n(t);
                }

                i && (n(null), r.emit("loaded", "database " + r.filename + " loaded"));
              } else {
                if (!e) return n(null), void r.emit("loaded", "empty database " + r.filename + " loaded");
                if (e instanceof Error) return void n(e);
                if ("object" == typeof e) return r.loadJSONObject(e, t || {}), n(null), void r.emit("loaded", "database " + r.filename + " loaded");
                n("unexpected adapter response : " + e);
              }
            }) : n(new Error("persistenceAdapter not configured"));
          }, g.prototype.loadDatabase = function (t, e) {
            var n = this;
            this.throttledSaves ? this.throttledSaveDrain(function (r) {
              if (r) return n.throttledSavePending = !0, void n.loadDatabaseInternal(t, function (t) {
                0 === n.throttledCallbacks.length ? n.throttledSavePending = !1 : n.saveDatabase(), "function" == typeof e && e(t);
              });
              "function" == typeof e && e(new Error("Unable to pause save throttling long enough to read database"));
            }, t) : this.loadDatabaseInternal(t, e);
          }, g.prototype.saveDatabaseInternal = function (t) {
            var e = t || function (t) {
              if (t) throw t;
            },
                n = this;

            null !== this.persistenceAdapter ? "reference" === this.persistenceAdapter.mode && "function" == typeof this.persistenceAdapter.exportDatabase ? this.persistenceAdapter.exportDatabase(this.filename, this.copy({
              removeNonSerializable: !0
            }), function (t) {
              n.autosaveClearFlags(), e(t);
            }) : (n.autosaveClearFlags(), this.persistenceAdapter.saveDatabase(this.filename, n.serialize(), function (t) {
              e(t);
            })) : e(new Error("persistenceAdapter not configured"));
          }, g.prototype.saveDatabase = function (t) {
            if (this.throttledSaves) {
              if (this.throttledSavePending) this.throttledCallbacks.push(t);else {
                var e = this.throttledCallbacks;
                this.throttledCallbacks = [], e.unshift(t), this.throttledSavePending = !0;
                var n = this;
                this.saveDatabaseInternal(function (t) {
                  n.throttledSavePending = !1, e.forEach(function (e) {
                    "function" == typeof e && setTimeout(function () {
                      e(t);
                    }, 1);
                  }), n.throttledCallbacks.length > 0 && n.saveDatabase();
                });
              }
            } else this.saveDatabaseInternal(t);
          }, g.prototype.save = g.prototype.saveDatabase, g.prototype.deleteDatabase = function (t, e) {
            var n = e || function (t, e) {
              if (t) throw t;
            };

            "function" != typeof t || e || (n = t), null !== this.persistenceAdapter ? this.persistenceAdapter.deleteDatabase(this.filename, function (t) {
              n(t);
            }) : n(new Error("persistenceAdapter not configured"));
          }, g.prototype.autosaveDirty = function () {
            for (var t = 0; t < this.collections.length; t++) {
              if (this.collections[t].dirty) return !0;
            }

            return !1;
          }, g.prototype.autosaveClearFlags = function () {
            for (var t = 0; t < this.collections.length; t++) {
              this.collections[t].dirty = !1;
            }
          }, g.prototype.autosaveEnable = function (t, e) {
            this.autosave = !0;
            var n = 5e3,
                r = this;
            void 0 !== this.autosaveInterval && null !== this.autosaveInterval && (n = this.autosaveInterval), this.autosaveHandle = setInterval(function () {
              r.autosaveDirty() && r.saveDatabase(e);
            }, n);
          }, g.prototype.autosaveDisable = function () {
            void 0 !== this.autosaveHandle && null !== this.autosaveHandle && (clearInterval(this.autosaveHandle), this.autosaveHandle = null);
          }, k.prototype.reset = function () {
            return this.filteredrows.length > 0 && (this.filteredrows = []), this.filterInitialized = !1, this;
          }, k.prototype.toJSON = function () {
            var t = this.copy();
            return t.collection = null, t;
          }, k.prototype.limit = function (t) {
            this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex());
            var e = new k(this.collection);
            return e.filteredrows = this.filteredrows.slice(0, t), e.filterInitialized = !0, e;
          }, k.prototype.offset = function (t) {
            this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex());
            var e = new k(this.collection);
            return e.filteredrows = this.filteredrows.slice(t), e.filterInitialized = !0, e;
          }, k.prototype.copy = function () {
            var t = new k(this.collection);
            return this.filteredrows.length > 0 && (t.filteredrows = this.filteredrows.slice()), t.filterInitialized = this.filterInitialized, t;
          }, k.prototype.branch = k.prototype.copy, k.prototype.transform = function (t, n) {
            var r,
                i,
                o = this;
            if ("string" == typeof t && this.collection.transforms.hasOwnProperty(t) && (t = this.collection.transforms[t]), "object" != typeof t || !Array.isArray(t)) throw new Error("Invalid transform");

            for (void 0 !== n && (t = e.resolveTransformParams(t, n)), r = 0; r < t.length; r++) {
              switch ((i = t[r]).type) {
                case "find":
                  o.find(i.value);
                  break;

                case "where":
                  o.where(i.value);
                  break;

                case "simplesort":
                  o.simplesort(i.property, i.desc || i.options);
                  break;

                case "compoundsort":
                  o.compoundsort(i.value);
                  break;

                case "sort":
                  o.sort(i.value);
                  break;

                case "limit":
                  o = o.limit(i.value);
                  break;

                case "offset":
                  o = o.offset(i.value);
                  break;

                case "map":
                  o = o.map(i.value, i.dataOptions);
                  break;

                case "eqJoin":
                  o = o.eqJoin(i.joinData, i.leftJoinKey, i.rightJoinKey, i.mapFun, i.dataOptions);
                  break;

                case "mapReduce":
                  o = o.mapReduce(i.mapFunction, i.reduceFunction);
                  break;

                case "update":
                  o.update(i.value);
                  break;

                case "remove":
                  o.remove();
              }
            }

            return o;
          }, k.prototype.sort = function (t) {
            this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex());
            var e,
                n,
                r = (e = t, n = this.collection.data, function (t, r) {
              return e(n[t], n[r]);
            });
            return this.filteredrows.sort(r), this;
          }, k.prototype.simplesort = function (t, n) {
            var r,
                i = 10,
                o = this.collection.data.length,
                s = this.filteredrows.length,
                a = this.collection.binaryIndices.hasOwnProperty(t);

            if (void 0 !== n && !1 !== n || (n = {
              desc: !1
            }), !0 === n && (n = {
              desc: !0
            }), 0 === s) {
              if (this.filterInitialized) return this;
              if (this.collection.binaryIndices.hasOwnProperty(t)) return this.collection.ensureIndex(t), this.filteredrows = this.collection.binaryIndices[t].values.slice(0), n.desc && this.filteredrows.reverse(), this;
              this.filteredrows = this.collection.prepareFullDocIndex();
            } else if (!n.disableIndexIntersect && a && (r = o / s, n.useJavascriptSorting && (i = 6), r <= i || n.forceIndexIntersect)) {
              var u,
                  l = this.filteredrows,
                  h = {};

              for (u = 0; u < s; u++) {
                h[l[u]] = !0;
              }

              var f = this.collection.binaryIndices[t].values;
              return this.filteredrows = f.filter(function (t) {
                return h[t];
              }), n.desc && this.filteredrows.reverse(), this;
            }

            if (n.useJavascriptSorting) return this.sort(function (e, n) {
              return e[t] === n[t] ? 0 : e[t] > n[t] ? 1 : e[t] < n[t] ? -1 : void 0;
            });
            var p,
                d,
                y,
                v,
                b,
                g,
                m = (p = t, d = n.desc, y = this.collection.data, function (t, n) {
              return ~p.indexOf(".") ? (g = p.split("."), v = e.getIn(y[t], g, !0), b = e.getIn(y[n], g, !0)) : (v = y[t][p], b = y[n][p]), c(v, b, d);
            });
            return this.filteredrows.sort(m), this;
          }, k.prototype.compoundsort = function (t) {
            if (0 === t.length) throw new Error("Invalid call to compoundsort, need at least one property");
            var n;
            if (1 === t.length) return n = t[0], Array.isArray(n) ? this.simplesort(n[0], n[1]) : this.simplesort(n, !1);

            for (var r = 0, i = t.length; r < i; r += 1) {
              n = t[r], Array.isArray(n) || (t[r] = [n, !1]);
            }

            this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex());
            var o,
                s,
                a = (o = t, s = this.collection.data, function (t, n) {
              return function (t, n, r) {
                for (var i, o, s, a, u, l = 0, h = 0, f = t.length; h < f; h++) {
                  if (~(o = (i = t[h])[0]).indexOf(".") ? (u = o.split("."), s = e.getIn(n, u, !0), a = e.getIn(r, u, !0)) : (s = n[o], a = r[o]), 0 !== (l = c(s, a, i[1]))) return l;
                }

                return 0;
              }(o, s[t], s[n]);
            });
            return this.filteredrows.sort(a), this;
          }, k.prototype.findOr = function (t) {
            for (var e = null, n = 0, r = 0, i = [], o = [], s = 0, a = (this.count(), 0), u = t.length; a < u; a++) {
              for (r = (e = this.branch().find(t[a]).filteredrows).length, n = 0; n < r; n++) {
                void 0 === o[s = e[n]] && (o[s] = !0, i.push(s));
              }
            }

            return this.filteredrows = i, this.filterInitialized = !0, this;
          }, k.prototype.$or = k.prototype.findOr, k.prototype.findAnd = function (t) {
            for (var e = 0, n = t.length; e < n; e++) {
              if (0 === this.count()) return this;
              this.find(t[e]);
            }

            return this;
          }, k.prototype.$and = k.prototype.findAnd, k.prototype.find = function (n, r) {
            if (0 === this.collection.data.length) return this.filteredrows = [], this.filterInitialized = !0, this;
            var i,
                o,
                s,
                a,
                u,
                c,
                h,
                f = n || "getAll",
                y = !1,
                v = [],
                b = [],
                g = null;

            if (r = r || !1, "object" == typeof f) {
              for (i in f) {
                (a = {})[i] = f[i], b.push(a), t.call(f, i) && (o = i, s = f[i]);
              }

              if (b.length > 1) return this.find({
                $and: b
              }, r);
            }

            if (!o || "getAll" === f) return r && (this.filterInitialized ? this.filteredrows = this.filteredrows.slice(0, 1) : (this.filteredrows = this.collection.data.length > 0 ? [0] : [], this.filterInitialized = !0)), this;
            if ("$and" === o || "$or" === o) return this[o](s), r && this.filteredrows.length > 1 && (this.filteredrows = this.filteredrows.slice(0, 1)), this;
            if (null === s || "object" != typeof s || s instanceof Date) u = "$eq", c = s;else {
              if ("object" != typeof s) throw new Error("Do not know what you want to do.");

              for (h in s) {
                if (t.call(s, h)) {
                  u = h, c = s[h];
                  break;
                }
              }
            }
            "$regex" !== u && "object" != typeof c || (c = function t(e, n) {
              if ("$regex" === e) Array.isArray(n) ? n = new RegExp(n[0], n[1]) : n instanceof RegExp || (n = new RegExp(n));else if ("object" == typeof n) for (var r in n) {
                "$regex" !== r && "object" != typeof n[r] || (n[r] = t(r, n[r]));
              }
              return n;
            }(u, c));
            var m = -1 !== o.indexOf(".");
            !this.filterInitialized && this.collection.binaryIndices[o] && d[u] && (!0 !== this.collection.adaptiveBinaryIndices && this.collection.ensureIndex(o), y = !0, g = this.collection.binaryIndices[o]);
            var w,
                I = p[u],
                x = this.collection.data,
                k = 0,
                E = 0,
                O = 0;

            if (this.filterInitialized) {
              if (E = (w = this.filteredrows).length, m) {
                for (o = o.split("."), k = 0; k < E; k++) {
                  if (l(x[O = w[k]], o, I, c) && (v.push(O), r)) return this.filteredrows = v, this;
                }
              } else for (k = 0; k < E; k++) {
                if (I(x[O = w[k]][o], c) && (v.push(O), r)) return this.filteredrows = v, this;
              }
            } else if (y) {
              var S = this.collection.calculateRange(u, o, c);

              if ("$in" !== u) {
                for (k = S[0]; k <= S[1]; k++) {
                  if (!0 !== d[u]) {
                    if (d[u](e.getIn(x[g.values[k]], o, m), c) && (v.push(g.values[k]), r)) return this.filteredrows = v, this.filterInitialized = !0, this;
                  } else if (v.push(g.values[k]), r) return this.filteredrows = v, this.filterInitialized = !0, this;
                }
              } else for (k = 0, E = S.length; k < E; k++) {
                if (v.push(g.values[S[k]]), r) return this.filteredrows = v, this.filterInitialized = !0, this;
              }
            } else if (E = x.length, m) {
              for (o = o.split("."), k = 0; k < E; k++) {
                if (l(x[k], o, I, c) && (v.push(k), r)) return this.filteredrows = v, this.filterInitialized = !0, this;
              }
            } else for (k = 0; k < E; k++) {
              if (I(x[k][o], c) && (v.push(k), r)) return this.filteredrows = v, this.filterInitialized = !0, this;
            }

            return this.filteredrows = v, this.filterInitialized = !0, this;
          }, k.prototype.where = function (t) {
            var e,
                n = [];
            if ("function" != typeof t) throw new TypeError("Argument is not a stored view or a function");
            e = t;

            try {
              if (this.filterInitialized) {
                for (var r = this.filteredrows.length; r--;) {
                  !0 === e(this.collection.data[this.filteredrows[r]]) && n.push(this.filteredrows[r]);
                }

                return this.filteredrows = n, this;
              }

              for (var i = this.collection.data.length; i--;) {
                !0 === e(this.collection.data[i]) && n.push(i);
              }

              return this.filteredrows = n, this.filterInitialized = !0, this;
            } catch (t) {
              throw t;
            }
          }, k.prototype.count = function () {
            return this.filterInitialized ? this.filteredrows.length : this.collection.count();
          }, k.prototype.data = function (t) {
            var e,
                n,
                r,
                i,
                o = [],
                s = this.collection.data;

            if ((t = t || {}).removeMeta && !t.forceClones && (t.forceClones = !0, t.forceCloneMethod = t.forceCloneMethod || "shallow"), this.collection.disableDeltaChangesApi || (t.forceClones = !0, t.forceCloneMethod = "parse-stringify"), !this.filterInitialized) {
              if (0 === this.filteredrows.length) {
                if (this.collection.cloneObjects || t.forceClones) {
                  for (n = s.length, i = t.forceCloneMethod || this.collection.cloneMethod, r = 0; r < n; r++) {
                    e = y(s[r], i), t.removeMeta && (delete e.$loki, delete e.meta), o.push(e);
                  }

                  return o;
                }

                return s.slice();
              }

              this.filterInitialized = !0;
            }

            var a = this.filteredrows;
            if (n = a.length, this.collection.cloneObjects || t.forceClones) for (i = t.forceCloneMethod || this.collection.cloneMethod, r = 0; r < n; r++) {
              e = y(s[a[r]], i), t.removeMeta && (delete e.$loki, delete e.meta), o.push(e);
            } else for (r = 0; r < n; r++) {
              o.push(s[a[r]]);
            }
            return o;
          }, k.prototype.update = function (t) {
            if ("function" != typeof t) throw new TypeError("Argument is not a function");
            this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex());

            for (var e, n = this.filteredrows.length, r = this.collection.data, i = 0; i < n; i++) {
              this.collection.cloneObjects || !this.collection.disableDeltaChangesApi ? (t(e = y(r[this.filteredrows[i]], this.collection.cloneMethod)), this.collection.update(e)) : (t(r[this.filteredrows[i]]), this.collection.update(r[this.filteredrows[i]]));
            }

            return this;
          }, k.prototype.remove = function () {
            return this.filterInitialized || 0 !== this.filteredrows.length || (this.filteredrows = this.collection.prepareFullDocIndex()), this.collection.removeBatchByPositions(this.filteredrows), this.filteredrows = [], this;
          }, k.prototype.mapReduce = function (t, e) {
            try {
              return e(this.data().map(t));
            } catch (t) {
              throw t;
            }
          }, k.prototype.eqJoin = function (t, e, n, r, i) {
            var o,
                s,
                a,
                u,
                c = [],
                l = [],
                h = "function" == typeof e,
                f = "function" == typeof n,
                p = {};
            if (s = (o = this.data(i)).length, t instanceof O) c = t.chain().data(i);else if (t instanceof k) c = t.data(i);else {
              if (!Array.isArray(t)) throw new TypeError("joinData needs to be an array or result set");
              c = t;
            }
            a = c.length;

            for (var d = 0; d < a; d++) {
              p[u = f ? n(c[d]) : c[d][n]] = c[d];
            }

            r || (r = function r(t, e) {
              return {
                left: t,
                right: e
              };
            });

            for (var y = 0; y < s; y++) {
              u = h ? e(o[y]) : o[y][e], l.push(r(o[y], p[u] || {}));
            }

            return this.collection = new O("joinData"), this.collection.insert(l), this.filteredrows = [], this.filterInitialized = !1, this;
          }, k.prototype.map = function (t, e) {
            var n = this.data(e).map(t);
            return this.collection = new O("mappedData"), this.collection.insert(n), this.filteredrows = [], this.filterInitialized = !1, this;
          }, E.prototype = new b(), E.prototype.rematerialize = function (t) {
            var e, n, r;
            if (t = t || {}, this.resultdata = [], this.resultsdirty = !0, this.resultset = new k(this.collection), (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple) && (this.sortDirty = !0), t.hasOwnProperty("removeWhereFilters")) for (n = e = this.filterPipeline.length; n--;) {
              "where" === this.filterPipeline[n].type && (n !== this.filterPipeline.length - 1 && (this.filterPipeline[n] = this.filterPipeline[this.filterPipeline.length - 1]), this.filterPipeline.length--);
            }
            var i = this.filterPipeline;

            for (this.filterPipeline = [], e = i.length, r = 0; r < e; r++) {
              this.applyFind(i[r].val);
            }

            return this.data(), this.emit("rebuild", this), this;
          }, E.prototype.branchResultset = function (t, e) {
            var n = this.resultset.branch();
            return void 0 === t ? n : n.transform(t, e);
          }, E.prototype.toJSON = function () {
            var t = new E(this.collection, this.name, this.options);
            return t.resultset = this.resultset, t.resultdata = [], t.resultsdirty = !0, t.filterPipeline = this.filterPipeline, t.sortFunction = this.sortFunction, t.sortCriteria = this.sortCriteria, t.sortCriteriaSimple = this.sortCriteriaSimple || null, t.sortDirty = this.sortDirty, t.collection = null, t;
          }, E.prototype.removeFilters = function (t) {
            t = t || {}, this.rebuildPending = !1, this.resultset.reset(), this.resultdata = [], this.resultsdirty = !0, this.cachedresultset = null, this.filterPipeline = [], this.sortFunction = null, this.sortCriteria = null, this.sortCriteriaSimple = null, this.sortDirty = !1, !0 === t.queueSortPhase && this.queueSortPhase();
          }, E.prototype.applySort = function (t) {
            return this.sortFunction = t, this.sortCriteria = null, this.sortCriteriaSimple = null, this.queueSortPhase(), this;
          }, E.prototype.applySimpleSort = function (t, e) {
            return this.sortCriteriaSimple = {
              propname: t,
              options: e || !1
            }, this.sortCriteria = null, this.sortFunction = null, this.queueSortPhase(), this;
          }, E.prototype.applySortCriteria = function (t) {
            return this.sortCriteria = t, this.sortCriteriaSimple = null, this.sortFunction = null, this.queueSortPhase(), this;
          }, E.prototype.startTransaction = function () {
            return this.cachedresultset = this.resultset.copy(), this;
          }, E.prototype.commit = function () {
            return this.cachedresultset = null, this;
          }, E.prototype.rollback = function () {
            return this.resultset = this.cachedresultset, this.options.persistent && (this.resultdata = this.resultset.data(), this.emit("rebuild", this)), this;
          }, E.prototype._indexOfFilterWithId = function (t) {
            if ("string" == typeof t || "number" == typeof t) for (var e = 0, n = this.filterPipeline.length; e < n; e += 1) {
              if (t === this.filterPipeline[e].uid) return e;
            }
            return -1;
          }, E.prototype._addFilter = function (t) {
            this.filterPipeline.push(t), this.resultset[t.type](t.val);
          }, E.prototype.reapplyFilters = function () {
            this.resultset.reset(), this.cachedresultset = null, this.options.persistent && (this.resultdata = [], this.resultsdirty = !0);
            var t = this.filterPipeline;
            this.filterPipeline = [];

            for (var e = 0, n = t.length; e < n; e += 1) {
              this._addFilter(t[e]);
            }

            return this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent(), this;
          }, E.prototype.applyFilter = function (t) {
            var e = this._indexOfFilterWithId(t.uid);

            return e >= 0 ? (this.filterPipeline[e] = t, this.reapplyFilters()) : (this.cachedresultset = null, this.options.persistent && (this.resultdata = [], this.resultsdirty = !0), this._addFilter(t), this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent(), this);
          }, E.prototype.applyFind = function (t, e) {
            return this.applyFilter({
              type: "find",
              val: t,
              uid: e
            }), this;
          }, E.prototype.applyWhere = function (t, e) {
            return this.applyFilter({
              type: "where",
              val: t,
              uid: e
            }), this;
          }, E.prototype.removeFilter = function (t) {
            var e = this._indexOfFilterWithId(t);

            if (e < 0) throw new Error("Dynamic view does not contain a filter with ID: " + t);
            return this.filterPipeline.splice(e, 1), this.reapplyFilters(), this;
          }, E.prototype.count = function () {
            return this.resultsdirty && (this.resultdata = this.resultset.data()), this.resultset.count();
          }, E.prototype.data = function (t) {
            return (this.sortDirty || this.resultsdirty) && this.performSortPhase({
              suppressRebuildEvent: !0
            }), this.options.persistent ? this.resultdata : this.resultset.data(t);
          }, E.prototype.queueRebuildEvent = function () {
            if (!this.rebuildPending) {
              this.rebuildPending = !0;
              var t = this;
              setTimeout(function () {
                t.rebuildPending && (t.rebuildPending = !1, t.emit("rebuild", t));
              }, this.options.minRebuildInterval);
            }
          }, E.prototype.queueSortPhase = function () {
            if (!this.sortDirty) {
              this.sortDirty = !0;
              var t = this;
              "active" === this.options.sortPriority ? setTimeout(function () {
                t.performSortPhase();
              }, this.options.minRebuildInterval) : this.queueRebuildEvent();
            }
          }, E.prototype.performSortPhase = function (t) {
            (this.sortDirty || this.resultsdirty) && (t = t || {}, this.sortDirty && (this.sortFunction ? this.resultset.sort(this.sortFunction) : this.sortCriteria ? this.resultset.compoundsort(this.sortCriteria) : this.sortCriteriaSimple && this.resultset.simplesort(this.sortCriteriaSimple.propname, this.sortCriteriaSimple.options), this.sortDirty = !1), this.options.persistent && (this.resultdata = this.resultset.data(), this.resultsdirty = !1), t.suppressRebuildEvent || this.emit("rebuild", this));
          }, E.prototype.evaluateDocument = function (t, e) {
            if (!this.resultset.filterInitialized) return this.options.persistent && (this.resultdata = this.resultset.data()), void (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent());
            var n,
                r = this.resultset.filteredrows,
                i = e ? -1 : r.indexOf(+t),
                o = r.length,
                s = new k(this.collection);
            s.filteredrows = [t], s.filterInitialized = !0;

            for (var a = 0, u = this.filterPipeline.length; a < u; a++) {
              s[(n = this.filterPipeline[a]).type](n.val);
            }

            var c = 0 === s.filteredrows.length ? -1 : 0;
            return -1 !== i || -1 !== c ? -1 === i && -1 !== c ? (r.push(t), this.options.persistent && this.resultdata.push(this.collection.data[t]), void (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent())) : -1 !== i && -1 === c ? (i < o - 1 ? (r.splice(i, 1), this.options.persistent && this.resultdata.splice(i, 1)) : (r.length = o - 1, this.options.persistent && (this.resultdata.length = o - 1)), void (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent())) : -1 !== i && -1 !== c ? (this.options.persistent && (this.resultdata[i] = this.collection.data[t]), void (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent())) : void 0 : void 0;
          }, E.prototype.removeDocument = function (t) {
            var e,
                n,
                r,
                i = {},
                o = {},
                s = [],
                a = this.resultset,
                u = this.resultset.filteredrows,
                c = u.length;
            if (!this.resultset.filterInitialized) return this.options.persistent && (this.resultdata = this.resultset.data()), void (this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent());

            for (Array.isArray(t) || (t = [t]), r = t.length, n = 0; n < r; n++) {
              i[t[n]] = !0;
            }

            for (e = 0; e < c; e++) {
              i[u[e]] && (o[e] = !0);
            }

            Object.keys(o).length > 0 && (this.resultset.filteredrows = this.resultset.filteredrows.filter(function (t, e) {
              return !o[e];
            }), this.options.persistent && (this.resultdata = this.resultdata.filter(function (t, e) {
              return !o[e];
            })), this.sortFunction || this.sortCriteria || this.sortCriteriaSimple ? this.queueSortPhase() : this.queueRebuildEvent());

            var l = function l(t) {
              return function (e) {
                return e < a.filteredrows[t];
              };
            };

            for (c = a.filteredrows.length, e = 0; e < c; e++) {
              s = t.filter(l(e)), a.filteredrows[e] -= s.length;
            }
          }, E.prototype.mapReduce = function (t, e) {
            try {
              return e(this.data().map(t));
            } catch (t) {
              throw t;
            }
          }, O.prototype = new b(), O.prototype.createChange = function (t, e, n, r) {
            this.changes.push({
              name: t,
              operation: e,
              obj: "U" != e || this.disableDeltaChangesApi ? JSON.parse(JSON.stringify(n)) : this.getChangeDelta(n, r)
            });
          }, O.prototype.insertMeta = function (t) {
            var e, n;
            if (!this.disableMeta && t) if (Array.isArray(t)) for (e = t.length, n = 0; n < e; n++) {
              t[n].hasOwnProperty("meta") || (t[n].meta = {}), t[n].meta.created = new Date().getTime(), t[n].meta.revision = 0;
            } else t.meta || (t.meta = {}), t.meta.created = new Date().getTime(), t.meta.revision = 0;
          }, O.prototype.updateMeta = function (t) {
            !this.disableMeta && t && (t.meta.updated = new Date().getTime(), t.meta.revision += 1);
          }, O.prototype.createInsertChange = function (t) {
            this.createChange(this.name, "I", t);
          }, O.prototype.createUpdateChange = function (t, e) {
            this.createChange(this.name, "U", t, e);
          }, O.prototype.insertMetaWithChange = function (t) {
            this.insertMeta(t), this.createInsertChange(t);
          }, O.prototype.updateMetaWithChange = function (t, e) {
            this.updateMeta(t), this.createUpdateChange(t, e);
          }, O.prototype.lokiConsoleWrapper = {
            log: function log() {},
            warn: function warn() {},
            error: function error() {}
          }, O.prototype.addAutoUpdateObserver = function (t) {
            this.autoupdate && "function" == typeof Object.observe && Object.observe(t, this.observerCallback, ["add", "update", "delete", "reconfigure", "setPrototype"]);
          }, O.prototype.removeAutoUpdateObserver = function (t) {
            this.autoupdate && "function" == typeof Object.observe && Object.unobserve(t, this.observerCallback);
          }, O.prototype.addTransform = function (t, e) {
            if (this.transforms.hasOwnProperty(t)) throw new Error("a transform by that name already exists");
            this.transforms[t] = e;
          }, O.prototype.getTransform = function (t) {
            return this.transforms[t];
          }, O.prototype.setTransform = function (t, e) {
            this.transforms[t] = e;
          }, O.prototype.removeTransform = function (t) {
            delete this.transforms[t];
          }, O.prototype.byExample = function (t) {
            var e, n, r;

            for (e in r = [], t) {
              t.hasOwnProperty(e) && r.push(((n = {})[e] = t[e], n));
            }

            return {
              $and: r
            };
          }, O.prototype.findObject = function (t) {
            return this.findOne(this.byExample(t));
          }, O.prototype.findObjects = function (t) {
            return this.find(this.byExample(t));
          }, O.prototype.ttlDaemonFuncGen = function () {
            var t = this,
                e = this.ttl.age;
            return function () {
              var n = Date.now();
              t.chain().where(function (t) {
                var r = t.meta.updated || t.meta.created;
                return e < n - r;
              }).remove();
            };
          }, O.prototype.setTTL = function (t, e) {
            t < 0 ? clearInterval(this.ttl.daemon) : (this.ttl.age = t, this.ttl.ttlInterval = e, this.ttl.daemon = setInterval(this.ttlDaemonFuncGen(), e));
          }, O.prototype.prepareFullDocIndex = function () {
            for (var t = this.data.length, e = new Array(t), n = 0; n < t; n += 1) {
              e[n] = n;
            }

            return e;
          }, O.prototype.configureOptions = function (t) {
            (t = t || {}).hasOwnProperty("adaptiveBinaryIndices") && (this.adaptiveBinaryIndices = t.adaptiveBinaryIndices, this.adaptiveBinaryIndices && this.ensureAllIndexes());
          }, O.prototype.ensureIndex = function (t, n) {
            if (void 0 === n && (n = !1), null == t) throw new Error("Attempting to set index without an associated property");

            if ((!this.binaryIndices[t] || n || this.binaryIndices[t].dirty) && (!0 !== this.adaptiveBinaryIndices || !this.binaryIndices.hasOwnProperty(t) || n)) {
              var r = {
                name: t,
                dirty: !0,
                values: this.prepareFullDocIndex()
              };
              this.binaryIndices[t] = r;
              var i,
                  s,
                  a,
                  u,
                  c,
                  l = (i = t, s = this.data, function (t, n) {
                if (~i.indexOf(".") ? (c = i.split("."), a = e.getIn(s[t], c, !0), u = e.getIn(s[n], c, !0)) : (a = s[t][i], u = s[n][i]), a !== u) {
                  if (o.lt(a, u, !1)) return -1;
                  if (o.gt(a, u, !1)) return 1;
                }

                return 0;
              });
              r.values.sort(l), r.dirty = !1, this.dirty = !0;
            }
          }, O.prototype.checkAllIndexes = function (e) {
            var n,
                r = this.binaryIndices,
                i = [];

            for (n in r) {
              t.call(r, n) && (this.checkIndex(n, e) || i.push(n));
            }

            return i;
          }, O.prototype.checkIndex = function (t, n) {
            (n = n || {}).randomSamplingFactor && !1 !== n.randomSampling && (n.randomSampling = !0), n.randomSamplingFactor = n.randomSamplingFactor || .1, (n.randomSamplingFactor < 0 || n.randomSamplingFactor > 1) && (n.randomSamplingFactor = .1);
            var r,
                i,
                o,
                s,
                a,
                u = !0;
            if (!this.binaryIndices.hasOwnProperty(t)) throw new Error("called checkIndex on property without an index: " + t);
            if (this.adaptiveBinaryIndices || this.ensureIndex(t), (s = (a = this.binaryIndices[t].values).length) !== this.data.length) return n.repair && this.ensureIndex(t, !0), !1;
            if (0 === s) return !0;
            var c = -1 !== t.indexOf(".");
            if (1 === s) u = 0 === a[0];else if (n.randomSampling) {
              if (p.$lte(e.getIn(this.data[a[0]], t, c), e.getIn(this.data[a[1]], t, c)) || (u = !1), p.$lte(e.getIn(this.data[a[s - 2]], t, c), e.getIn(this.data[a[s - 1]], t, c)) || (u = !1), u) for (i = Math.floor((s - 1) * n.randomSamplingFactor), r = 0; r < i - 1; r++) {
                if (o = Math.floor(Math.random() * (s - 1)), !p.$lte(e.getIn(this.data[a[o]], t, c), e.getIn(this.data[a[o + 1]], t, c))) {
                  u = !1;
                  break;
                }
              }
            } else for (r = 0; r < s - 1; r++) {
              if (!p.$lte(e.getIn(this.data[a[r]], t, c), e.getIn(this.data[a[r + 1]], t, c))) {
                u = !1;
                break;
              }
            }
            return !u && n.repair && this.ensureIndex(t, !0), u;
          }, O.prototype.getBinaryIndexValues = function (t) {
            var n,
                r = this.binaryIndices[t].values,
                i = [];

            for (n = 0; n < r.length; n++) {
              i.push(e.getIn(this.data[r[n]], t, !0));
            }

            return i;
          }, O.prototype.ensureUniqueIndex = function (t) {
            var e = this.constraints.unique[t];
            return e || -1 == this.uniqueNames.indexOf(t) && this.uniqueNames.push(t), this.constraints.unique[t] = e = new N(t), this.data.forEach(function (t) {
              e.set(t);
            }), e;
          }, O.prototype.ensureAllIndexes = function (e) {
            var n,
                r = this.binaryIndices;

            for (n in r) {
              t.call(r, n) && this.ensureIndex(n, e);
            }
          }, O.prototype.flagBinaryIndexesDirty = function () {
            var e,
                n = this.binaryIndices;

            for (e in n) {
              t.call(n, e) && (n[e].dirty = !0);
            }
          }, O.prototype.flagBinaryIndexDirty = function (t) {
            this.binaryIndices[t] && (this.binaryIndices[t].dirty = !0);
          }, O.prototype.count = function (t) {
            return t ? this.chain().find(t).filteredrows.length : this.data.length;
          }, O.prototype.ensureId = function () {
            var t = this.data.length,
                e = 0;

            for (this.idIndex = []; e < t; e += 1) {
              this.idIndex.push(this.data[e].$loki);
            }
          }, O.prototype.ensureIdAsync = function (t) {
            this.async(function () {
              this.ensureId();
            }, t);
          }, O.prototype.addDynamicView = function (t, e) {
            var n = new E(this, t, e);
            return this.DynamicViews.push(n), n;
          }, O.prototype.removeDynamicView = function (t) {
            this.DynamicViews = this.DynamicViews.filter(function (e) {
              return e.name !== t;
            });
          }, O.prototype.getDynamicView = function (t) {
            for (var e = 0; e < this.DynamicViews.length; e++) {
              if (this.DynamicViews[e].name === t) return this.DynamicViews[e];
            }

            return null;
          }, O.prototype.findAndUpdate = function (t, e) {
            "function" == typeof t ? this.updateWhere(t, e) : this.chain().find(t).update(e);
          }, O.prototype.findAndRemove = function (t) {
            this.chain().find(t).remove();
          }, O.prototype.insert = function (t) {
            if (!Array.isArray(t)) return this.insertOne(t);
            var e,
                n = [];
            this.emit("pre-insert", t);

            for (var r = 0, i = t.length; r < i; r++) {
              if (!(e = this.insertOne(t[r], !0))) return;
              n.push(e);
            }

            return this.emit("insert", n), 1 === (n = this.cloneObjects ? y(n, this.cloneMethod) : n).length ? n[0] : n;
          }, O.prototype.insertOne = function (t, e) {
            var n,
                r = null;
            if ("object" != typeof t ? r = new TypeError("Document needs to be an object") : null === t && (r = new TypeError("Object cannot be null")), null !== r) throw this.emit("error", r), r;
            var i = this.cloneObjects ? y(t, this.cloneMethod) : t;
            if (this.disableMeta || void 0 !== i.meta || (i.meta = {
              revision: 0,
              created: 0
            }), e || this.emit("pre-insert", i), this.add(i)) return this.disableChangesApi ? this.insertMeta(i) : this.insertMetaWithChange(i), n = this.cloneObjects ? y(i, this.cloneMethod) : i, e || this.emit("insert", n), this.addAutoUpdateObserver(n), n;
          }, O.prototype.clear = function (t) {
            var e = this;
            t = t || {}, this.data = [], this.idIndex = [], this.cachedIndex = null, this.cachedBinaryIndex = null, this.cachedData = null, this.maxId = 0, this.DynamicViews = [], this.dirty = !0, !0 === t.removeIndices ? (this.binaryIndices = {}, this.constraints = {
              unique: {},
              exact: {}
            }, this.uniqueNames = []) : (Object.keys(this.binaryIndices).forEach(function (t) {
              e.binaryIndices[t].dirty = !1, e.binaryIndices[t].values = [];
            }), this.constraints = {
              unique: {},
              exact: {}
            }, this.uniqueNames.forEach(function (t) {
              e.ensureUniqueIndex(t);
            }));
          }, O.prototype.update = function (e) {
            var n, r, i;

            if (Array.isArray(e)) {
              i = e.length, (n = !this.cloneObjects && this.adaptiveBinaryIndices && Object.keys(this.binaryIndices).length > 0) && (this.adaptiveBinaryIndices = !1);

              try {
                for (r = 0; r < i; r += 1) {
                  this.update(e[r]);
                }
              } finally {
                n && (this.ensureAllIndexes(), this.adaptiveBinaryIndices = !0);
              }
            } else {
              if (!t.call(e, "$loki")) throw new Error("Trying to update unsynced document. Please save the document first by using insert() or addMany()");

              try {
                this.startTransaction();
                var o,
                    s,
                    a,
                    u,
                    c,
                    l = this.get(e.$loki, !0),
                    h = this;
                if (!l) throw new Error("Trying to update a document not in collection.");
                o = l[0], a = l[1], s = this.cloneObjects || !this.disableDeltaChangesApi ? y(e, this.cloneMethod) : e, this.emit("pre-update", e), Object.keys(this.constraints.unique).forEach(function (t) {
                  h.constraints.unique[t].update(o, s);
                }), this.data[a] = s, s !== e && this.addAutoUpdateObserver(e);

                for (var f = 0; f < this.DynamicViews.length; f++) {
                  this.DynamicViews[f].evaluateDocument(a, !1);
                }

                if (this.adaptiveBinaryIndices) {
                  var p = this.binaryIndices;

                  for (u in p) {
                    this.adaptiveBinaryIndexUpdate(a, u);
                  }
                } else this.flagBinaryIndexesDirty();

                return this.idIndex[a] = s.$loki, this.commit(), this.dirty = !0, this.disableChangesApi ? this.updateMeta(s, null) : this.updateMetaWithChange(s, o), c = this.cloneObjects ? y(s, this.cloneMethod) : s, this.emit("update", c, o), c;
              } catch (t) {
                throw this.rollback(), this.lokiConsoleWrapper.error(t.message), this.emit("error", t), t;
              }
            }
          }, O.prototype.add = function (e) {
            if ("object" != typeof e) throw new TypeError("Object being added needs to be an object");
            if (void 0 !== e.$loki) throw new Error("Document is already in collection, please use update()");

            try {
              this.startTransaction(), this.maxId++, isNaN(this.maxId) && (this.maxId = this.data[this.data.length - 1].$loki + 1), e.$loki = this.maxId, this.disableMeta || (e.meta.version = 0);
              var n,
                  r = this.constraints.unique;

              for (n in r) {
                t.call(r, n) && r[n].set(e);
              }

              this.idIndex.push(e.$loki), this.data.push(e);

              for (var i = this.data.length - 1, o = this.DynamicViews.length, s = 0; s < o; s++) {
                this.DynamicViews[s].evaluateDocument(i, !0);
              }

              if (this.adaptiveBinaryIndices) {
                var a = this.binaryIndices;

                for (n in a) {
                  this.adaptiveBinaryIndexInsert(i, n);
                }
              } else this.flagBinaryIndexesDirty();

              return this.commit(), this.dirty = !0, this.cloneObjects ? y(e, this.cloneMethod) : e;
            } catch (t) {
              throw this.rollback(), this.lokiConsoleWrapper.error(t.message), this.emit("error", t), t;
            }
          }, O.prototype.updateWhere = function (t, e) {
            var n,
                r = this.where(t),
                i = 0;

            try {
              for (; i < r.length; i++) {
                n = e(r[i]), this.update(n);
              }
            } catch (t) {
              this.rollback(), this.lokiConsoleWrapper.error(t.message);
            }
          }, O.prototype.removeWhere = function (t) {
            var e;
            "function" == typeof t ? (e = this.data.filter(t), this.remove(e)) : this.chain().find(t).remove();
          }, O.prototype.removeDataOnly = function () {
            this.remove(this.data.slice());
          }, O.prototype.removeBatchByPositions = function (t) {
            var e,
                n,
                r,
                i,
                o = t.length,
                s = {},
                a = Object.keys(this.binaryIndices).length,
                u = Object.keys(this.constraints.unique).length,
                c = this.adaptiveBinaryIndices && Object.keys(this.binaryIndices).length > 0,
                l = this;

            try {
              for (this.startTransaction(), r = 0; r < o; r++) {
                s[this.idIndex[t[r]]] = !0;
              }

              if ((e = this.DynamicViews.length) > 0 || a > 0 || u > 0) {
                if (e > 0) for (n = 0; n < e; n++) {
                  this.DynamicViews[n].removeDocument(t);
                }

                if (this.adaptiveBinaryIndices && !c) {
                  var h,
                      f = this.binaryIndices;

                  for (h in f) {
                    this.adaptiveBinaryIndexRemove(t, h);
                  }
                } else this.flagBinaryIndexesDirty();

                u && Object.keys(this.constraints.unique).forEach(function (e) {
                  for (r = 0; r < o; r++) {
                    null !== (i = l.data[t[r]])[e] && void 0 !== i[e] && l.constraints.unique[e].remove(i[e]);
                  }
                });
              }

              if (!this.disableChangesApi || this.events.delete.length > 1) for (r = 0; r < o; r++) {
                this.emit("delete", this.data[t[r]]);
              }
              this.data = this.data.filter(function (t) {
                return !s[t.$loki];
              }), this.idIndex = this.idIndex.filter(function (t) {
                return !s[t];
              }), this.adaptiveBinaryIndices && c && (this.adaptiveBinaryIndices = !1, this.ensureAllIndexes(!0), this.adaptiveBinaryIndices = !0), this.commit(), this.dirty = !0;
            } catch (t) {
              return this.rollback(), c && (this.adaptiveBinaryIndices = !0), this.lokiConsoleWrapper.error(t.message), this.emit("error", t), null;
            }
          }, O.prototype.removeBatch = function (t) {
            var e,
                n = t.length,
                r = this.data.length,
                i = {},
                o = [];

            for (e = 0; e < r; e++) {
              i[this.data[e].$loki] = e;
            }

            for (e = 0; e < n; e++) {
              "object" == typeof t[e] ? o.push(i[t[e].$loki]) : o.push(i[t[e]]);
            }

            this.removeBatchByPositions(o);
          }, O.prototype.remove = function (e) {
            if ("number" == typeof e && (e = this.get(e)), "object" != typeof e) throw new Error("Parameter is not an object");
            if (Array.isArray(e)) this.removeBatch(e);else {
              if (!t.call(e, "$loki")) throw new Error("Object is not a document stored in the collection");

              try {
                this.startTransaction();
                var n = this.get(e.$loki, !0),
                    r = n[1],
                    i = this;
                Object.keys(this.constraints.unique).forEach(function (t) {
                  null !== e[t] && void 0 !== e[t] && i.constraints.unique[t].remove(e[t]);
                });

                for (var o = 0; o < this.DynamicViews.length; o++) {
                  this.DynamicViews[o].removeDocument(r);
                }

                if (this.adaptiveBinaryIndices) {
                  var s,
                      a = this.binaryIndices;

                  for (s in a) {
                    this.adaptiveBinaryIndexRemove(r, s);
                  }
                } else this.flagBinaryIndexesDirty();

                return this.data.splice(r, 1), this.removeAutoUpdateObserver(e), this.idIndex.splice(r, 1), this.commit(), this.dirty = !0, this.emit("delete", n[0]), delete e.$loki, delete e.meta, e;
              } catch (t) {
                return this.rollback(), this.lokiConsoleWrapper.error(t.message), this.emit("error", t), null;
              }
            }
          }, O.prototype.get = function (t, e) {
            var n = e || !1,
                r = this.idIndex,
                i = r.length - 1,
                o = 0,
                s = o + i >> 1;
            if (t = "number" == typeof t ? t : parseInt(t, 10), isNaN(t)) throw new TypeError("Passed id is not an integer");

            for (; r[o] < r[i];) {
              r[s = o + i >> 1] < t ? o = s + 1 : i = s;
            }

            return i === o && r[o] === t ? n ? [this.data[o], o] : this.data[o] : null;
          }, O.prototype.getBinaryIndexPosition = function (t, n) {
            var r = e.getIn(this.data[t], n, !0),
                i = this.binaryIndices[n].values,
                o = this.calculateRange("$eq", n, r);
            if (0 === o[0] && -1 === o[1]) return null;

            for (var s = o[0], a = o[1], u = s; u <= a; u++) {
              if (i[u] === t) return u;
            }

            return null;
          }, O.prototype.adaptiveBinaryIndexInsert = function (t, n) {
            var r = -1 !== n.indexOf("."),
                i = this.binaryIndices[n].values,
                o = e.getIn(this.data[t], n, r);
            !0 === this.serializableIndices && o instanceof Date && (this.data[t][n] = o.getTime(), o = e.getIn(this.data[t], n));
            var s = 0 === i.length ? 0 : this.calculateRangeStart(n, o, !0, r);
            this.binaryIndices[n].values.splice(s, 0, t);
          }, O.prototype.adaptiveBinaryIndexUpdate = function (t, e) {
            var n,
                r = this.binaryIndices[e].values,
                i = r.length;

            for (n = 0; n < i && r[n] !== t; n++) {
              ;
            }

            this.binaryIndices[e].values.splice(n, 1), this.adaptiveBinaryIndexInsert(t, e);
          }, O.prototype.adaptiveBinaryIndexRemove = function (t, e, n) {
            var r,
                i,
                o,
                s,
                a,
                u,
                c,
                l = this.binaryIndices[e],
                h = {};

            if (Array.isArray(t)) {
              if (1 !== (s = t.length)) {
                for (o = 0; o < s; o++) {
                  h[t[o]] = !0;
                }

                if (l.values = l.values.filter(function (t) {
                  return !h[t];
                }), !0 === n) return;
                var f = t.slice();

                for (f.sort(function (t, e) {
                  return t - e;
                }), r = l.values.length, i = 0; i < r; i++) {
                  for (a = l.values[i], u = 0, o = 0; o < s && a > f[o]; o++) {
                    u++;
                  }

                  l.values[i] -= u;
                }

                return;
              }

              t = t[0];
            }

            if (null === (c = this.getBinaryIndexPosition(t, e))) return null;
            if (l.values.splice(c, 1), !0 !== n) for (r = l.values.length, i = 0; i < r; i++) {
              l.values[i] > t && l.values[i]--;
            }
          }, O.prototype.calculateRangeStart = function (t, n, r, i) {
            var s = this.data,
                a = this.binaryIndices[t].values,
                u = 0,
                c = a.length - 1,
                l = 0;
            if (0 === a.length) return -1;

            for (e.getIn(s[a[u]], t, i), e.getIn(s[a[c]], t, i); u < c;) {
              l = u + c >> 1, o.lt(e.getIn(s[a[l]], t, i), n, !1) ? u = l + 1 : c = l;
            }

            var h = u;
            return o.aeq(n, e.getIn(s[a[h]], t, i)) ? h : o.lt(n, e.getIn(s[a[h]], t, i), !1) ? r ? h : h - 1 : r ? h + 1 : h;
          }, O.prototype.calculateRangeEnd = function (t, n, r) {
            var i = this.data,
                s = this.binaryIndices[t].values,
                a = 0,
                u = s.length - 1,
                c = 0;
            if (0 === s.length) return -1;

            for (e.getIn(i[s[a]], t, r), e.getIn(i[s[u]], t, r); a < u;) {
              c = a + u >> 1, o.lt(n, e.getIn(i[s[c]], t, r), !1) ? u = c : a = c + 1;
            }

            var l = u;
            return o.aeq(n, e.getIn(i[s[l]], t, r)) ? l : o.gt(n, e.getIn(i[s[l]], t, r), !1) ? l + 1 : o.aeq(n, e.getIn(i[s[l - 1]], t, r)) ? l - 1 : l;
          }, O.prototype.calculateRange = function (t, n, r) {
            var i,
                s,
                a,
                u = this.data,
                c = this.binaryIndices[n].values,
                l = c.length - 1;
            if (0 === u.length) return [0, -1];
            var h = -1 !== n.indexOf("."),
                f = e.getIn(u[c[0]], n, h),
                p = e.getIn(u[c[l]], n, h);

            switch (t) {
              case "$eq":
              case "$aeq":
              case "$dteq":
                if (o.lt(r, f, !1) || o.gt(r, p, !1)) return [0, -1];
                break;

              case "$gt":
                if (o.gt(r, p, !0)) return [0, -1];
                if (o.gt(f, r, !1)) return [0, l];
                break;

              case "$gte":
                if (o.gt(r, p, !1)) return [0, -1];
                if (o.gt(f, r, !0)) return [0, l];
                break;

              case "$lt":
                if (o.lt(r, f, !0)) return [0, -1];
                if (o.lt(p, r, !1)) return [0, l];
                break;

              case "$lte":
                if (o.lt(r, f, !1)) return [0, -1];
                if (o.lt(p, r, !0)) return [0, l];
                break;

              case "$between":
                return o.gt(r[0], p, !1) ? [0, -1] : o.lt(r[1], f, !1) ? [0, -1] : ((i = this.calculateRangeStart(n, r[0], !1, h)) < 0 && i++, (a = this.calculateRangeEnd(n, r[1], h)) > l && a--, o.gt(e.getIn(u[c[i]], n, h), r[0], !0) || i++, o.lt(e.getIn(u[c[a]], n, h), r[1], !0) || a--, a < i ? [0, -1] : [i, a]);

              case "$in":
                for (var d = [], y = [], v = 0, b = r.length; v < b; v++) {
                  for (var g = this.calculateRange("$eq", n, r[v]), m = g[0]; m <= g[1]; m++) {
                    void 0 === d[m] && (d[m] = !0, y.push(m));
                  }
                }

                return y;
            }

            switch (t) {
              case "$eq":
              case "$aeq":
              case "$dteq":
              case "$gte":
              case "$lt":
                i = this.calculateRangeStart(n, r, !1, h), s = e.getIn(u[c[i]], n, h);
            }

            switch (t) {
              case "$eq":
              case "$aeq":
              case "$dteq":
              case "$lte":
              case "$gt":
                a = this.calculateRangeEnd(n, r, h), e.getIn(u[c[a]], n, h);
            }

            switch (t) {
              case "$eq":
              case "$aeq":
              case "$dteq":
                return o.aeq(s, r) ? [i, a] : [0, -1];

              case "$gt":
                return o.aeq(e.getIn(u[c[a]], n, h), r) ? [a + 1, l] : [a, l];

              case "$gte":
                return o.aeq(e.getIn(u[c[i]], n, h), r) ? [i, l] : [i + 1, l];

              case "$lt":
                return o.aeq(e.getIn(u[c[i]], n, h), r) ? [0, i - 1] : [0, i];

              case "$lte":
                return o.aeq(e.getIn(u[c[a]], n, h), r) ? [0, a] : [0, a - 1];

              default:
                return [0, u.length - 1];
            }
          }, O.prototype.by = function (t, e) {
            var n;
            if (void 0 === e) return n = this, function (e) {
              return n.by(t, e);
            };
            var r = this.constraints.unique[t].get(e);
            return this.cloneObjects ? y(r, this.cloneMethod) : r;
          }, O.prototype.findOne = function (t) {
            t = t || {};
            var e = this.chain().find(t, !0).data();
            return Array.isArray(e) && 0 === e.length ? null : this.cloneObjects ? y(e[0], this.cloneMethod) : e[0];
          }, O.prototype.chain = function (t, e) {
            var n = new k(this);
            return void 0 === t ? n : n.transform(t, e);
          }, O.prototype.find = function (t) {
            return this.chain().find(t).data();
          }, O.prototype.findOneUnindexed = function (t, n) {
            for (var r = this.data.length; r--;) {
              if (e.getIn(this.data[r], t, !0) === n) return this.data[r];
            }

            return null;
          }, O.prototype.startTransaction = function () {
            if (this.transactional) {
              this.cachedData = y(this.data, this.cloneMethod), this.cachedIndex = this.idIndex, this.cachedBinaryIndex = this.binaryIndices;

              for (var t = 0; t < this.DynamicViews.length; t++) {
                this.DynamicViews[t].startTransaction();
              }
            }
          }, O.prototype.commit = function () {
            if (this.transactional) {
              this.cachedData = null, this.cachedIndex = null, this.cachedBinaryIndex = null;

              for (var t = 0; t < this.DynamicViews.length; t++) {
                this.DynamicViews[t].commit();
              }
            }
          }, O.prototype.rollback = function () {
            if (this.transactional) {
              null !== this.cachedData && null !== this.cachedIndex && (this.data = this.cachedData, this.idIndex = this.cachedIndex, this.binaryIndices = this.cachedBinaryIndex);

              for (var t = 0; t < this.DynamicViews.length; t++) {
                this.DynamicViews[t].rollback();
              }
            }
          }, O.prototype.async = function (t, e) {
            setTimeout(function () {
              if ("function" != typeof t) throw new TypeError("Argument passed for async execution is not a function");
              t(), e();
            }, 0);
          }, O.prototype.where = function (t) {
            return this.chain().where(t).data();
          }, O.prototype.mapReduce = function (t, e) {
            try {
              return e(this.data.map(t));
            } catch (t) {
              throw t;
            }
          }, O.prototype.eqJoin = function (t, e, n, r, i) {
            return new k(this).eqJoin(t, e, n, r, i);
          }, O.prototype.stages = {}, O.prototype.getStage = function (t) {
            return this.stages[t] || (this.stages[t] = {}), this.stages[t];
          }, O.prototype.commitLog = [], O.prototype.stage = function (t, e) {
            var n = JSON.parse(JSON.stringify(e));
            return this.getStage(t)[e.$loki] = n, n;
          }, O.prototype.commitStage = function (t, e) {
            var n,
                r = this.getStage(t),
                i = new Date().getTime();

            for (n in r) {
              this.update(r[n]), this.commitLog.push({
                timestamp: i,
                message: e,
                data: JSON.parse(JSON.stringify(r[n]))
              });
            }

            this.stages[t] = {};
          }, O.prototype.no_op = function () {}, O.prototype.extract = function (t) {
            for (var e = 0, n = this.data.length, r = S(t), i = []; e < n; e += 1) {
              i.push(P(this.data[e], t, r));
            }

            return i;
          }, O.prototype.max = function (t) {
            return Math.max.apply(null, this.extract(t));
          }, O.prototype.min = function (t) {
            return Math.min.apply(null, this.extract(t));
          }, O.prototype.maxRecord = function (t) {
            for (var e, n = 0, r = this.data.length, i = S(t), o = {
              index: 0,
              value: void 0
            }; n < r; n += 1) {
              void 0 !== e ? e < P(this.data[n], t, i) && (e = P(this.data[n], t, i), o.index = this.data[n].$loki) : (e = P(this.data[n], t, i), o.index = this.data[n].$loki);
            }

            return o.value = e, o;
          }, O.prototype.minRecord = function (t) {
            for (var e, n = 0, r = this.data.length, i = S(t), o = {
              index: 0,
              value: void 0
            }; n < r; n += 1) {
              void 0 !== e ? e > P(this.data[n], t, i) && (e = P(this.data[n], t, i), o.index = this.data[n].$loki) : (e = P(this.data[n], t, i), o.index = this.data[n].$loki);
            }

            return o.value = e, o;
          }, O.prototype.extractNumerical = function (t) {
            return this.extract(t).map(_).filter(Number).filter(function (t) {
              return !isNaN(t);
            });
          }, O.prototype.avg = function (t) {
            return D(this.extractNumerical(t));
          }, O.prototype.stdDev = function (t) {
            return e = this.extractNumerical(t), n = D(e), r = D(e.map(function (t) {
              var e = t - n;
              return e * e;
            })), Math.sqrt(r);
            var e, n, r;
          }, O.prototype.mode = function (t) {
            var e,
                n,
                r,
                i = {},
                o = this.extract(t);

            for (n in o.forEach(function (t) {
              i[t] ? i[t] += 1 : i[t] = 1;
            }), i) {
              e ? e < i[n] && (r = n) : (r = n, e = i[n]);
            }

            return r;
          }, O.prototype.median = function (t) {
            var e = this.extractNumerical(t);
            e.sort(j);
            var n = Math.floor(e.length / 2);
            return e.length % 2 ? e[n] : (e[n - 1] + e[n]) / 2;
          }, L.prototype = {
            keys: [],
            values: [],
            sort: function sort(t, e) {
              return t < e ? -1 : t > e ? 1 : 0;
            },
            setSort: function setSort(t) {
              this.bs = new C(t);
            },
            bs: function bs() {
              return new C(this.sort);
            },
            set: function set(t, e) {
              var n = this.bs(this.keys, t);
              n.found ? this.values[n.index] = e : (this.keys.splice(n.index, 0, t), this.values.splice(n.index, 0, e));
            },
            get: function get(t) {
              return this.values[B(this.keys, t, this.sort).index];
            }
          }, N.prototype.keyMap = {}, N.prototype.lokiMap = {}, N.prototype.set = function (t) {
            var e = t[this.field];

            if (null != e) {
              if (this.keyMap[e]) throw new Error("Duplicate key for property " + this.field + ": " + e);
              this.keyMap[e] = t, this.lokiMap[t.$loki] = e;
            }
          }, N.prototype.get = function (t) {
            return this.keyMap[t];
          }, N.prototype.byId = function (t) {
            return this.keyMap[this.lokiMap[t]];
          }, N.prototype.update = function (t, e) {
            if (this.lokiMap[t.$loki] !== e[this.field]) {
              var n = this.lokiMap[t.$loki];
              this.set(e), this.keyMap[n] = void 0;
            } else this.keyMap[t[this.field]] = e;
          }, N.prototype.remove = function (t) {
            var e = this.keyMap[t];
            if (null == e) throw new Error("Key is not in unique index: " + this.field);
            this.keyMap[t] = void 0, this.lokiMap[e.$loki] = void 0;
          }, N.prototype.clear = function () {
            this.keyMap = {}, this.lokiMap = {};
          }, T.prototype = {
            set: function set(t, e) {
              this.index[t] ? this.index[t].push(e) : this.index[t] = [e];
            },
            remove: function remove(t, e) {
              var n = this.index[t];

              for (var r in n) {
                n[r] == e && n.splice(r, 1);
              }

              n.length < 1 && (this.index[t] = void 0);
            },
            get: function get(t) {
              return this.index[t];
            },
            clear: function clear(t) {
              this.index = {};
            }
          }, g.LokiOps = p, g.Collection = O, g.KeyValueStore = L, g.LokiMemoryAdapter = m, g.LokiPartitioningAdapter = w, g.LokiLocalStorageAdapter = x, g.LokiFsAdapter = I, g.persistenceAdapters = {
            fs: I,
            localStorage: x
          }, g.aeq = s, g.lt = a, g.gt = u, g.Comparators = o, g;
        }();
      }) ? o.apply(e, s) : o) || (t.exports = a);
    }).call(this, n(18), n(29));
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(0),
        i = n(2);

    function o(t, e) {
      return function (n) {
        if ("function" != typeof t) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return n.lift(new s(t, e));
      };
    }

    var s = function () {
      function t(t, e) {
        this.project = t, this.thisArg = e;
      }

      return t.prototype.call = function (t, e) {
        return e.subscribe(new a(t, this.project, this.thisArg));
      }, t;
    }(),
        a = function (t) {
      function e(e, n, r) {
        var i = t.call(this, e) || this;
        return i.project = n, i.count = 0, i.thisArg = r || i, i;
      }

      return r.a(e, t), e.prototype._next = function (t) {
        var e;

        try {
          e = this.project.call(this.thisArg, t, this.count++);
        } catch (t) {
          return void this.destination.error(t);
        }

        this.destination.next(e);
      }, e;
    }(i.a);
  }, function (t, e, n) {
    "use strict";

    var r,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, n) {
      return Function.prototype.apply.call(t, e, n);
    };
    r = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var s = Number.isNaN || function (t) {
      return t != t;
    };

    function a() {
      a.init.call(this);
    }

    t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
    var u = 10;

    function c(t) {
      return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
    }

    function l(t, e, n, r) {
      var i, o, s, a;
      if ("function" != typeof n) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
      if (void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, n.listener ? n.listener : n), o = t._events), s = o[e]), void 0 === s) s = o[e] = n, ++t._eventsCount;else if ("function" == typeof s ? s = o[e] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), (i = c(t)) > 0 && s.length > i && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = s.length, a = u, console && console.warn && console.warn(a);
      }
      return t;
    }

    function h() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t.push(arguments[e]);
      }

      this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, o(this.listener, this.target, t));
    }

    function f(t, e, n) {
      var r = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: n
      },
          i = h.bind(r);
      return i.listener = n, r.wrapFn = i, i;
    }

    function p(t, e, n) {
      var r = t._events;
      if (void 0 === r) return [];
      var i = r[e];
      return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (t) {
        for (var e = new Array(t.length), n = 0; n < e.length; ++n) {
          e[n] = t[n].listener || t[n];
        }

        return e;
      }(i) : y(i, i.length);
    }

    function d(t) {
      var e = this._events;

      if (void 0 !== e) {
        var n = e[t];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length;
      }

      return 0;
    }

    function y(t, e) {
      for (var n = new Array(e), r = 0; r < e; ++r) {
        n[r] = t[r];
      }

      return n;
    }

    Object.defineProperty(a, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t;
      }
    }), a.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, a.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, a.prototype.getMaxListeners = function () {
      return c(this);
    }, a.prototype.emit = function (t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e.push(arguments[n]);
      }

      var r = "error" === t,
          i = this._events;
      if (void 0 !== i) r = r && void 0 === i.error;else if (!r) return !1;

      if (r) {
        var s;
        if (e.length > 0 && (s = e[0]), s instanceof Error) throw s;
        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
        throw a.context = s, a;
      }

      var u = i[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) o(u, this, e);else {
        var c = u.length,
            l = y(u, c);

        for (n = 0; n < c; ++n) {
          o(l[n], this, e);
        }
      }
      return !0;
    }, a.prototype.addListener = function (t, e) {
      return l(this, t, e, !1);
    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (t, e) {
      return l(this, t, e, !0);
    }, a.prototype.once = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.on(t, f(this, t, e)), this;
    }, a.prototype.prependOnceListener = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.prependListener(t, f(this, t, e)), this;
    }, a.prototype.removeListener = function (t, e) {
      var n, r, i, o, s;
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      if (void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[t])) return this;
      if (n === e || n.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[t], r.removeListener && this.emit("removeListener", t, n.listener || e));else if ("function" != typeof n) {
        for (i = -1, o = n.length - 1; o >= 0; o--) {
          if (n[o] === e || n[o].listener === e) {
            s = n[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? n.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(n, i), 1 === n.length && (r[t] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", t, s || e);
      }
      return this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (t) {
      var e, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(n);

        for (r = 0; r < o.length; ++r) {
          "removeListener" !== (i = o[r]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = n[t])) this.removeListener(t, e);else if (void 0 !== e) for (r = e.length - 1; r >= 0; r--) {
        this.removeListener(t, e[r]);
      }
      return this;
    }, a.prototype.listeners = function (t) {
      return p(this, t, !0);
    }, a.prototype.rawListeners = function (t) {
      return p(this, t, !1);
    }, a.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e);
    }, a.prototype.listenerCount = d, a.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : [];
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    var r = n(32);

    t.exports = function (t) {
      return "string" != typeof t ? t : r(t) ? t.slice(2) : t;
    };
  }, function (t, e) {
    function n(t, e, n) {
      for (var r = [], i = Math.max(t.length, e.length), o = 0, s = 0; s < i || o;) {
        var a = o + (s < t.length ? t[s] : 0) + (s < e.length ? e[s] : 0);
        r.push(a % n), o = Math.floor(a / n), s++;
      }

      return r;
    }

    function r(t, e, r) {
      if (t < 0) return null;
      if (0 == t) return [];

      for (var i = [], o = e; 1 & t && (i = n(i, o, r)), 0 != (t >>= 1);) {
        o = n(o, o, r);
      }

      return i;
    }

    function i(t, e, i) {
      var o = function (t, e) {
        for (var n = t.split(""), r = [], i = n.length - 1; i >= 0; i--) {
          var o = parseInt(n[i], e);
          if (isNaN(o)) return null;
          r.push(o);
        }

        return r;
      }(t, e);

      if (null === o) return null;

      for (var s = [], a = [1], u = 0; u < o.length; u++) {
        o[u] && (s = n(s, r(o[u], a, i), i)), a = r(e, a, i);
      }

      var c = "";

      for (u = s.length - 1; u >= 0; u--) {
        c += s[u].toString(i);
      }

      return "" === c && (c = "0"), c;
    }

    t.exports = {
      hexToDec: function hexToDec(t) {
        return "0x" === t.substring(0, 2) && (t = t.substring(2)), i(t = t.toLowerCase(), 16, 10);
      },
      decToHex: function decToHex(t, e) {
        var n = e && !1 === e.prefix,
            r = i(t, 10, 16);
        return r ? n ? r : "0x" + r : null;
      }
    };
  }, function (t, e, n) {
    "use strict";

    function r() {}

    function i() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      return o(t);
    }

    function o(t) {
      return t ? 1 === t.length ? t[0] : function (e) {
        return t.reduce(function (t, e) {
          return e(t);
        }, e);
      } : r;
    }

    n.d(e, "a", function () {
      return i;
    }), n.d(e, "b", function () {
      return o;
    });
  },, function (t, e, n) {
    var r = function (t) {
      "use strict";

      var e,
          n = Object.prototype,
          r = n.hasOwnProperty,
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          s = i.asyncIterator || "@@asyncIterator",
          a = i.toStringTag || "@@toStringTag";

      function u(t, e, n, r) {
        var i = e && e.prototype instanceof y ? e : y,
            o = Object.create(i.prototype),
            s = new _(r || []);
        return o._invoke = function (t, e, n) {
          var r = l;
          return function (i, o) {
            if (r === f) throw new Error("Generator is already running");

            if (r === p) {
              if ("throw" === i) throw o;
              return j();
            }

            for (n.method = i, n.arg = o;;) {
              var s = n.delegate;

              if (s) {
                var a = E(s, n);

                if (a) {
                  if (a === d) continue;
                  return a;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === l) throw r = p, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = f;
              var u = c(t, e, n);

              if ("normal" === u.type) {
                if (r = n.done ? p : h, u.arg === d) continue;
                return {
                  value: u.arg,
                  done: n.done
                };
              }

              "throw" === u.type && (r = p, n.method = "throw", n.arg = u.arg);
            }
          };
        }(t, n, s), o;
      }

      function c(t, e, n) {
        try {
          return {
            type: "normal",
            arg: t.call(e, n)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var l = "suspendedStart",
          h = "suspendedYield",
          f = "executing",
          p = "completed",
          d = {};

      function y() {}

      function v() {}

      function b() {}

      var g = {};

      g[o] = function () {
        return this;
      };

      var m = Object.getPrototypeOf,
          w = m && m(m(A([])));
      w && w !== n && r.call(w, o) && (g = w);
      var I = b.prototype = y.prototype = Object.create(g);

      function x(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function k(t) {
        var e;

        this._invoke = function (n, i) {
          function o() {
            return new Promise(function (e, o) {
              !function e(n, i, o, s) {
                var a = c(t[n], t, i);

                if ("throw" !== a.type) {
                  var u = a.arg,
                      l = u.value;
                  return l && "object" == typeof l && r.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                    e("next", t, o, s);
                  }, function (t) {
                    e("throw", t, o, s);
                  }) : Promise.resolve(l).then(function (t) {
                    u.value = t, o(u);
                  }, function (t) {
                    return e("throw", t, o, s);
                  });
                }

                s(a.arg);
              }(n, i, e, o);
            });
          }

          return e = e ? e.then(o, o) : o();
        };
      }

      function E(t, n) {
        var r = t.iterator[n.method];

        if (r === e) {
          if (n.delegate = null, "throw" === n.method) {
            if (t.iterator.return && (n.method = "return", n.arg = e, E(t, n), "throw" === n.method)) return d;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return d;
        }

        var i = c(r, t.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, d;
        var o = i.arg;
        return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, d) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, d);
      }

      function O(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function S(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function _(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(O, this), this.reset(!0);
      }

      function A(t) {
        if (t) {
          var n = t[o];
          if (n) return n.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var i = -1,
                s = function n() {
              for (; ++i < t.length;) {
                if (r.call(t, i)) return n.value = t[i], n.done = !1, n;
              }

              return n.value = e, n.done = !0, n;
            };

            return s.next = s;
          }
        }

        return {
          next: j
        };
      }

      function j() {
        return {
          value: e,
          done: !0
        };
      }

      return v.prototype = I.constructor = b, b.constructor = v, b[a] = v.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(I), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, x(k.prototype), k.prototype[s] = function () {
        return this;
      }, t.AsyncIterator = k, t.async = function (e, n, r, i) {
        var o = new k(u(e, n, r, i));
        return t.isGeneratorFunction(n) ? o : o.next().then(function (t) {
          return t.done ? t.value : o.next();
        });
      }, x(I), I[a] = "Generator", I[o] = function () {
        return this;
      }, I.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var n in t) {
          e.push(n);
        }

        return e.reverse(), function n() {
          for (; e.length;) {
            var r = e.pop();
            if (r in t) return n.value = r, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, t.values = A, _.prototype = {
        constructor: _,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(S), !t) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var n = this;

          function i(r, i) {
            return a.type = "throw", a.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var s = this.tryEntries[o],
                a = s.completion;
            if ("root" === s.tryLoc) return i("end");

            if (s.tryLoc <= this.prev) {
              var u = r.call(s, "catchLoc"),
                  c = r.call(s, "finallyLoc");

              if (u && c) {
                if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
                if (this.prev < s.finallyLoc) return i(s.finallyLoc);
              } else if (u) {
                if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < s.finallyLoc) return i(s.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var i = this.tryEntries[n];

            if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var s = o ? o.completion : {};
          return s.type = t, s.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(s);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), S(n), d;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];

            if (n.tryLoc === t) {
              var r = n.completion;

              if ("throw" === r.type) {
                var i = r.arg;
                S(n);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, n, r) {
          return this.delegate = {
            iterator: A(t),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = e), d;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = r;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (t, e) {
    var n,
        r,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (t) {
        r = s;
      }
    }();
    var u,
        c = [],
        l = !1,
        h = -1;

    function f() {
      l && u && (l = !1, u.length ? c = u.concat(c) : h = -1, c.length && p());
    }

    function p() {
      if (!l) {
        var t = a(f);
        l = !0;

        for (var e = c.length; e;) {
          for (u = c, c = []; ++h < e;) {
            u && u[h].run();
          }

          h = -1, e = c.length;
        }

        u = null, l = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function y() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      c.push(new d(t, e)), 1 !== c.length || l || a(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    var r, i, o;
    i = [], void 0 === (o = "function" == typeof (r = function r() {
      return function () {
        function t(t, e) {
          if (this.app = "loki", this.options = e || {}, void 0 !== t && (this.app = t), this.catalog = null, !this.checkAvailability()) throw new Error("indexedDB does not seem to be supported for your environment");
        }

        function e(t) {
          this.db = null, this.initializeLokiCatalog(t);
        }

        return t.prototype.closeDatabase = function () {
          this.catalog && this.catalog.db && (this.catalog.db.close(), this.catalog.db = null);
        }, t.prototype.checkAvailability = function () {
          return !("undefined" == typeof indexedDB || !indexedDB);
        }, t.prototype.loadDatabase = function (t, n) {
          var r = this.app,
              i = this;
          null !== this.catalog && null !== this.catalog.db ? this.catalog.getAppKey(r, t, function (t) {
            if ("function" == typeof n) {
              if (0 === t.id) return void n(null);
              n(t.val);
            } else console.log(t.val);
          }) : this.catalog = new e(function (e) {
            i.catalog = e, i.loadDatabase(t, n);
          });
        }, t.prototype.loadKey = t.prototype.loadDatabase, t.prototype.saveDatabase = function (t, n, r) {
          var i = this.app,
              o = this;

          function s(t) {
            t && !0 === t.success ? r(null) : r(new Error("Error saving database")), o.options.closeAfterSave && o.closeDatabase();
          }

          null !== this.catalog && null !== this.catalog.db ? this.catalog.setAppKey(i, t, n, s) : this.catalog = new e(function (e) {
            o.saveDatabase(t, n, s);
          });
        }, t.prototype.saveKey = t.prototype.saveDatabase, t.prototype.deleteDatabase = function (t, n) {
          var r = this.app,
              i = this;
          null !== this.catalog && null !== this.catalog.db ? this.catalog.getAppKey(r, t, function (t) {
            var e = t.id;
            0 !== e ? i.catalog.deleteAppKey(e, n) : "function" == typeof n && n({
              success: !0
            });
          }) : this.catalog = new e(function (e) {
            i.catalog = e, i.deleteDatabase(t, n);
          });
        }, t.prototype.deleteKey = t.prototype.deleteDatabase, t.prototype.deleteDatabasePartitions = function (t) {
          var e = this;
          this.getDatabaseList(function (n) {
            n.forEach(function (n) {
              n.startsWith(t) && e.deleteDatabase(n);
            });
          });
        }, t.prototype.getDatabaseList = function (t) {
          var n = this.app,
              r = this;
          null !== this.catalog && null !== this.catalog.db ? this.catalog.getAppKeys(n, function (e) {
            for (var n = [], r = 0; r < e.length; r++) {
              n.push(e[r].key);
            }

            "function" == typeof t ? t(n) : n.forEach(function (t) {
              console.log(t);
            });
          }) : this.catalog = new e(function (e) {
            r.catalog = e, r.getDatabaseList(t);
          });
        }, t.prototype.getKeyList = t.prototype.getDatabaseList, t.prototype.getCatalogSummary = function (t) {
          this.app;
          var n = this;
          null !== this.catalog && null !== this.catalog.db ? this.catalog.getAllKeys(function (e) {
            for (var n, r, i, o, s, a = [], u = 0; u < e.length; u++) {
              i = (n = e[u]).app || "", o = n.key || "", s = n.val || "", r = 2 * i.length + 2 * o.length + s.length + 1, a.push({
                app: n.app,
                key: n.key,
                size: r
              });
            }

            "function" == typeof t ? t(a) : a.forEach(function (t) {
              console.log(t);
            });
          }) : this.catalog = new e(function (e) {
            n.catalog = e, n.getCatalogSummary(t);
          });
        }, e.prototype.initializeLokiCatalog = function (t) {
          var e = indexedDB.open("LokiCatalog", 1),
              n = this;
          e.onupgradeneeded = function (t) {
            var e = t.target.result;

            if (e.objectStoreNames.contains("LokiAKV") && e.deleteObjectStore("LokiAKV"), !e.objectStoreNames.contains("LokiAKV")) {
              var n = e.createObjectStore("LokiAKV", {
                keyPath: "id",
                autoIncrement: !0
              });
              n.createIndex("app", "app", {
                unique: !1
              }), n.createIndex("key", "key", {
                unique: !1
              }), n.createIndex("appkey", "appkey", {
                unique: !0
              });
            }
          }, e.onsuccess = function (e) {
            n.db = e.target.result, "function" == typeof t && t(n);
          }, e.onerror = function (t) {
            throw t;
          };
        }, e.prototype.getAppKey = function (t, e, n) {
          var r,
              i = t + "," + e,
              o = this.db.transaction(["LokiAKV"], "readonly").objectStore("LokiAKV").index("appkey").get(i);
          o.onsuccess = (r = n, function (t) {
            var e = t.target.result;
            null == e && (e = {
              id: 0,
              success: !1
            }), "function" == typeof r ? r(e) : console.log(e);
          }), o.onerror = function (t) {
            return function (e) {
              if ("function" != typeof t) throw e;
              t({
                id: 0,
                success: !1
              });
            };
          }(n);
        }, e.prototype.getAppKeyById = function (t, e, n) {
          this.db.transaction(["LokiAKV"], "readonly").objectStore("LokiAKV").get(t).onsuccess = function (t, e) {
            return function (n) {
              "function" == typeof e ? e(n.target.result, t) : console.log(n.target.result);
            };
          }(n, e);
        }, e.prototype.setAppKey = function (t, e, n, r) {
          var i,
              o = this.db.transaction(["LokiAKV"], "readwrite").objectStore("LokiAKV"),
              s = o.index("appkey"),
              a = t + "," + e,
              u = s.get(a);
          u.onsuccess = function (i) {
            var s = i.target.result;
            null == s ? s = {
              app: t,
              key: e,
              appkey: t + "," + e,
              val: n
            } : s.val = n;
            var a,
                c = o.put(s);
            c.onerror = (a = r, function (t) {
              "function" == typeof a ? a({
                success: !1
              }) : (console.error("LokiCatalog.setAppKey (set) onerror"), console.error(u.error));
            }), c.onsuccess = function (t) {
              return function (e) {
                "function" == typeof t && t({
                  success: !0
                });
              };
            }(r);
          }, u.onerror = (i = r, function (t) {
            "function" == typeof i ? i({
              success: !1
            }) : (console.error("LokiCatalog.setAppKey (get) onerror"), console.error(u.error));
          });
        }, e.prototype.deleteAppKey = function (t, e) {
          var n,
              r = this.db.transaction(["LokiAKV"], "readwrite").objectStore("LokiAKV").delete(t);
          r.onsuccess = (n = e, function (t) {
            "function" == typeof n && n({
              success: !0
            });
          }), r.onerror = function (t) {
            return function (e) {
              "function" == typeof t ? t({
                success: !1
              }) : (console.error("LokiCatalog.deleteAppKey raised onerror"), console.error(r.error));
            };
          }(e);
        }, e.prototype.getAppKeys = function (t, e) {
          var n,
              r = this.db.transaction(["LokiAKV"], "readonly").objectStore("LokiAKV").index("app"),
              i = IDBKeyRange.only(t),
              o = r.openCursor(i);
          o.onsuccess = function (t, e) {
            return function (n) {
              var r = n.target.result;

              if (r) {
                var i = r.value;
                t.push(i), r.continue();
              } else "function" == typeof e ? e(t) : console.log(t);
            };
          }([], e), o.onerror = (n = e, function (t) {
            "function" == typeof n ? n(null) : (console.error("LokiCatalog.getAppKeys raised onerror"), console.error(t));
          });
        }, e.prototype.getAllKeys = function (t) {
          var e,
              n = this.db.transaction(["LokiAKV"], "readonly").objectStore("LokiAKV").openCursor();
          n.onsuccess = function (t, e) {
            return function (n) {
              var r = n.target.result;

              if (r) {
                var i = r.value;
                t.push(i), r.continue();
              } else "function" == typeof e ? e(t) : console.log(t);
            };
          }([], t), n.onerror = (e = t, function (t) {
            "function" == typeof e && e(null);
          });
        }, t;
      }();
    }) ? r.apply(e, i) : r) || (t.exports = o);
  }, function (t, e) {}, function (t, e) {
    t.exports = function (t) {
      if ("string" != typeof t) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof t + ", while checking isHexPrefixed.");
      return "0x" === t.slice(0, 2);
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);

    var r = n(1),
        i = n.n(r),
        o = n(8),
        s = n.n(o),
        a = n(4),
        u = n.n(a),
        c = n(5),
        l = n.n(c),
        h = n(0),
        f = n(3),
        p = n(2),
        d = n(6),
        y = function () {
      function t() {
        return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
      }

      return t.prototype = Object.create(Error.prototype), t;
    }(),
        v = function (t) {
      function e(e, n) {
        var r = t.call(this) || this;
        return r.subject = e, r.subscriber = n, r.closed = !1, r;
      }

      return h.a(e, t), e.prototype.unsubscribe = function () {
        if (!this.closed) {
          this.closed = !0;
          var t = this.subject,
              e = t.observers;

          if (this.subject = null, e && 0 !== e.length && !t.isStopped && !t.closed) {
            var n = e.indexOf(this.subscriber);
            -1 !== n && e.splice(n, 1);
          }
        }
      }, e;
    }(d.a),
        b = n(11),
        g = function (t) {
      function e(e) {
        var n = t.call(this, e) || this;
        return n.destination = e, n;
      }

      return h.a(e, t), e;
    }(p.a),
        m = function (t) {
      function e() {
        var e = t.call(this) || this;
        return e.observers = [], e.closed = !1, e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
      }

      return h.a(e, t), e.prototype[b.a] = function () {
        return new g(this);
      }, e.prototype.lift = function (t) {
        var e = new w(this, this);
        return e.operator = t, e;
      }, e.prototype.next = function (t) {
        if (this.closed) throw new y();
        if (!this.isStopped) for (var e = this.observers, n = e.length, r = e.slice(), i = 0; i < n; i++) {
          r[i].next(t);
        }
      }, e.prototype.error = function (t) {
        if (this.closed) throw new y();
        this.hasError = !0, this.thrownError = t, this.isStopped = !0;

        for (var e = this.observers, n = e.length, r = e.slice(), i = 0; i < n; i++) {
          r[i].error(t);
        }

        this.observers.length = 0;
      }, e.prototype.complete = function () {
        if (this.closed) throw new y();
        this.isStopped = !0;

        for (var t = this.observers, e = t.length, n = t.slice(), r = 0; r < e; r++) {
          n[r].complete();
        }

        this.observers.length = 0;
      }, e.prototype.unsubscribe = function () {
        this.isStopped = !0, this.closed = !0, this.observers = null;
      }, e.prototype._trySubscribe = function (e) {
        if (this.closed) throw new y();
        return t.prototype._trySubscribe.call(this, e);
      }, e.prototype._subscribe = function (t) {
        if (this.closed) throw new y();
        return this.hasError ? (t.error(this.thrownError), d.a.EMPTY) : this.isStopped ? (t.complete(), d.a.EMPTY) : (this.observers.push(t), new v(this, t));
      }, e.prototype.asObservable = function () {
        var t = new f.a();
        return t.source = this, t;
      }, e.create = function (t, e) {
        return new w(t, e);
      }, e;
    }(f.a),
        w = function (t) {
      function e(e, n) {
        var r = t.call(this) || this;
        return r.destination = e, r.source = n, r;
      }

      return h.a(e, t), e.prototype.next = function (t) {
        var e = this.destination;
        e && e.next && e.next(t);
      }, e.prototype.error = function (t) {
        var e = this.destination;
        e && e.error && this.destination.error(t);
      }, e.prototype.complete = function () {
        var t = this.destination;
        t && t.complete && this.destination.complete();
      }, e.prototype._subscribe = function (t) {
        return this.source ? this.source.subscribe(t) : d.a.EMPTY;
      }, e;
    }(m),
        I = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.scheduler = e, r.work = n, r;
      }

      return h.a(e, t), e.prototype.schedule = function (e, n) {
        return void 0 === n && (n = 0), n > 0 ? t.prototype.schedule.call(this, e, n) : (this.delay = n, this.state = e, this.scheduler.flush(this), this);
      }, e.prototype.execute = function (e, n) {
        return n > 0 || this.closed ? t.prototype.execute.call(this, e, n) : this._execute(e, n);
      }, e.prototype.requestAsyncId = function (e, n, r) {
        return void 0 === r && (r = 0), null !== r && r > 0 || null === r && this.delay > 0 ? t.prototype.requestAsyncId.call(this, e, n, r) : e.flush(this);
      }, e;
    }(function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.scheduler = e, r.work = n, r.pending = !1, r;
      }

      return h.a(e, t), e.prototype.schedule = function (t, e) {
        if (void 0 === e && (e = 0), this.closed) return this;
        this.state = t;
        var n = this.id,
            r = this.scheduler;
        return null != n && (this.id = this.recycleAsyncId(r, n, e)), this.pending = !0, this.delay = e, this.id = this.id || this.requestAsyncId(r, this.id, e), this;
      }, e.prototype.requestAsyncId = function (t, e, n) {
        return void 0 === n && (n = 0), setInterval(t.flush.bind(t, this), n);
      }, e.prototype.recycleAsyncId = function (t, e, n) {
        if (void 0 === n && (n = 0), null !== n && this.delay === n && !1 === this.pending) return e;
        clearInterval(e);
      }, e.prototype.execute = function (t, e) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = !1;

        var n = this._execute(t, e);

        if (n) return n;
        !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
      }, e.prototype._execute = function (t, e) {
        var n = !1,
            r = void 0;

        try {
          this.work(t);
        } catch (t) {
          n = !0, r = !!t && t || new Error(t);
        }

        if (n) return this.unsubscribe(), r;
      }, e.prototype._unsubscribe = function () {
        var t = this.id,
            e = this.scheduler,
            n = e.actions,
            r = n.indexOf(this);
        this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== r && n.splice(r, 1), null != t && (this.id = this.recycleAsyncId(e, t, null)), this.delay = null;
      }, e;
    }(function (t) {
      function e(e, n) {
        return t.call(this) || this;
      }

      return h.a(e, t), e.prototype.schedule = function (t, e) {
        return void 0 === e && (e = 0), this;
      }, e;
    }(d.a))),
        x = function () {
      function t(e, n) {
        void 0 === n && (n = t.now), this.SchedulerAction = e, this.now = n;
      }

      return t.prototype.schedule = function (t, e, n) {
        return void 0 === e && (e = 0), new this.SchedulerAction(this, t).schedule(n, e);
      }, t.now = function () {
        return Date.now();
      }, t;
    }(),
        k = new (function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return h.a(e, t), e;
    }(function (t) {
      function e(n, r) {
        void 0 === r && (r = x.now);
        var i = t.call(this, n, function () {
          return e.delegate && e.delegate !== i ? e.delegate.now() : r();
        }) || this;
        return i.actions = [], i.active = !1, i.scheduled = void 0, i;
      }

      return h.a(e, t), e.prototype.schedule = function (n, r, i) {
        return void 0 === r && (r = 0), e.delegate && e.delegate !== this ? e.delegate.schedule(n, r, i) : t.prototype.schedule.call(this, n, r, i);
      }, e.prototype.flush = function (t) {
        var e = this.actions;
        if (this.active) e.push(t);else {
          var n;
          this.active = !0;

          do {
            if (n = t.execute(t.state, t.delay)) break;
          } while (t = e.shift());

          if (this.active = !1, n) {
            for (; t = e.shift();) {
              t.unsubscribe();
            }

            throw n;
          }
        }
      }, e;
    }(x)))(I),
        E = new f.a(function (t) {
      return t.complete();
    });

    function O(t) {
      return t ? function (t) {
        return new f.a(function (e) {
          return t.schedule(function () {
            return e.complete();
          });
        });
      }(t) : E;
    }

    var S,
        _ = function _(t) {
      return function (e) {
        for (var n = 0, r = t.length; n < r && !e.closed; n++) {
          e.next(t[n]);
        }

        e.complete();
      };
    };

    function A(t, e) {
      return new f.a(function (n) {
        var r = new d.a(),
            i = 0;
        return r.add(e.schedule(function () {
          i !== t.length ? (n.next(t[i++]), n.closed || r.add(this.schedule())) : n.complete();
        })), r;
      });
    }

    function j() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      var n,
          r = t[t.length - 1];
      return (n = r) && "function" == typeof n.schedule ? (t.pop(), A(t, r)) : function (t, e) {
        return e ? A(t, e) : new f.a(_(t));
      }(t);
    }

    function D(t) {
      var e = t.error;
      t.subscriber.error(e);
    }

    S || (S = {});

    var P = function () {
      function t(t, e, n) {
        this.kind = t, this.value = e, this.error = n, this.hasValue = "N" === t;
      }

      return t.prototype.observe = function (t) {
        switch (this.kind) {
          case "N":
            return t.next && t.next(this.value);

          case "E":
            return t.error && t.error(this.error);

          case "C":
            return t.complete && t.complete();
        }
      }, t.prototype.do = function (t, e, n) {
        switch (this.kind) {
          case "N":
            return t && t(this.value);

          case "E":
            return e && e(this.error);

          case "C":
            return n && n();
        }
      }, t.prototype.accept = function (t, e, n) {
        return t && "function" == typeof t.next ? this.observe(t) : this.do(t, e, n);
      }, t.prototype.toObservable = function () {
        var t, e;

        switch (this.kind) {
          case "N":
            return j(this.value);

          case "E":
            return t = this.error, e ? new f.a(function (n) {
              return e.schedule(D, 0, {
                error: t,
                subscriber: n
              });
            }) : new f.a(function (e) {
              return e.error(t);
            });

          case "C":
            return O();
        }

        throw new Error("unexpected notification kind value");
      }, t.createNext = function (e) {
        return void 0 !== e ? new t("N", e) : t.undefinedValueNotification;
      }, t.createError = function (e) {
        return new t("E", void 0, e);
      }, t.createComplete = function () {
        return t.completeNotification;
      }, t.completeNotification = new t("C"), t.undefinedValueNotification = new t("N", void 0), t;
    }();

    var B = function (t) {
      function e(e, n, r) {
        void 0 === r && (r = 0);
        var i = t.call(this, e) || this;
        return i.scheduler = n, i.delay = r, i;
      }

      return h.a(e, t), e.dispatch = function (t) {
        var e = t.notification,
            n = t.destination;
        e.observe(n), this.unsubscribe();
      }, e.prototype.scheduleMessage = function (t) {
        this.destination.add(this.scheduler.schedule(e.dispatch, this.delay, new C(t, this.destination)));
      }, e.prototype._next = function (t) {
        this.scheduleMessage(P.createNext(t));
      }, e.prototype._error = function (t) {
        this.scheduleMessage(P.createError(t)), this.unsubscribe();
      }, e.prototype._complete = function () {
        this.scheduleMessage(P.createComplete()), this.unsubscribe();
      }, e;
    }(p.a),
        C = function () {
      return function (t, e) {
        this.notification = t, this.destination = e;
      };
    }(),
        L = function (t) {
      function e(e, n, r) {
        void 0 === e && (e = Number.POSITIVE_INFINITY), void 0 === n && (n = Number.POSITIVE_INFINITY);
        var i = t.call(this) || this;
        return i.scheduler = r, i._events = [], i._infiniteTimeWindow = !1, i._bufferSize = e < 1 ? 1 : e, i._windowTime = n < 1 ? 1 : n, n === Number.POSITIVE_INFINITY ? (i._infiniteTimeWindow = !0, i.next = i.nextInfiniteTimeWindow) : i.next = i.nextTimeWindow, i;
      }

      return h.a(e, t), e.prototype.nextInfiniteTimeWindow = function (e) {
        var n = this._events;
        n.push(e), n.length > this._bufferSize && n.shift(), t.prototype.next.call(this, e);
      }, e.prototype.nextTimeWindow = function (e) {
        this._events.push(new N(this._getNow(), e)), this._trimBufferThenGetEvents(), t.prototype.next.call(this, e);
      }, e.prototype._subscribe = function (t) {
        var e,
            n = this._infiniteTimeWindow,
            r = n ? this._events : this._trimBufferThenGetEvents(),
            i = this.scheduler,
            o = r.length;
        if (this.closed) throw new y();
        if (this.isStopped || this.hasError ? e = d.a.EMPTY : (this.observers.push(t), e = new v(this, t)), i && t.add(t = new B(t, i)), n) for (var s = 0; s < o && !t.closed; s++) {
          t.next(r[s]);
        } else for (s = 0; s < o && !t.closed; s++) {
          t.next(r[s].value);
        }
        return this.hasError ? t.error(this.thrownError) : this.isStopped && t.complete(), e;
      }, e.prototype._getNow = function () {
        return (this.scheduler || k).now();
      }, e.prototype._trimBufferThenGetEvents = function () {
        for (var t = this._getNow(), e = this._bufferSize, n = this._windowTime, r = this._events, i = r.length, o = 0; o < i && !(t - r[o].time < n);) {
          o++;
        }

        return i > e && (o = Math.max(o, i - e)), o > 0 && r.splice(0, o), r;
      }, e;
    }(m),
        N = function () {
      return function (t, e) {
        this.time = t, this.value = e;
      };
    }(),
        T = n(21);

    function M(t, e) {
      return function (n) {
        return n.lift(new F(t, e));
      };
    }

    var F = function () {
      function t(t, e) {
        this.compare = t, this.keySelector = e;
      }

      return t.prototype.call = function (t, e) {
        return e.subscribe(new $(t, this.compare, this.keySelector));
      }, t;
    }(),
        $ = function (t) {
      function e(e, n, r) {
        var i = t.call(this, e) || this;
        return i.keySelector = r, i.hasKey = !1, "function" == typeof n && (i.compare = n), i;
      }

      return h.a(e, t), e.prototype.compare = function (t, e) {
        return t === e;
      }, e.prototype._next = function (t) {
        var e;

        try {
          var n = this.keySelector;
          e = n ? n(t) : t;
        } catch (t) {
          return this.destination.error(t);
        }

        var r = !1;
        if (this.hasKey) try {
          r = (0, this.compare)(this.key, e);
        } catch (t) {
          return this.destination.error(t);
        } else this.hasKey = !0;
        r || (this.key = e, this.destination.next(t));
      }, e;
    }(p.a),
        q = n(17),
        z = n.n(q),
        R = n(19),
        U = function () {
      function t(e, n, r) {
        u()(this, t), this.events = n, r && r();
      }

      return l()(t, [{
        key: "databaseInitialize",
        value: function value(t) {
          t && t();
        }
      }, {
        key: "getLastKnownEvent",
        value: function value() {
          return {
            firstKnownBlock: 0,
            lastKnownBlock: 0
          };
        }
      }, {
        key: "getEventsFor",
        value: function value(t) {
          return [];
        }
      }, {
        key: "eventExists",
        value: function value(t, e) {
          return !1;
        }
      }, {
        key: "recordEvent",
        value: function value(t, e) {}
      }, {
        key: "deleteEvent",
        value: function value(t, e) {}
      }, {
        key: "deleteNewestBlocks",
        value: function value(t, e) {}
      }]), t;
    }(),
        V = n(22),
        K = n.n(V),
        J = n(23),
        W = n.n(J);

    function Y(t) {
      return /^(0x)?[0-9a-fA-F]{40}$/i.test(t);
    }

    function H(t) {
      return new Promise(function (e) {
        return setTimeout(e, t);
      });
    }

    var G = n(24),
        X = n.n(G),
        Q = n(25),
        Z = n(9),
        tt = n.n(Z),
        et = n(34),
        nt = n(13),
        rt = n.n(nt),
        it = function () {
      function t(e) {
        u()(this, t), this.pollExecution = [], this.web3 = e;
      }

      var e, n;
      return l()(t, [{
        key: "poll",
        value: (n = s()(i.a.mark(function t(e, n, r) {
          var o;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, n();

                case 2:
                  if (o = t.sent, this.pollExecution[e] && !o) {
                    t.next = 5;
                    break;
                  }

                  return t.abrupt("return");

                case 5:
                  if (!r) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 8, H(1e3 * r);

                case 8:
                  return t.next = 10, this.poll(e, n, r);

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return n.apply(this, arguments);
        })
      }, {
        key: "scan",
        value: (e = s()(i.a.mark(function t(e, n, r, o) {
          var a,
              u,
              c,
              l,
              h,
              f,
              p = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return a = this.pollExecution.push(!0) - 1, u = 5e5, t.next = 4, this.web3.getBlockNumber();

                case 4:
                  return c = t.sent, l = 0, o.toBlock && "latest" !== o.toBlock && (l = o.toBlock), h = l && l < c, f = l > 0 ? Math.min(l, r) : r, r > 0 && o.fromBlock >= 0 && (e(o, f), r += 1), r = Math.max(r, o.fromBlock || 0), t.next = 13, this.poll(a, s()(i.a.mark(function t() {
                    var e, o, s;
                    return i.a.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            return t.prev = 0, e = Math.min(r + u, c), o = h ? Math.min(e, l) : e, t.t0 = Math, t.next = 6, p.web3.getBlockNumber();

                          case 6:
                            if (t.t1 = t.sent, t.t2 = o, !((s = t.t0.min.call(t.t0, t.t1, t.t2)) >= r)) {
                              t.next = 13;
                              break;
                            }

                            return t.next = 12, n(r, s, h ? l : null);

                          case 12:
                            r = s + 1;

                          case 13:
                            t.next = 18;
                            break;

                          case 15:
                            t.prev = 15, t.t3 = t.catch(0), console.log(t.t3.toString());

                          case 18:
                            return t.abrupt("return", h && r >= (l || 0) || r > Math.max(c, h && l || 0));

                          case 19:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t, null, [[0, 15]]);
                  })));

                case 13:
                  if (!h) {
                    t.next = 15;
                    break;
                  }

                  return t.abrupt("return");

                case 15:
                  return t.next = 17, this.poll(a, s()(i.a.mark(function t() {
                    var e;
                    return i.a.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            return t.prev = 0, t.next = 3, p.web3.getBlockNumber();

                          case 3:
                            if (!((e = t.sent) >= r)) {
                              t.next = 8;
                              break;
                            }

                            return t.next = 7, n(r, e, l || 0);

                          case 7:
                            r = e + 1;

                          case 8:
                            t.next = 13;
                            break;

                          case 10:
                            t.prev = 10, t.t0 = t.catch(0), console.log(t.t0.toString());

                          case 13:
                            return t.abrupt("return", "latest" !== o.toBlock && r > Math.max(c, l || 0));

                          case 14:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t, null, [[0, 10]]);
                  })), 1);

                case 17:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, n, r, i) {
          return e.apply(this, arguments);
        })
      }, {
        key: "close",
        value: function value() {
          this.pollExecution = Array(this.pollExecution.length).fill(!1);
        }
      }]), t;
    }(),
        ot = function () {
      function t(e) {
        u()(this, t), this.web3 = e, this.subscriptions = [];
      }

      var e;
      return l()(t, [{
        key: "scan",
        value: (e = s()(i.a.mark(function t(e, n, r, o, s, a) {
          var u, c, l, h, f, p, d;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.web3.getBlockNumber();

                case 2:
                  if (u = t.sent, c = 0, a.toBlock && "latest" !== a.toBlock && (c = a.toBlock), l = c && c < u ? c : null, !(0 == o || o > 0 && o <= a.fromBlock)) {
                    t.next = 24;
                    break;
                  }

                  if ("latest" !== a.toBlock) {
                    t.next = 14;
                    break;
                  }

                  return e(a, s), h = Object.assign({}, a, {
                    fromBlock: a.fromBlock > s ? a.fromBlock : s + 1
                  }), t.abrupt("return", r(this.subscriptions, h));

                case 14:
                  if (!(a.toBlock <= s)) {
                    t.next = 18;
                    break;
                  }

                  e(a, a.toBlock), t.next = 22;
                  break;

                case 18:
                  return e(a, s), f = a.fromBlock > s ? a.fromBlock : s + 1, t.next = 22, n(f, a.toBlock, l);

                case 22:
                  t.next = 41;
                  break;

                case 24:
                  if (!(o > 0)) {
                    t.next = 41;
                    break;
                  }

                  return p = o > a.fromBlock ? a.fromBlock : 0, t.next = 28, n(p, o - 1, l);

                case 28:
                  if ("latest" !== a.toBlock) {
                    t.next = 34;
                    break;
                  }

                  return e(a, s, o), d = Object.assign({}, a, {
                    fromBlock: s + 1
                  }), t.abrupt("return", r(this.subscriptions, d));

                case 34:
                  if (!(a.toBlock <= s)) {
                    t.next = 38;
                    break;
                  }

                  e(a, a.toBlock), t.next = 41;
                  break;

                case 38:
                  return e(a, s), t.next = 41, n(s + 1, a.toBlock, l);

                case 41:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, n, r, i, o, s) {
          return e.apply(this, arguments);
        })
      }, {
        key: "close",
        value: function value() {
          this.subscriptions.forEach(function (t) {
            return t.unsubscribe();
          });
        }
      }]), t;
    }();

    function st(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function at(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? st(n, !0).forEach(function (e) {
          tt()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : st(n).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    var ut = function () {
      function t(e, n, r, o) {
        var a = this;
        u()(this, t), tt()(this, "getPastEvents", function (t, e, n, r) {
          return function () {
            var o = s()(i.a.mark(function o(s, u, c) {
              var l, h;
              return i.a.wrap(function (i) {
                for (;;) {
                  switch (i.prev = i.next) {
                    case 0:
                      return i.next = 2, e.getPastEvents(n, at({}, r, {
                        fromBlock: s,
                        toBlock: u
                      }));

                    case 2:
                      l = i.sent, h = a.callbackFactory(r, t), l.forEach(function (t) {
                        return h(null, t);
                      }), c && u === c && a.events.emit(t);

                    case 6:
                    case "end":
                      return i.stop();
                  }
                }
              }, o);
            }));
            return function (t, e, n) {
              return o.apply(this, arguments);
            };
          }();
        }), tt()(this, "serveDBEvents", function (t) {
          return function (e, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                i = a.callbackFactory(e, t),
                o = a.db.getEventsFor(t).filter(function (t) {
              return t.blockNumber >= (r || e.fromBlock) && t.blockNumber <= n;
            });
            o.forEach(function (t) {
              i(null, t);
            });
          };
        }), tt()(this, "subscribeToEvent", function (t, e, n) {
          return function (r, i) {
            var o = a.callbackFactory(i, t),
                s = e.events[n](i, o);
            return r.push(s), s;
          };
        }), tt()(this, "callbackFactory", function (t, e) {
          return function (n, r) {
            if (n) console.error(n);else {
              if (t) {
                var i = [];

                for (var o in t.filter) {
                  Object.keys(r.returnValues).indexOf(o) >= 0 && i.push(o);
                }

                for (var s = 0, u = i; s < u.length; s++) {
                  var c = u[s];
                  if (t.filter[c] !== r.returnValues[c]) return;
                }
              }

              a.events.emit(e, r);
            }
          };
        }), this.events = n, this.web3 = e, this.db = r, this.isWebsocketProvider = o, this.eventScanner = o ? new ot(e) : new it(e);
      }

      return l()(t, [{
        key: "track",
        value: function value(t, e, n, r, o) {
          var a = this,
              u = rt()(Object.assign({
            address: t.options.address,
            networkId: o
          }, n || {}));
          this.db.deleteNewestBlocks(u, r);
          var c = Object.assign({
            fromBlock: 0,
            toBlock: "latest"
          }, n || {}),
              l = this.db.getLastKnownEvent(u),
              h = this.db.getFirstKnownEvent(u),
              f = new L();
          Object(et.a)(this.events, u).subscribe(function (t) {
            if (t) {
              var n = rt()({
                eventName: e,
                blockNumber: t.blockNumber,
                transactionIndex: t.transactionIndex,
                logIndex: t.logIndex
              }),
                  r = {
                id: n,
                returnValues: at({}, t.returnValues),
                blockNumber: t.blockNumber,
                transactionIndex: t.transactionIndex,
                logIndex: t.logIndex,
                removed: t.removed
              };
              f.next(at({
                blockNumber: t.blockNumber
              }, t.returnValues)), t.removed ? a.db.deleteEvent(u, n) : a.db.eventExists(u, r.id) || (a.db.recordEvent(u, r), a.events.emit("updateDB"));
            } else f.complete();
          });
          var p = this.serveDBEvents(u),
              d = this.getPastEvents(u, t, e, n);

          if (this.isWebsocketProvider) {
            var y = this.subscribeToEvent(u, t, e),
                v = this.eventScanner.scan(p, d, y, h, l, c),
                b = f.subscribe;

            f.subscribe = function () {
              var t = s()(i.a.mark(function t(e, n, r) {
                var o;
                return i.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        return (o = b.apply(f, [e, n, r])).add(function () {
                          v.then(function (t) {
                            t && t.unsubscribe();
                          });
                        }), t.abrupt("return", o);

                      case 3:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t);
              }));
              return function (e, n, r) {
                return t.apply(this, arguments);
              };
            }();
          } else this.eventScanner.scan(p, d, l, c);

          return f;
        }
      }, {
        key: "close",
        value: function value() {
          this.eventScanner.close();
        }
      }]), t;
    }(),
        ct = function () {
      function t(e, n, r) {
        var i = this;
        u()(this, t), tt()(this, "_parseEventCBFactory", function (t, e) {
          return function (n, r) {
            if (n) throw new Error(n);

            if (t) {
              if (t.address && r.address.toLowerCase() !== t.address.toLowerCase()) return;

              if (t.topics) {
                var o = !1;
                if (t.topics.forEach(function (t, e) {
                  null == t || r.topics[e] && r.topics[e].toLowerCase() === t.toLowerCase() || (o = !0);
                }), o) return;
              }
            }

            i.events.emit(e, r);
          };
        }), this.events = n, this.web3 = e, this.db = r, this.subscriptions = [];
      }

      return l()(t, [{
        key: "track",
        value: function value(t, e, n, r) {
          var i = this,
              o = "logs-" + rt()(Object.assign({
            networkId: r
          }, t || {})),
              s = Object.assign({
            fromBlock: 0,
            toBlock: "latest"
          }, t || {});
          this.db.deleteNewestBlocks(o, n);
          var a = this.db.getLastKnownEvent(o),
              u = new L();
          Object(et.a)(this.events, o).subscribe(function (t) {
            if (t) {
              var n = rt()({
                eventName: o,
                blockNumber: t.blockNumber,
                transactionIndex: t.transactionIndex,
                logIndex: t.logIndex
              }),
                  r = {
                id: rt()({
                  eventName: o,
                  blockNumber: t.blockNumber,
                  transactionIndex: t.transactionIndex,
                  logIndex: t.logIndex
                }),
                data: t.data,
                address: t.address,
                topics: t.topics,
                removed: t.removed
              },
                  s = {
                blockNumber: t.blockNumber,
                data: t.data,
                address: t.address,
                topics: t.topics
              };
              e && (r.returnValues = web3.eth.abi.decodeLog(e, t.data, t.topics.slice(1)), s.returnValues = r.returnValues), u.next(s), t.removed ? i.db.deleteEvent(o, n) : i.db.eventExists(o, r.id) || (i.db.recordEvent(o, r), i.events.emit("updateDB"));
            }
          });

          var c = this._retrieveEvents(o, a.firstKnownBlock, a.lastKnownBlock, s),
              l = u.subscribe;

          return u.subscribe = function (t, e, n) {
            var r = l.apply(u, [t, e, n]);
            return r.add(function () {
              c && c.unsubscribe();
            }), r;
          }, u;
        }
      }, {
        key: "_retrieveEvents",
        value: function value(t, e, n, r) {
          if (0 == e || e > 0 && e <= r.fromBlock) {
            if ("latest" === r.toBlock) {
              this._serveDBEvents(t, r.fromBlock, n, r);

              var i = Object.assign({}, r, {
                fromBlock: r.fromBlock > n ? r.fromBlock : n + 1
              });
              return this._subscribeToEvent(i, t);
            }

            if (r.toBlock <= n) this._serveDBEvents(t, r.fromBlock, r.toBlock, r);else {
              this._serveDBEvents(t, r.fromBlock, n, r);

              var o = Object.assign({}, r, {
                fromBlock: r.fromBlock > n ? r.fromBlock : n + 1
              });

              this._getPastEvents(o, t);
            }
          } else if (e > 0) {
            var s = e > r.fromBlock ? r.fromBlock : 0,
                a = Object.assign({}, r, {
              fromBlock: s,
              toBlock: e - 1
            });

            if (this._getPastEvents(a, t), "latest" === r.toBlock) {
              this._serveDBEvents(t, e, n, r);

              var u = Object.assign({}, r, {
                fromBlock: n + 1
              });
              return this._subscribeToEvent(u, t);
            }

            if (r.toBlock <= n) this._serveDBEvents(t, r.fromBlock, r.toBlock, r);else {
              this._serveDBEvents(t, r.fromBlock, n, r);

              var c = Object.assign({}, r, {
                fromBlock: n + 1,
                toBlock: r.toBlock
              });

              this._getPastEvents(c, t);
            }
          }
        }
      }, {
        key: "_serveDBEvents",
        value: function value(t, e, n, r) {
          var i = this._parseEventCBFactory(r, t);

          this.db.getEventsFor(t).filter(function (t) {
            return t.blockNumber >= e && t.blockNumber <= n;
          }).forEach(function (t) {
            i(null, t);
          });
        }
      }, {
        key: "_getPastEvents",
        value: function value(t, e) {
          var n = this._parseEventCBFactory(t, e);

          this.web3.getPastLogs(options, function (t, e) {
            if (t) throw new Error(t);
            e.forEach(function (t) {
              n(null, t);
            });
          });
        }
      }, {
        key: "_subscribeToEvent",
        value: function value(t, e) {
          var n = this.web3.subscribe("logs", t, this._parseEventCBFactory(t, e));
          return this.subscriptions.push(n), n;
        }
      }, {
        key: "close",
        value: function value() {
          this.subscriptions.forEach(function (t) {
            t.unsubscribe();
          });
        }
      }]), t;
    }(),
        lt = function () {
      function t(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        u()(this, t), e.on && console.warn("subspace: the current provider doesn't support subscriptions. Falling back to http polling"), this.events = new K.a(), this.web3 = new W.a(e), this.options = {}, this.options.refreshLastNBlocks = n.refreshLastNBlocks || 12, this.options.callInterval = n.callInterval || 0, this.options.dbFilename = n.dbFilename || "subspace.db", this.latestBlockNumber = void 0, this.disableDatabase = n.disableDatabase, this.networkId = void 0, this.isWebsocketProvider = !n.disableSubscriptions && !!e.on, this.newBlocksSubscription = null, this.intervalTracker = null, this.callables = [];
      }

      return l()(t, [{
        key: "init",
        value: function value() {
          var t = this;
          return new Promise(function (e, n) {
            !0 === t.disableDatabase ? t._db = new U("", t.events) : t._db = new R.a(t.options.dbFilename, t.events), t.eventSyncer = new ut(t.web3, t.events, t._db, t.isWebsocketProvider), t.logSyncer = new ct(t.web3, t.events, t._db), t.web3.net.getId().then(function (e) {
              t.networkId = e;
            }), t.web3.getBlock("latest").then(function (n) {
              t.latestBlockNumber = n.number, t.isWebsocketProvider ? t._initNewBlocksSubscription() : (t.options.callInterval = t.options.callInterval || 1e3, t._initCallInterval()), e();
            });
          });
        }
      }, {
        key: "contract",
        value: function value(t) {
          var e = this;
          if (!t) throw new Error("please pass a contract instance to Subspace.contract()");
          var n = t.options && t.options.address || t.address || t.deployedAddress,
              r = t.options && t.options.jsonInterface || t.abi || t.abiDefinition,
              o = t.options && t.options.from || t.from || t.defaultAddress || this.web3.defaultAccount,
              a = t.options && t.options.gas || t.gas || t.gas || "800000",
              u = new this.web3.Contract(r, {
            from: o,
            gas: a
          });
          return u.options.address = n, u.options.from = o, o || setTimeout(s()(i.a.mark(function t() {
            var n;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, e.web3.getAccounts();

                  case 2:
                    n = t.sent, u.options.from = n[0];

                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          })), 100), u.trackEvent = function (t, n) {
            return e.trackEvent(u, t, n);
          }, Object.keys(u.events).forEach(function (t) {
            u.options.jsonInterface.find(function (e) {
              return "event" === e.type && e.name == t;
            }) && (u.events[t].track = function (n) {
              return e.trackEvent(u, t, n);
            });
          }), u.trackProperty = function (t, n, r) {
            return e.trackProperty(u, t, n, r);
          }, Object.keys(u.methods).forEach(function (t) {
            var n = u.methods[t],
                r = e;

            u.methods[t] = function () {
              var e = n.apply(null, arguments);
              return e.track = function (n) {
                return r.trackProperty(u, t, e.arguments, n);
              }, e;
            };
          }), u.trackBalance = function (t) {
            return e.trackBalance(u.options.address, t);
          }, u;
        }
      }, {
        key: "trackEvent",
        value: function value(t, e, n) {
          var r = this.latestBlockNumber - this.options.refreshLastNBlocks,
              i = this.eventSyncer.track(t, e, n, r, this.networkId);
          return i.map = function (t) {
            return i.pipe(Object(T.a)(function (e) {
              if ("string" == typeof t) return e[t];

              if (Array.isArray(t)) {
                var n = {};
                return t.forEach(function (t) {
                  n[t] = e[t];
                }), n;
              }
            }));
          }, i;
        }
      }, {
        key: "clearDB",
        value: function value(t) {}
      }, {
        key: "trackLogs",
        value: function value(t, e) {
          return this.isWebsocketProvider || console.warn("This method only works with websockets"), this.logSyncer.track(t, e, this.latestBlockNumber - this.options.refreshLastNBlocks, this.networkId);
        }
      }, {
        key: "_initNewBlocksSubscription",
        value: function value() {
          var t = this;
          null == this.newBlocksSubscription && 0 === this.options.callInterval && (this.newBlocksSubscription = this.web3.subscribe("newBlockHeaders", function (e, n) {
            e ? console.error(e) : t.callables.forEach(function (t) {
              t();
            });
          }));
        }
      }, {
        key: "_initCallInterval",
        value: function value() {
          var t = this;
          null == this.intervalTracker && 0 !== this.options.callInterval && (this.intervalTracker = setInterval(function () {
            t.callables.forEach(function (t) {
              t();
            });
          }, this.options.callInterval));
        }
      }, {
        key: "trackProperty",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              i = new L();
          Array.isArray(n) || (n = [n]);

          var o = t.methods[e].apply(t.methods[e], n),
              s = function s() {
            o.call.apply(o.call, [r, function (t, e) {
              t ? i.error(t) : i.next(e);
            }]);
          };

          s(), this.callables.push(s);
          var a = i.pipe(M(function (t, e) {
            return z()(t, e);
          }));
          return a.map = function (t) {
            return a.pipe(Object(T.a)(function (e) {
              if ("string" == typeof t) return e[t];

              if (Array.isArray(t)) {
                var n = {};
                return t.forEach(function (t) {
                  n[t] = e[t];
                }), n;
              }
            }));
          }, a;
        }
      }, {
        key: "trackBalance",
        value: function value(t, e) {
          var n,
              r = this,
              i = new L();
          if (!Y(t)) throw "invalid address";
          if (e && !Y(e)) throw "invalid ERC20 contract address";
          return n = e ? function () {
            var n = r.web3.call,
                o = "0x70a08231000000000000000000000000" + X()(t);
            n.apply(n, [{
              to: e,
              data: o
            }, function (t, e) {
              t ? i.error(t) : i.next(Object(Q.hexToDec)(e));
            }]);
          } : function () {
            var e = r.web3.getBalance;
            e.apply(e, [t, function (t, e) {
              t ? i.error(t) : i.next(e);
            }]);
          }, setTimeout(function () {
            n();
          }, 500), this.callables.push(n), i.pipe(M(function (t, e) {
            return z()(t, e);
          }));
        }
      }, {
        key: "close",
        value: function value() {
          clearInterval(this.intervalTracker), this.newBlocksSubscription && this.newBlocksSubscription.unsubscribe(), this.eventSyncer.close(), this.intervalTracker = null, this.callables = [];
        }
      }]), t;
    }(),
        ht = n(26);

    function ft(t, e) {
      var n = !1;
      return arguments.length >= 2 && (n = !0), function (r) {
        return r.lift(new pt(t, e, n));
      };
    }

    var pt = function () {
      function t(t, e, n) {
        void 0 === n && (n = !1), this.accumulator = t, this.seed = e, this.hasSeed = n;
      }

      return t.prototype.call = function (t, e) {
        return e.subscribe(new dt(t, this.accumulator, this.seed, this.hasSeed));
      }, t;
    }(),
        dt = function (t) {
      function e(e, n, r, i) {
        var o = t.call(this, e) || this;
        return o.accumulator = n, o._seed = r, o.hasSeed = i, o.index = 0, o;
      }

      return h.a(e, t), Object.defineProperty(e.prototype, "seed", {
        get: function get() {
          return this._seed;
        },
        set: function set(t) {
          this.hasSeed = !0, this._seed = t;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._next = function (t) {
        if (this.hasSeed) return this._tryNext(t);
        this.seed = t, this.destination.next(t);
      }, e.prototype._tryNext = function (t) {
        var e,
            n = this.index++;

        try {
          e = this.accumulator(this.seed, t, n);
        } catch (t) {
          this.destination.error(t);
        }

        this.seed = e, this.destination.next(e);
      }, e;
    }(p.a);

    function yt() {
      var t = Object.values(arguments);
      return Object(ht.a)(Object(T.a)(function (e) {
        var n = {};
        return t.forEach(function (t) {
          n[t] = e[t];
        }), n;
      }));
    }

    function vt(t) {
      return Object(ht.a)(ft(function (e, n) {
        var r;
        return r = "string" == typeof t || t instanceof String ? n[t] : "function" == typeof t ? t(n) : n, {
          sum: e.sum + r,
          count: e.count + 1
        };
      }, {
        sum: 0,
        count: 0
      }), Object(T.a)(function (t) {
        return t.sum / t.count;
      }));
    }

    function bt(t) {
      return Object(ht.a)(ft(function (e, n) {
        var r;
        return (r = "string" == typeof t || t instanceof String ? n[t] : "function" == typeof t ? t(n) : n) > e ? r : e;
      }));
    }

    function gt(t) {
      return Object(ht.a)(ft(function (e, n) {
        var r;
        return (r = "string" == typeof t || t instanceof String ? n[t] : "function" == typeof t ? t(n) : n) < e ? r : e;
      }));
    }

    function mt(t) {
      return Object(ht.a)(ft(function (e, n) {
        var r = n;
        return e.push(r), e.length > t && e.shift(), e;
      }, []));
    }

    n.d(e, "default", function () {
      return lt;
    }), n.d(e, "$takeProps", function () {
      return yt;
    }), n.d(e, "$average", function () {
      return vt;
    }), n.d(e, "$max", function () {
      return bt;
    }), n.d(e, "$min", function () {
      return gt;
    }), n.d(e, "$latest", function () {
      return mt;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return a;
    });
    var r = n(3),
        i = n(16),
        o = n(10),
        s = n(21);

    function a(t, e, n, u) {
      return Object(o.a)(n) && (u = n, n = void 0), u ? a(t, e, n).pipe(Object(s.a)(function (t) {
        return Object(i.a)(t) ? u.apply(void 0, t) : u(t);
      })) : new r.a(function (r) {
        !function t(e, n, r, i, o) {
          var s;

          if (function (t) {
            return t && "function" == typeof t.addEventListener && "function" == typeof t.removeEventListener;
          }(e)) {
            var a = e;
            e.addEventListener(n, r, o), s = function s() {
              return a.removeEventListener(n, r, o);
            };
          } else if (function (t) {
            return t && "function" == typeof t.on && "function" == typeof t.off;
          }(e)) {
            var u = e;
            e.on(n, r), s = function s() {
              return u.off(n, r);
            };
          } else if (function (t) {
            return t && "function" == typeof t.addListener && "function" == typeof t.removeListener;
          }(e)) {
            var c = e;
            e.addListener(n, r), s = function s() {
              return c.removeListener(n, r);
            };
          } else {
            if (!e || !e.length) throw new TypeError("Invalid event target");

            for (var l = 0, h = e.length; l < h; l++) {
              t(e[l], n, r, i, o);
            }
          }

          i.add(s);
        }(t, e, function (t) {
          arguments.length > 1 ? r.next(Array.prototype.slice.call(arguments)) : r.next(t);
        }, r, n);
      });
    }
  }]);
});